/**
 * @license
 * @qwik.dev/core 2.0.0-beta.35-dev+9adcc2e
 * Copyright QwikDev. All Rights Reserved.
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/QwikDev/qwik/blob/main/LICENSE
 */
import { isServer as ue, isBrowser as ce } from "@qwik.dev/core/build";

export { isBrowser, isServer } from "@qwik.dev/core/build";

import { p as le } from "@qwik.dev/core/preloader";

const fe = !1;

const he = (t, n, ...e) => {
    const s = n instanceof Error ? n : Error(n);
    console.error("%cQWIK ERROR", "", s.message, ...e, s.stack);
    t && setTimeout(() => {
        throw s;
    }, 0);
    return s;
};

const de = t => {
    const n = Object.getPrototypeOf(t);
    return n === Object.prototype || n === Array.prototype || n === null;
};

const pe = t => typeof t === "object" && t !== null;

const $e = t => Array.isArray(t);

const ye = t => typeof t === "string";

const me = t => typeof t === "function";

const we = (t, n = []) => {
    const e = (t => `Code(Q${t}) https://qwikdev-build-v2.qwik-8nx.pages.dev/docs/errors/#q${t}`)(t, ...n);
    return ((t, ...n) => {
        const e = he(false, t, ...n);
        debugger;
        return e;
    })(e, ...n);
};

const ve = "2.0.0-beta.35-dev+9adcc2e";

const be = globalThis.__qwik__ ||= {};

import.meta.hot && import.meta.hot.dispose(() => {
    globalThis.__qwik__ = void 0;
});

let ge;

if (ue) {
    const t = be.version;
    t ? t !== ve && we(30, [ t, ve ]) : be.version = ve;
    ge = be.singletons ||= {};
} else {
    ge = be[ve] ||= {};
}

const _e = (t, n) => {
    t in ge || (ge[t] = n());
    return ge[t];
};

const Se = "<sync>";

const ke = t => typeof t === "function" && typeof t.getSymbol === "function";

const Ca = t => {
    const n = t.lastIndexOf("_") + 1;
    return t.slice(n);
};

const Ee = "q:renderFn";

const xe = "q:targetEl";

const qe = "⚡️";

const Te = "q:slot";

const Pe = "q:s";

const Re = "q:style";

const Ae = "style[q\\:style]";

const Ne = Ae + ",style[q\\:sstyle]";

const Me = "q:sstyle";

const Ie = "q:ctx";

const Ce = "q:brefs";

const je = (t, n) => t["qFuncs_" + n] || [];

const Oe = "q:base";

const Fe = "q:container-island";

const Le = "/" + Fe;

const De = "q:ignore";

const Ve = "/" + De;

const We = "q:container";

const Ue = "/" + We;

const Xe = "q:template";

const ze = "http://www.w3.org/1999/xhtml";

const Be = "http://www.w3.org/2000/svg";

const He = "http://www.w3.org/1998/Math/MathML";

const Je = "qRender";

const Ye = "q:key";

const Ge = "q:props";

const Ke = "q:seq";

const Ze = "q:seqIdx";

const tr = "q:p";

const nr = "q:ps";

const rr = ":on";

const sr = ":onIdx";

const ir = ":onFlags";

const or = "q:cursorBoundary";

const lr = ":nearestCursorBoundary";

const ur = ":";

const cr = "dangerouslySetInnerHTML";

const ja = ue ? _e("regSymbols", () => new Map) : void 0;

const ar = () => ({
    isServer: ue,
    importSymbol(t, n, e) {
        if (ue) {
            const t = Ca(e);
            const n = ja.get(t);
            if (n) {
                return n;
            }
            throw we(6, [ e ]);
        }
        if (!n) {
            throw we(14, [ e ]);
        }
        if (!t) {
            throw we(13, [ n, e ]);
        }
        const s = "" + hr(t.ownerDocument, t, n);
        const o = new URL(s);
        o.hash = "";
        const r = o.href;
        return import(r).then(t => t[e]);
    },
    raf: t => new Promise(n => {
        requestAnimationFrame(() => {
            n(t());
        });
    }),
    chunkForSymbol(t, n) {
        return [ t, n ?? "_" ];
    }
});

const hr = (t, n, e) => {
    const s = t.baseURI;
    const o = new URL(n.getAttribute(Oe) ?? s, s);
    return new URL(e, o);
};

let dr = /*#__PURE__ */ ar();

const pr = t => dr = t;

const $r = () => dr;

const Oa = () => dr.isServer;

/*@__INLINE__*/ const yr = t => t.nodeType === 1;

const mr = 100;

const wr = t => !!t && typeof t == "object" && typeof t.then === "function";

const vr = (t, n, e) => {
    try {
        const s = t();
        return wr(s) ? s.then(n, e) : n(s);
    } catch (t) {
        return e(t);
    }
};

const br = (t, n) => wr(t) ? t.then(n) : n(t);

const gr = t => {
    throw t;
};

function t(t, n = gr) {
    let e = !1;
    let s;
    try {
        s = t();
        e = !0;
    } catch (t) {
        s = t;
    }
    if (!wr(s)) {
        if (e) {
            return s;
        }
        return n(s);
    }
    let o = mr;
    const r = async e => {
        for (;wr(e); ) {
            try {
                await e;
                return await t();
            } catch (t) {
                if (!wr(t)) {
                    e = t;
                    break;
                }
                if (! --o) {
                    e = Error("Exceeded max retry count in retryOnPromise");
                    break;
                }
                e = t;
            }
        }
        return n(e);
    };
    return e ? s.catch(r) : r(s);
}

const _r = Symbol();

class Sr {
    [_r]=void 0;
}

const kr = "q:type";

const Er = {
    ["V"]: "Virtual",
    ["F"]: "Fragment",
    ["S"]: "Signal",
    ["A"]: "Awaited",
    ["C"]: "Component",
    ["I"]: "InlineComponent",
    ["P"]: "Projection"
};

const xr = 124;

const qr = t => t === "foreignObject";

const Tr = t => t === "svg" || qr(t);

const Pr = t => t === "math";

function n(t, e, s, o = !1) {
    const r = t.ownerDocument.createElementNS(s, e);
    for (let n = 0; n < t.attributes.length; n++) {
        const e = t.attributes[n];
        e.name !== ur && r.setAttribute(e.name, e.value);
    }
    if (o) {
        for (let e = 0; e < t.childNodes.length; e++) {
            const i = t.childNodes[e];
            const c = i.nodeType;
            c === 3 ? r.appendChild(i.cloneNode()) : c === 1 && r.appendChild(n(i, i.localName, s, o));
        }
    }
    return r;
}

const Rr = {
    elementNamespace: ze,
    elementNamespaceFlag: 0
};

function e(t, n) {
    const e = !t || !!Xo(t) && (t => {
        const n = t.flags;
        return (n & 1536) === 0;
    })(t);
    const s = !e && qr(Xo(t));
    let o = ze;
    let r = 0;
    const i = typeof n === "string" || ao(n);
    if (i && function c(t) {
        if (typeof t === "string") {
            return Tr(t);
        }
        if (ao(t)) {
            return Tr(Xo(t)) || (t.flags & 512) !== 0;
        }
        return !1;
    }(n)) {
        o = Be;
        r = 512;
    } else if (i && function l(t) {
        if (typeof t === "string") {
            return Pr(t);
        }
        if (ao(t)) {
            return Pr(Xo(t)) || (t.flags & 1024) !== 0;
        }
        return !1;
    }(n)) {
        o = He;
        r = 1024;
    } else if (t && !s && !e) {
        const n = (t.flags & 512) !== 0;
        const e = (t.flags & 1024) !== 0;
        o = n ? Be : e ? He : ze;
        r = t.flags & 1536;
    }
    Rr.elementNamespace = o;
    Rr.elementNamespaceFlag = r;
    return Rr;
}

const Ar = t => t.charCodeAt(0) === 113 && t.charCodeAt(1) === 45 && (t.charCodeAt(3) === 58 || t.charCodeAt(3) === 112 && t.charCodeAt(4) === 58);

function r(t, n = !1) {
    if (t.endsWith("$")) {
        const [e, s] = function o(t, n = !1) {
            let e;
            let s = -1;
            if (t.startsWith("on")) {
                e = n ? "q-ep:" : "q-e:";
                s = 2;
            } else if (t.startsWith("window:on")) {
                e = n ? "q-wp:" : "q-w:";
                s = 9;
            } else if (t.startsWith("document:on")) {
                e = n ? "q-dp:" : "q-d:";
                s = 11;
            }
            return [ e, s ];
        }(t, n);
        if (s !== -1) {
            return e + Nr(t.slice(s, -1));
        }
    }
    return null;
}

const Nr = t => t === "DOMContentLoaded" ? "-d-o-m-content-loaded" : function n(t, e = "") {
    const s = Mr(t);
    return e + s;
}(t.charAt(0) === "-" ? t.slice(1) : t.toLowerCase());

const Mr = t => t.replace(/([A-Z-])/g, t => "-" + t.toLowerCase());

const Ir = t => {
    const n = t.indexOf(":");
    return [ t.slice(2, n), t.slice(n + 1) ];
};

class Cr {
    flags;
    parent;
    previousSibling;
    nextSibling;
    props;
    [_r]=void 0;
    slotParent=null;
    dirty=0;
    dirtyChildren=null;
    nextDirtyChildIndex=0;
    constructor(t, n, e, s, o) {
        this.flags = t;
        this.parent = n;
        this.previousSibling = e;
        this.nextSibling = s;
        this.props = o;
    }
    toString() {
        return Object.prototype.toString.call(this);
    }
}

class jr extends Cr {
    key;
    firstChild;
    lastChild;
    constructor(t, n, e, s, o, r, i, c) {
        super(n, e, s, o, r);
        this.key = t;
        this.firstChild = i;
        this.lastChild = c;
    }
}

class Or extends jr {
    node;
    elementName;
    constructor(t, n, e, s, o, r, i, c, l, u) {
        super(t, n, e, s, o, r, i, c);
        this.node = l;
        this.elementName = u;
    }
}

class Fr extends Cr {
    node;
    text;
    constructor(t, n, e, s, o, r, i) {
        super(t, n, e, s, o);
        this.node = r;
        this.text = i;
    }
}

const Lr = [];

const Dr = [];

function s(t, n) {
    const e = d(n).priority;
    let s = Lr.length;
    for (let t = 0; t < Lr.length; t++) {
        const n = d(Lr[t]).priority;
        if (e < n) {
            s = t;
            break;
        }
    }
    Lr.splice(s, 0, n);
    t.o++;
    t.l ||= new Promise(n => t.u = n);
}

function i() {
    for (let t = 0; t < Lr.length; t++) {
        const n = Lr[t];
        let e = !1;
        for (let t = 0; t < Dr.length; t++) {
            const s = Dr[t];
            if (hl(n, s)) {
                e = !0;
                break;
            }
        }
        if (!e) {
            return n;
        }
    }
    return null;
}

function o(t, n) {
    Dr.push(t);
    c(t, n, !0);
    n.o++;
}

function l(t, n) {
    if (!(t.flags & 256)) {
        return;
    }
    f(t, n);
    s(n, t);
}

function u(t, n, e) {
    const s = d(e);
    if (!s || s === n) {
        return;
    }
    c(e, t, !1);
    f(e, t);
    h(n, s);
    s.afterFlushTasks = null;
    s.extraPromises = null;
    s.journal = null;
    s.boundaries = null;
    s.position = null;
    s.promise = null;
}

function c(t, n, e) {
    e || (t.flags &= -257);
    const s = Lr.indexOf(t);
    if (s !== -1) {
        Lr.splice(s, 1);
        n.o--;
        return !0;
    }
    return !1;
}

function f(t, n) {
    const e = Dr.indexOf(t);
    if (e === -1) {
        return !1;
    }
    const s = Dr.length - 1;
    e !== s && (Dr[e] = Dr[s]);
    Dr.pop();
    n.o--;
    return !0;
}

const Vr = new WeakMap;

const Wr = ":nodeProps";

const Ur = ":nodeDiff";

const Xr = ":errorData";

const zr = ":signal";

function a(t, n, e) {
    n.position = e;
    e && rn(e) && function s(t, n, e) {
        c(e, t);
        const s = d(e);
        (function o(t, n) {
            if (n === t) {
                return;
            }
            const e = n.afterFlushTasks;
            if (e && e.length > 0) {
                const n = t.afterFlushTasks;
                n ? n.push(...e) : t.afterFlushTasks = e;
            }
            const s = n.extraPromises;
            if (s && s.length > 0) {
                const n = t.extraPromises;
                n ? n.push(...s) : t.extraPromises = s;
            }
            h(t, n);
        })(n, s);
    }(t, n, e);
}

function h(t, n) {
    if (n === t) {
        return;
    }
    const e = n.journal;
    if (e && e.length > 0) {
        const n = t.journal;
        n ? n.push(...e) : t.journal = e;
    }
    const s = n.boundaries;
    if (__EXPERIMENTAL__.suspense && s && s.length > 0) {
        const n = t.boundaries ||= [];
        for (let t = 0; t < s.length; t++) {
            const e = s[t];
            n.includes(e) || n.push(e);
        }
    }
}

function d(t) {
    return Vr.get(t) ?? null;
}

const Br = Symbol();

class Hr {
    consumer;
    property;
    backRef;
    data;
    constructor(t, n, e = null, s = null) {
        this.consumer = t;
        this.property = n;
        this.backRef = e;
        this.data = s;
    }
}

const Jr = Symbol();

const Qr = Symbol();

const Yr = Symbol();

function p(t, n, e) {
    t[_r] || (ue && function s(t) {
        return "__brand__" in t && t.__brand__ === "SsrNode";
    }(t) ? t.setProp(Ce, new Map) : t[_r] = new Map);
    const o = t[_r];
    let r = o.get(n);
    if (!r) {
        r = new Hr(t, n);
        o.set(n, r);
    }
    e && (r.data = e);
    return r;
}

const Gr = (t, n) => (e, s) => {
    const o = ie();
    o.Lt = p(t, ":");
    o.m = n || void 0;
    return ee(o, () => {
        if (me(e)) {
            return e();
        }
        if (s) {
            return e[s];
        }
        if (xl(e)) {
            return e.value;
        }
        if (pe(e) && Dl(e)) {
            kn(jl(e), Yr, Cl(e), o.Lt);
            return e;
        }
        throw we(2);
    });
};

class Kr {
    Wt;
    ft=void 0;
    m=null;
    Ut=null;
    constructor(t, n) {
        this.m = t || dc()?.m || null;
        this.Wt = n;
    }
    trigger() {
        Rl(this.m, this, this.ft);
    }
    force() {
        Rl(this.m, this, this.ft);
    }
    get untrackedValue() {
        return this.Wt;
    }
    set untrackedValue(t) {
        this.Wt = t;
    }
    get value() {
        const t = this.untrackedValue;
        const n = dc();
        if (!n) {
            return t;
        }
        this.m === null && (this.m = n.m);
        const e = n.Lt;
        if (e) {
            ql(this.ft ||= new Set, e);
            Tl(e, this);
            ue && Pl(e, this.m);
        }
        return t;
    }
    set value(t) {
        if (t !== this.Wt) {
            this.Wt = t;
            Rl(this.m, this, this.ft);
        }
    }
    valueOf() {}
    toString() {
        return this.constructor.name;
    }
    toJSON() {
        return {
            value: this.Wt
        };
    }
}

class Zr extends Kr {
    Xt;
    h;
    [_r]=void 0;
    constructor(t, n, e = 17) {
        super(t || dc()?.m, Br);
        this.Xt = n;
        this.h = e;
    }
    invalidate() {
        this.h |= 1;
        const n = ie();
        n.m = this.m || void 0;
        const e = t(re.bind(this, n, this.$));
        e && e.catch(t => {
            this.m ? this.m.handleError(t, null) : console.error("Error during computation", t);
        });
    }
    get untrackedValue() {
        this.$();
        return this.Wt;
    }
    set untrackedValue(t) {
        this.Wt = t;
    }
    $() {
        if (!(this.h & 1)) {
            return;
        }
        const t = this.Xt;
        El(t);
        const n = dc();
        const e = n?.Lt;
        if (n) {
            const t = p(this, ".");
            mn(this.m, t);
            n.Lt = t;
        }
        try {
            const e = t.getFn(n)();
            if (wr(e)) {
                throw we(29, [ t.dev ? t.dev.file : "", t.lt ]);
            }
            this.h &= -2;
            super.value = e;
        } finally {
            n && (n.Lt = e);
        }
    }
}

class ts {
    zt;
    Bt=null;
    Ht=!1;
    Jt=!0;
    constructor(t, n, e) {
        this.zt = t;
        if (n !== void 0) {
            this.info = n;
            this.Qt = e;
        }
    }
    get track() {
        return this.Yt ||= Gr(this.zt, this.zt.m);
    }
    get abortSignal() {
        return (this.Gt ||= new AbortController).signal;
    }
    cache() {}
    get previous() {
        const t = this.zt.Wt;
        if (t !== Br) {
            return t;
        }
    }
    cleanup(t) {
        typeof t === "function" && (this.Kt ||= []).push(t);
    }
}

class ns extends Zr {
    Zt=!1;
    tn=void 0;
    nn=null;
    [_r]=void 0;
    constructor(t, n, e = 17, s) {
        super(t, n, e);
        if (!s) {
            return;
        }
        const o = s.initial;
        if (o !== void 0) {
            const t = typeof o === "function" ? o() : o;
            this.Wt = t;
        }
        const r = s.concurrency;
        if (r !== void 0 && r >= 0 && r !== 1) {
            this.en = r;
            this.rn = [];
        }
        const i = s.timeout;
        i && (this.sn = i);
        s.eagerCleanup && (this.h |= 32);
        s.clientOnly && (this.h |= 64);
        s.allowStale === !1 && (this.h |= 128);
        const c = s.expires ?? (s.interval ? Math.abs(s.interval) : void 0);
        c && (this.expires = c);
        (s.poll === !1 || s.interval !== void 0 && s.interval < 0) && (this.h |= 256);
    }
    get untrackedValue() {
        this.$();
        if (this.nn?.Bt) {
            if (this.Wt === Br || ue) {
                throw this.nn?.Bt;
            }
            return this.Wt;
        }
        if (this.tn) {
            throw this.tn;
        }
        if (ue && this.h & 64 && this.Wt === Br) {
            throw we(35);
        }
        return this.Wt;
    }
    set untrackedValue(t) {
        this.Wt = t;
    }
    get value() {
        return super.value;
    }
    set value(t) {
        this.h &= -2;
        this.untrackedLoading = !1;
        this.untrackedError = void 0;
        this.ln = void 0;
        if (this.rn) {
            for (let t = 0; t < this.rn.length; t++) {
                this.rn[t].Jt = !1;
            }
        } else {
            this.nn && (this.nn.Jt = !1);
        }
        this.un();
        super.value = t;
        this.cn();
    }
    get loading() {
        const t = this.untrackedLoading;
        const n = dc();
        if (n && (this.m ||= n.m || null)) {
            const t = n.Lt;
            if (t) {
                ql(this.yt ||= new Set, t);
                Tl(t, this);
                Pl(t, this.m);
            }
        }
        return t;
    }
    set untrackedLoading(t) {
        if (t !== this.Zt) {
            this.Zt = t;
            Rl(this.m, this, this.yt);
        }
    }
    get untrackedLoading() {
        this.$();
        if (ue && this.nn?.Bt) {
            throw this.nn?.Bt;
        }
        return this.Zt;
    }
    get error() {
        const t = this.untrackedError;
        const n = dc();
        if (n && (this.m ||= n.m || null)) {
            const t = n.Lt;
            if (t) {
                ql(this.wt ||= new Set, t);
                Tl(t, this);
                Pl(t, this.m);
            }
        }
        return t;
    }
    set untrackedError(t) {
        if (t !== this.tn) {
            this.tn = t;
            Rl(this.m, this, this.wt);
        }
    }
    get untrackedError() {
        return this.tn;
    }
    get expires() {
        return this.Tt || 0;
    }
    set expires(t) {
        this.un();
        this.Tt = t;
        this.Tt && this.fn() && this.cn();
    }
    get poll() {
        return !(this.h & 256);
    }
    set poll(t) {
        t ? this.h &= -257 : this.h |= 256;
        if (this.Tt && this.fn()) {
            this.un();
            this.cn();
        }
    }
    get interval() {
        const t = this.Tt || 0;
        return this.h & 256 ? -t : t;
    }
    set interval(t) {
        t < 0 ? this.h |= 256 : this.h &= -257;
        this.expires = Math.abs(t);
    }
    async invalidate(t) {
        if (arguments.length > 0) {
            this.ln = t;
            this.Qt = this.Qt === void 0 ? 1 : this.Qt + 1;
        }
        this.an(!0, this.h & 128);
    }
    an(t, n) {
        this.h |= 1;
        this.un();
        n && (this.Wt = Br);
        t && (this.ft?.size || this.yt?.size || this.wt?.size) && Promise.resolve().then(() => this.$());
    }
    abort(t) {
        this.nn && this.hn(this.nn, t);
    }
    vt() {
        if (!(this.h & 32) || this.fn()) {
            return;
        }
        if (!ce) {
            return;
        }
        setTimeout(() => {
            this.fn() || this.abort();
        });
    }
    async promise() {
        this.$();
        for (;this.nn?.Bt; ) {
            await (this.nn?.Bt);
        }
    }
    $() {
        if (!(this.h & 1)) {
            return;
        }
        if (ue && this.h & 64) {
            this.Zt = !0;
            this.m?.serializationCtx.Pt.add(this);
            return;
        }
        this.un();
        this.h &= -2;
        const t = this.nn;
        t && this.hn(t);
        const n = this.en === 0 ? Infinity : this.en ?? 1;
        if (this.rn ? this.rn.length >= n : t?.Bt) {
            this.h |= 1;
            return;
        }
        const e = this.Qt;
        const s = new ts(this, this.ln, e);
        this.nn = s;
        this.rn && this.rn.push(s);
        s.Bt = this.dn(s);
    }
    async dn(n) {
        let e = this.Xt.resolved;
        if (!e) {
            this.untrackedLoading = !0;
            e = await this.Xt.resolve();
            if (n.Gt?.signal.aborted) {
                n.Bt = null;
                return;
            }
        }
        try {
            this.sn && (this.pn = setTimeout(() => {
                const t = Error(`timeout ${this.sn}ms`);
                this.$n(n, t);
                n.Gt?.abort(t);
            }, this.sn));
            const s = t(e.bind(null, n));
            let o;
            if (wr(s)) {
                this.untrackedLoading = !0;
                o = await s;
            } else {
                o = s;
            }
            n.Bt = null;
            if (n.Jt) {
                const t = this.rn;
                if (t) {
                    let e = !1;
                    for (let s = t.length - 1; s >= 0; s--) {
                        t[s] === n ? e = !0 : e && (t[s].Jt = !1);
                    }
                }
                this.untrackedError = void 0;
                super.value = o;
            }
        } catch (t) {
            n.Bt = null;
            this.$n(n, t);
        }
        if ((() => n === this.nn)()) {
            clearTimeout(this.pn);
            n.Qt === this.Qt && (this.ln = void 0);
            if (this.h & 1) {
                this.$();
            } else {
                this.untrackedLoading = !1;
                this.cn();
            }
        }
    }
    $n(t, n) {
        if (t !== this.nn || !t.Jt) {
            return;
        }
        t.Jt = !1;
        if (n instanceof Error && n.name === "AbortError") {
            return;
        }
        this.untrackedError = n;
        this.untrackedValue = Br;
    }
    async yn() {
        this.un();
        clearTimeout(this.pn);
        const t = this.nn;
        t && this.hn(t);
        this.rn ? await Promise.all(this.rn.map(t => t.Bt)) : await (t?.Bt);
    }
    un() {
        if (this.mn !== void 0) {
            clearTimeout(this.mn);
            this.mn = void 0;
        }
    }
    cn() {
        if (ue || !this.Tt) {
            return;
        }
        this.un();
        const t = !(this.h & 256);
        const n = this.h & 128 && !t;
        this.mn = setTimeout(() => this.an(t, n), this.Tt);
        this.mn?.unref?.();
    }
    fn() {
        return !!(this.ft?.size || this.yt?.size || this.wt?.size);
    }
    hn(t, n) {
        if (t.Ht) {
            return;
        }
        t.Ht = !0;
        t.Gt?.abort(n);
        t.Bt = br(t.Bt, () => this.wn(t));
    }
    wn(t) {
        const n = t.Kt;
        const e = t => {
            const n = this.m?.handleError;
            n ? n(t, null) : console.error("Error in async signal cleanup", t);
        };
        const s = () => {
            t.Bt = null;
            n && (n.length = 0);
            const e = this.rn;
            if (e) {
                const n = e.indexOf(t);
                n !== -1 && e.splice(n, 1);
            }
            this.$();
        };
        let o;
        if (n) {
            for (let t = 0; t < n.length; t++) {
                try {
                    const s = n[t]();
                    wr(s) && (o = (o ? o.then(() => s) : s).catch(e));
                } catch (t) {
                    e(t);
                }
            }
        }
        if (o) {
            return o.then(s);
        }
        s();
    }
}

const es = Symbol();

const rs = Symbol();

const ss = Symbol();

const is = Symbol();

const os = Symbol();

const ls = Symbol();

const us = [];

const cs = {};

Object.freeze(us);

Object.freeze(cs);

function $(t) {
    return new Proxy({}, new fs(t));
}

class fs {
    owner;
    ft=void 0;
    m=null;
    constructor(t) {
        this.owner = t;
    }
    get(t, n) {
        if (n === es) {
            return this.owner.constProps;
        }
        if (n === rs) {
            return this.owner.varProps;
        }
        if (n === ss) {
            return this.owner;
        }
        if (n === is) {
            return this;
        }
        let e;
        if (n === "children") {
            e = this.owner.children;
        } else {
            if (typeof n === "string" && typeof this.owner.type === "string") {
                const t = r(n);
                t && (n = t);
            }
            e = ds(this.owner, n);
            n in this.owner.varProps && as(this, n);
        }
        return e instanceof Ms && e.h & 4 ? e.value : e;
    }
    set(t, n, e) {
        if (n === ss) {
            this.owner = e;
        } else if (n === "children") {
            this.owner.children = e;
        } else if (n === es) {
            this.owner.constProps = e;
        } else if (n === rs) {
            this.owner.varProps = e;
        } else {
            if (typeof n === "string" && typeof this.owner.type === "string") {
                const t = r(n);
                t && (n = t);
            }
            this.owner.constProps && n in this.owner.constProps && delete this.owner.constProps[n];
            this.owner.varProps === cs ? this.owner.varProps = {} : n in this.owner.varProps || (this.owner.toSort = !0);
            if (this.owner.varProps[n] !== e) {
                this.owner.varProps[n] = e;
                hs(this, n);
            }
        }
        return !0;
    }
    deleteProperty(t, n) {
        let e = delete this.owner.varProps[n];
        e && hs(this, n);
        this.owner.constProps && (e = delete this.owner.constProps[n] || e);
        if (this.owner.children != null && n === "children") {
            this.owner.children = null;
            e = !0;
        }
        return e;
    }
    has(t, n) {
        if (n === "children") {
            return this.owner.children != null;
        }
        if (n === es || n === rs) {
            return !0;
        }
        const e = n in this.owner.varProps;
        if (typeof n === "string") {
            e && as(this, n);
            if (typeof this.owner.type === "string") {
                const t = r(n);
                t && (n = t);
            }
        }
        return e || !!this.owner.constProps && n in this.owner.constProps;
    }
    getOwnPropertyDescriptor(t, n) {
        const e = n === "children" ? this.owner.children : this.owner.constProps && n in this.owner.constProps ? this.owner.constProps[n] : this.owner.varProps[n];
        return {
            configurable: !0,
            enumerable: !0,
            value: e
        };
    }
    ownKeys() {
        const t = Object.keys(this.owner.varProps);
        this.owner.children != null && t.push("children");
        if (this.owner.constProps) {
            for (const n in this.owner.constProps) {
                t.indexOf(n) === -1 && t.push(n);
            }
        }
        return t;
    }
}

const as = (t, n) => {
    const e = dc();
    e && t.m === null && e.m && (t.m = e.m);
    const s = e?.Lt;
    s && kn(t.owner._proxy, n, t, s);
};

const hs = (t, n) => {
    const e = function s(t, n) {
        return t?.get(n);
    }(t.ft, n);
    e && Rl(t.m, t, e);
    return !!e;
};

const ds = (t, n) => t.constProps && n in t.constProps ? t.constProps[n] : t.varProps[n];

const ps = (t, n) => $s(t)?.[n] || ys(t)?.[n] || null;

const $s = t => {
    if (!t) {
        return null;
    }
    return rs in t ? "children" in t ? {
        ...t[rs],
        children: t.children
    } : t[rs] : t;
};

const ys = t => {
    if (!t) {
        return null;
    }
    return es in t ? t[es] : null;
};

const ms = t => t && rs in t;

const ws = t => (n, ...e) => t.call(null, Jc(n), ...e);

class vs extends Zr {
    constructor(t, n) {
        super(t, n, 17);
    }
    vn=!1;
    $() {
        if (!(this.h & 1)) {
            return;
        }
        El(this.Xt);
        const t = mc(this.Xt.resolved);
        const {deserialize: n, initial: e} = t;
        const s = t.update;
        const o = this.Wt === Br ? e : this.Wt;
        const r = vc(() => this.vn ? s?.(o) || o : n(o), this, ".", this.m);
        this.vn = !0;
        this.h &= -2;
        const i = this.vn && r !== "undefined" || r !== this.Wt;
        if (i) {
            this.Wt = r;
            Rl(this.m, this, this.ft);
        }
    }
}

const bs = (t, n) => new Zr(n?.container || null, t, Nl(n?.serializationStrategy || "always"));

const gs = (t, n) => new ns(n?.container || null, t, Nl(n?.serializationStrategy || "always"), n);

const _s = t => new vs(null, t);

const Ss = t => new Kr(null, t);

const ks = /*#__PURE__*/ ws(bs);

const Es = /*#__PURE__*/ ws(gs);

const xs = ws(_s);

const qs = t => t.value;

const Ts = (t, n) => t[n];

const Ps = t => {
    if (t.length === 1) {
        if (xl(t[0])) {
            return t[0].Ut ||= new Ms(null, qs, t, null);
        }
        if (Dl(t[0])) {
            return new Ms(null, qs, t, null);
        }
        return t[0].value;
    }
    return new Ms(null, Ts, t, null);
};

const Rs = (...t) => {
    const n = t[0];
    const e = t.length < 2 ? "value" : t[1];
    if (!pe(n)) {
        return n[e];
    }
    if (xl(n)) {
        if (n instanceof Ms && n.h & 4) {
            return n;
        }
        return Ps(t);
    }
    if (ms(n)) {
        const s = n[es];
        const o = n[rs];
        if (s && Object.prototype.hasOwnProperty.call(s, e)) {
            return s[e];
        }
        if (Object.prototype.hasOwnProperty.call(o, e)) {
            const n = o[e];
            return As(n, t);
        }
    } else {
        const s = jl(n);
        if (s) {
            const n = s[e];
            return As(n, t);
        }
    }
    return n[e];
};

const As = (t, n) => xl(t) ? t : Ps(n);

const Ns = (t, n) => {
    const e = Rs(t, n);
    if (e === os) {
        return t[n];
    }
    return e;
};

class Ms extends Kr {
    ct;
    ut;
    xt;
    h;
    k=void 0;
    [_r]=void 0;
    constructor(t, n, e, s, o = 5) {
        super(t, Br);
        this.ct = e;
        this.ut = n;
        this.xt = s;
        this.h = o;
    }
    invalidate() {
        this.h |= 1;
        try {
            this.$();
        } catch (t) {
            if (this.m && this.k) {
                this.m.setHostProp(this.k, zr, this);
                ln(this.m, this.k, 16);
            }
        }
        if (this.h & 2) {
            this.h &= -3;
            Rl(this.m, this, this.ft);
        }
    }
    get untrackedValue() {
        this.$();
        return this.Wt;
    }
    $() {
        if (!(this.h & 1)) {
            return;
        }
        const t = vc(() => this.ut(...this.ct), this, ".", this.m);
        this.h &= -3;
        const n = t !== this.Wt;
        if (n) {
            this.h |= 2;
            this.Wt = t;
        }
    }
    ot() {
        return this.ut === qs && xl(this.ct[0]) ? this.ct[0] : this;
    }
    set value(t) {
        throw we(31);
    }
    get value() {
        return super.value;
    }
}

class Is {
    data;
    constructor(t) {
        this.data = t;
    }
}

const Cs = (t, n) => {
    if (typeof t === "string") {
        const e = Gn(n);
        Cc(jc(e, t));
    }
    return null;
};

function y(t, n) {
    Cs(this, n);
    const e = Ic._[0];
    e.value = n.type === "number" ? n.valueAsNumber : n.value;
}

function m(t, n) {
    Cs(this, n);
    const e = Ic._[0];
    e.value = n.checked;
}

function w(t, n) {
    Cs(this, n);
    const e = Ic._;
    if (e) {
        for (let t = 0; t < e.length; t++) {
            const n = e[t];
            n instanceof ns && n.h & 64 && n.$();
        }
    }
}

const js = t => {
    for (const n in t) {
        if (Object.prototype.hasOwnProperty.call(t, n)) {
            return !1;
        }
    }
    return !0;
};

class Os {
    type;
    children;
    flags;
    toSort;
    key;
    varProps;
    constProps;
    dev;
    _proxy=null;
    constructor(t, n, e, s, o, r, i, c) {
        this.type = t;
        this.children = s;
        this.flags = o;
        this.toSort = !!i;
        this.key = r === null || r === void 0 ? null : typeof r === "string" ? r : "" + r;
        this.varProps = !n || js(n) ? cs : n;
        this.constProps = !e || js(e) ? null : e;
    }
    get props() {
        return this._proxy ||= $(this);
    }
}

const Fs = (t, n, e) => {
    let s = t[n];
    if (!s) {
        t[n] = e;
        return !0;
    }
    Array.isArray(s) ? s.push(e) : s = t[n] = [ s, e ];
};

const Ls = t => t instanceof Os;

const Ds = "bind:value";

const Vs = "bind:checked";

const Ws = "passive:";

const Us = "preventdefault:";

const Xs = Object.prototype.hasOwnProperty;

const zs = (t, n, e, s, o = !1) => {
    let r = t;
    let i = o;
    if (n.length > 0) {
        if (!i) {
            r = {
                ...r
            };
            i = !0;
        }
        for (let t = 0; t < n.length; t++) {
            const e = n[t];
            delete r[e];
        }
    }
    if (e.length > 0) {
        for (let t = 0; t < e.length; t++) {
            const n = e[t];
            if (s.has(Nr(n.slice(15)))) {
                if (!i) {
                    r = {
                        ...r
                    };
                    i = !0;
                }
                delete r[n];
            }
        }
    }
    return r;
};

const Bs = t => {
    if (t.startsWith("on") && t.endsWith("$")) {
        return Nr(t.slice(2, -1));
    }
    if (t.startsWith("window:on") && t.endsWith("$")) {
        return Nr(t.slice(9, -1));
    }
    if (t.startsWith("document:on") && t.endsWith("$")) {
        return Nr(t.slice(11, -1));
    }
    return null;
};

const Hs = (t, n, e, s, o = !1) => {
    let i = t;
    let c = o;
    for (let t = 0; t < n.length; t++) {
        const o = n[t];
        const l = Bs(o);
        const u = r(o, s.has(l));
        if (u) {
            if (!c) {
                i = {
                    ...i
                };
                c = !0;
            }
            const t = e.get(u);
            (t === void 0 || t < e.get(o)) && (i[u] = i[o]);
            delete i[o];
        }
    }
    return i;
};

const Js = (t, n, e, s, o, r, i) => new Os(t, n, e, s, o, r, !1, i);

const Qs = (t, n, e, s, o, r, i) => {
    let c = !1;
    let l = !1;
    let u = !1;
    let f = null;
    let a = null;
    if (typeof t === "string") {
        const t = new Set;
        const s = [];
        const o = [];
        const r = [];
        const i = [];
        const h = [];
        const d = [];
        const p = new Map;
        const $ = new Map;
        if (e) {
            let n = 0;
            for (const o in e) {
                p.set(o, n++);
                if (o.startsWith(Ws)) {
                    r.push(o);
                    t.add(Nr(o.slice(8)));
                } else {
                    o.startsWith(Us) ? h.push(o) : Bs(o) !== null ? s.push(o) : o === Vs ? a = e[o] : o === Ds && (f = e[o]);
                }
            }
        }
        if (n) {
            let e = 0;
            for (const s in n) {
                $.set(s, e++);
                if (s.startsWith(Ws)) {
                    i.push(s);
                    t.add(Nr(s.slice(8)));
                } else {
                    s.startsWith(Us) ? d.push(s) : Bs(s) !== null ? o.push(s) : s === Vs ? a = n[s] : s === Ds && (f = n[s]);
                }
            }
        }
        if (e) {
            const n = e;
            e = zs(e, r, h, t, l);
            l = l || e !== n;
            e = Hs(e, s, p, t, l);
            l = l || e !== n;
        }
        if (n) {
            const e = n;
            n = zs(n, i, d, t, u);
            u = u || n !== e;
            n = Hs(n, o, $, t, u);
            u = u || n !== e;
            c = c || o.length > 0;
        }
        if (a || f) {
            if (!u) {
                n = {
                    ...n
                };
                u = !0;
            }
            n ||= {};
            if (a) {
                n && Xs.call(n, Vs) && delete n[Vs];
                if (e && Xs.call(e, Vs)) {
                    if (!l) {
                        e = {
                            ...e
                        };
                        l = !0;
                    }
                    delete e[Vs];
                }
                n.checked = a;
                const t = Dc(null, "_chk", m, null, [ a ]);
                if (e && Xs.call(e, "q-e:input")) {
                    if (!l) {
                        e = {
                            ...e
                        };
                        l = !0;
                    }
                    const t = e["q-e:input"];
                    delete e["q-e:input"];
                    c = Fs(n, "q-e:input", t) || c;
                }
                c = Fs(n, "q-e:input", t) || c;
            } else if (f) {
                n && Xs.call(n, Ds) && delete n[Ds];
                if (e && Xs.call(e, Ds)) {
                    if (!l) {
                        e = {
                            ...e
                        };
                        l = !0;
                    }
                    delete e[Ds];
                }
                n.value = f;
                const t = Dc(null, "_val", y, null, [ f ]);
                if (e && Xs.call(e, "q-e:input")) {
                    if (!l) {
                        e = {
                            ...e
                        };
                        l = !0;
                    }
                    const t = e["q-e:input"];
                    delete e["q-e:input"];
                    c = Fs(n, "q-e:input", t) || c;
                }
                c = Fs(n, "q-e:input", t) || c;
            }
        }
        if (n && Xs.call(n, "className")) {
            if (!u) {
                n = {
                    ...n
                };
                u = !0;
            }
            n.class = n.className;
            n.className = void 0;
            c = !0;
        }
        if (e && Xs.call(e, "className")) {
            if (!l) {
                e = {
                    ...e
                };
                l = !0;
            }
            e.class = e.className;
            e.className = void 0;
        }
    }
    if (n) {
        for (const t in n) {
            if (t === "children") {
                if (!u) {
                    n = {
                        ...n
                    };
                    u = !0;
                }
                s ||= n.children;
                delete n.children;
            } else if (t === "key") {
                if (!u) {
                    n = {
                        ...n
                    };
                    u = !0;
                }
                r ||= n.key;
                delete n.key;
            } else if (e && t in e) {
                if (!u) {
                    n = {
                        ...n
                    };
                    u = !0;
                }
                delete n[t];
            } else if (n[t] === null) {
                if (!u) {
                    n = {
                        ...n
                    };
                    u = !0;
                }
                delete n[t];
            }
        }
    }
    return new Os(t, n, e, s, o, r, c || !0, i);
};

const Ys = (t, n, e, s) => ti(t, n, s);

const Gs = (t, n, e, s, o) => ti(t, {
    ...e,
    ...n
}, o);

const Ks = (t, n, e, s, o, r) => ti(t, {
    ...e,
    ...n,
    children: s
}, r);

const Zs = t => t.children;

const ti = (t, n, e, s, o) => Qs(t, n, null, null, 0, e, o);

const ni = ti;

const ei = ti;

function v(t, n, ...e) {
    const s = {
        children: arguments.length > 2 ? e.flat(100) : null
    };
    let o = null;
    for (const t in n) {
        t == "key" ? o = n[t] : s[t] = n[t];
    }
    return Qs(t, n, null, s.children, 0, o);
}

const ri = t => t.children;

const si = (t, n) => new Os(Zs, null, null, t.children, 0, n);

const ii = (t, n, e, s, o) => {
    const r = se(t.Ot, e || n, t);
    if (e) {
        r.Lt = p(e, ":");
        r.m = t;
    }
    let i;
    t.ensureProjectionResolved(n);
    let c = !1;
    s === null && (s = t.getHostProp(n, Ee));
    if (ke(s)) {
        o = o || t.getHostProp(n, Ge) || cs;
        "children" in o && delete o.children;
        i = s.getFn(r);
    } else if (tf(s)) {
        const t = s;
        i = () => re(r, t, [ o || cs, null, 0 ]);
    } else {
        c = !0;
        const t = s;
        i = () => re(r, t, [ o || cs ]);
    }
    const l = ue;
    const u = (e = 0) => vr(() => {
        if (!c) {
            t.setHostProp(n, Ze, null);
            t.setHostProp(n, sr, null);
        }
        e > 0 && fo(n) && yn(t, n);
        return br(i(o), t => br(r.Dt, () => t));
    }, s => {
        if (l && !c) {
            const t = n;
            if (t.dirty & 4) {
                t.dirty &= -5;
                if (e < mr) {
                    return u(e + 1);
                }
            }
        }
        const o = t.getHostProp(n, rr);
        if (o) {
            return function r(t, n) {
                const e = S(t);
                let s = t;
                const o = "q-e:qvisible";
                return br(e, t => {
                    const e = !t;
                    let r = null;
                    for (const i in n) {
                        if (Object.prototype.hasOwnProperty.call(n, i)) {
                            let c = t;
                            let l = i;
                            if (e) {
                                if (i !== o && !i.startsWith("q-d:") && !i.startsWith("q-w:")) {
                                    continue;
                                }
                                if (!r) {
                                    const [t, n] = k(s);
                                    s = n;
                                    r = t;
                                }
                                c = r;
                            }
                            if (c) {
                                c.type === "script" && i === o && (l = "q-d:qinit");
                                g(c, l, n[i]);
                            }
                        }
                    }
                    return s;
                });
            }(s, o);
        }
        return s;
    }, t => {
        if (wr(t) && e < mr) {
            return t.then(() => u(++e));
        }
        if (e >= mr) {
            throw Error("Max retry count of component execution reached");
        }
        throw t;
    });
    return u();
};

function g(t, n, e) {
    const s = t.constProps ||= {};
    const o = s[n];
    const r = e.qrls;
    o == null ? s[n] = r : Array.isArray(o) ? o.push(...r) : s[n] = [ o, ...r ];
    const i = t.varProps[n];
    if (i) {
        Array.isArray(o) ? o.push(...s[n]) : t.varProps[n] = [ o, ...r ];
        s[n] = void 0;
    }
    const c = e.capture;
    const l = e.preventdefault;
    const u = e.stoppropagation;
    if (!c && !l && !u) {
        return;
    }
    const [, f] = Ir(n);
    c && _(t, f, "capture");
    l && _(t, f, "preventdefault");
    u && _(t, f, "stoppropagation");
}

function _(t, n, e) {
    const s = `${e}:${n}`;
    const o = t.varProps;
    o === cs && (t.varProps = {});
    t.varProps[s] = !0;
}

function S(t) {
    const n = [ t ];
    for (;n.length; ) {
        const t = n.shift();
        if (Ls(t)) {
            if (typeof t.type === "string") {
                return t;
            }
            n.push(t.children);
        } else if ($e(t)) {
            n.push(...t);
        } else {
            if (wr(t)) {
                return br(t, t => S(t));
            }
            if (xl(t)) {
                return S(t.untrackedValue);
            }
        }
    }
    return null;
}

function k(t) {
    if (Ls(t)) {
        const n = E();
        if (t.type !== ri && !tf(t.type)) {
            return [ n, Js(ri, null, null, [ t, n ], 0, null) ];
        }
        t.children == null ? t.children = n : $e(t.children) ? t.children.push(n) : t.children = [ t.children, n ];
        return [ n, t ];
    }
    if ((t => typeof t !== "object" && typeof t !== "function" || t === null || t === void 0)(t)) {
        const n = E();
        return [ n, Js(ri, null, null, [ t, n ], 0, null) ];
    }
    if ($e(t) && t.length > 0) {
        const [n, e] = k(t[0]);
        return [ n, t ];
    }
    return [ null, t ];
}

function E() {
    return new Os("script", null, {
        hidden: ""
    }, null, 0, null);
}

const oi = t => Js(Zs, null, {
    [Pe]: ""
}, t.children, 0, t.name ?? "");

const li = Symbol();

const ui = () => null;

const ci = () => null;

const fi = t => t.children;

const ai = (t, n) => ti(si, {
    children: ti(hi, t)
}, n);

const hi = () => null;

let di = null;

let pi = null;

function x(t, n, e, s) {
    if (e != null) {
        if (s) {
            const s = function o(t) {
                switch (t) {
                  case "xlink:href":
                  case "xlink:actuate":
                  case "xlink:arcrole":
                  case "xlink:role":
                  case "xlink:show":
                  case "xlink:title":
                  case "xlink:type":
                    return "http://www.w3.org/1999/xlink";

                  case "xml:base":
                  case "xml:lang":
                  case "xml:space":
                    return "http://www.w3.org/XML/1998/namespace";

                  default:
                    return null;
                }
            }(n);
            if (s) {
                ((t, n, e, s) => {
                    pi || (pi = t.setAttributeNS);
                    pi.call(t, n, e, s);
                })(t, s, n, e);
                return;
            }
        }
        ((t, n, e) => {
            di || (di = t.setAttribute);
            di.call(t, n, e);
        })(t, n, e);
    }
}

function q(t) {
    let n = "";
    for (let e = 0; e < t.length; e++) {
        if (t.charAt(e) === "\\" && e + 1 < t.length) {
            n += t.charAt(e + 1);
            e++;
        } else {
            n += t.charAt(e);
        }
    }
    return n;
}

function T(t) {
    return !t.startsWith("q:") && !t.startsWith(":");
}

const $i = (t, n = [], e = {}) => {
    let s = null;
    const o = t[es];
    if (o) {
        for (const t in o) {
            if (!n.includes(t)) {
                s ||= {};
                s[t] = o[t];
            }
        }
    }
    const r = e;
    const i = t[rs];
    for (const t in i) {
        n.includes(t) || (r[t] = i[t]);
    }
    return $(new Os(null, r, s, null, 0, null));
};

const yi = t => qe + t;

const mi = t => {
    if (t) {
        let n = 0;
        do {
            t = t.substring(0, n) + yi(t.substring(n));
        } while ((n = t.indexOf(" ", n) + 1) !== 0);
    }
    return t || null;
};

const wi = new Set([ "animationIterationCount", "aspectRatio", "borderImageOutset", "borderImageSlice", "borderImageWidth", "boxFlex", "boxFlexGroup", "boxOrdinalGroup", "columnCount", "columns", "flex", "flexGrow", "flexShrink", "gridArea", "gridRow", "gridRowEnd", "gridRowStart", "gridColumn", "gridColumnEnd", "gridColumnStart", "fontWeight", "lineClamp", "lineHeight", "opacity", "order", "orphans", "scale", "tabSize", "widows", "zIndex", "zoom", "MozAnimationIterationCount", "MozBoxFlex", "msFlex", "msFlexPositive", "WebkitAnimationIterationCount", "WebkitBoxFlex", "WebkitBoxOrdinalGroup", "WebkitColumnCount", "WebkitColumns", "WebkitFlex", "WebkitFlexGrow", "WebkitFlexShrink", "WebkitLineClamp" ]);

const vi = (t, n = 0) => {
    for (let e = 0; e < t.length; e++) {
        const s = t.charCodeAt(e);
        n = (n << 5) - n + s;
        n |= 0;
    }
    return (+Math.abs(n)).toString(36);
};

const bi = t => {
    if (!t) {
        return "";
    }
    if (ye(t)) {
        return t.trim();
    }
    const n = [];
    if ($e(t)) {
        for (let e = 0; e < t.length; e++) {
            const s = t[e];
            const o = bi(s);
            o && n.push(o);
        }
    } else {
        for (const [e, s] of Object.entries(t)) {
            s && n.push(e.trim());
        }
    }
    return n.join(" ");
};

const gi = t => t.replace(/([A-Z])/g, "-$1").toLowerCase();

const _i = t => {
    if (t == null) {
        return "";
    }
    if (typeof t == "object") {
        if ($e(t)) {
            throw we(0, [ t, "style" ]);
        }
        {
            const n = [];
            for (const e in t) {
                if (Object.prototype.hasOwnProperty.call(t, e)) {
                    const s = t[e];
                    s != null && typeof s !== "function" && (e.startsWith("--") ? n.push(e + ":" + s) : n.push(gi(e) + ":" + ki(e, s)));
                }
            }
            return n.join(";");
        }
    }
    return t + "";
};

const Si = t => t != null ? t + "" : null;

function P(t, n, e) {
    if (function s(t) {
        return t === "class";
    }(t)) {
        const t = bi(n);
        n = e ? e + (t.length ? " " + t : t) : t;
    } else {
        t === "style" ? n = _i(n) : function o(t) {
            return function n(t) {
                return t.startsWith("aria-");
            }(t) || [ "spellcheck", "draggable", "contenteditable" ].includes(t);
        }(t) || typeof n === "number" ? n = Si(n) : n === !1 || n == null ? n = null : n === !0 && function r(t) {
            return t.startsWith("preventdefault:");
        }(t) && (n = "");
    }
    return n;
}

const ki = (t, n) => {
    if (typeof n === "number" && n !== 0 && !(t => wi.has(t))(t)) {
        return n + "px";
    }
    return n;
};

class Ei {
    target;
    constructor(t) {
        this.target = t;
    }
}

class xi {
    target;
    constructor(t) {
        this.target = t;
    }
}

class qi {
    target;
    text;
    constructor(t, n) {
        this.target = t;
        this.text = n;
    }
}

class Ti {
    target;
    parent;
    beforeTarget;
    constructor(t, n, e) {
        this.target = t;
        this.parent = n;
        this.beforeTarget = e;
    }
}

class Pi {
    target;
    attrName;
    attrValue;
    scopedStyleIdPrefix;
    isSvg;
    constructor(t, n, e, s, o) {
        this.target = t;
        this.attrName = n;
        this.attrValue = e;
        this.scopedStyleIdPrefix = s;
        this.isSvg = o;
    }
}

const Ri = t => new Ei(t);

const Ai = t => new xi(t);

const Ni = (t, n) => new qi(t, n);

const Mi = (t, n, e) => new Ti(t, n, e);

const Ii = (t, n, e, s = null, o = !1) => new Pi(t, n, e, s, o);

const Ci = () => {
    const t = $c();
    const n = t.k;
    const e = n;
    let s = t.m.getHostProp(e, Ke);
    if (s === null) {
        s = [];
        t.m.setHostProp(e, Ke, s);
    }
    let o = t.m.getHostProp(e, Ze);
    o === null && (o = 0);
    t.m.setHostProp(e, Ze, o + 1);
    for (;s.length <= o; ) {
        s.push(void 0);
    }
    return {
        val: s[o],
        set: t => s[o] = t,
        i: o,
        iCtx: t
    };
};

const ji = t => {
    const n = me(t) && !tf(t) ? ee(void 0, t) : t;
    return Ss(n);
};

const Oi = t => Fi(ji, t);

const Fi = (t, ...n) => {
    const {val: e, set: s} = Ci();
    if (e != null) {
        return e;
    }
    t = me(t) && !tf(t) ? mc(t, ...n) : t;
    return s(t);
};

const Li = () => ({
    pending: Ss(0),
    version: Ss(0)
});

function R(t, n) {
    if (!__EXPERIMENTAL__.suspense) {
        return;
    }
    const e = M(t.container, n);
    if (!e) {
        return;
    }
    const s = t.boundaries ||= [];
    if (!s.includes(e)) {
        s.push(e);
        e.pending.value++;
    }
}

function A(t, n) {
    if (!__EXPERIMENTAL__.suspense) {
        return null;
    }
    return t.getHostProp(n, or);
}

function N(t) {
    if (!__EXPERIMENTAL__.suspense) {
        return;
    }
    vo(t, lr, null);
}

function M(t, n) {
    if (!__EXPERIMENTAL__.suspense) {
        return null;
    }
    return function e(t) {
        if (!__EXPERIMENTAL__.suspense) {
            return null;
        }
        return wo(t, lr, null) || null;
    }(n) || A(t, n);
}

function I(t, n) {
    __EXPERIMENTAL__.suspense && vo(t, lr, n);
}

function C(t, n, e) {
    if (!__EXPERIMENTAL__.suspense) {
        return;
    }
    I(n, e);
    const s = n.dirtyChildren;
    if (!s || s.length === 0) {
        return;
    }
    for (let n = 0; n < s.length; n++) {
        const o = s[n];
        C(t, o, A(t, o) || e);
    }
}

const Di = t => {
    if (t.yn) {
        try {
            t.yn();
        } catch (t) {
            ((t, ...n) => {
                he(!1, t, ...n);
            })(t);
        }
        t.yn = null;
    }
};

function j(n, e, s, o) {
    if (!s.isConnected) {
        return;
    }
    o || (o = yc(e, s));
    const r = o.m;
    const i = o.k;
    _o(r, i);
    let c = n;
    if (i.flags & 64) {
        let t;
        if (!(i.flags & 128)) {
            t = !0;
            i.flags |= 128;
        }
        const o = t ? r.q : null;
        const l = wo(i, tr, o);
        if (l !== null) {
            c = () => n(e, s, l);
        } else {
            const t = wo(i, nr, o);
            t !== null && (c = () => n(e, s, ...t));
        }
    }
    return t(() => {
        if (!(i.flags & 32)) {
            return re(o, c, [ e, s ]);
        }
    }, t => r.handleError(t, i));
}

function O(t, n) {
    if (!n.isConnected) {
        return;
    }
    const e = yc(t, n);
    typeof this === "string" && Cc(jc(e.m, this));
    const s = Ic._[0];
    return j(s, t, n, e);
}

const Vi = (t, n, e) => {
    let s = e >> 1;
    let o = t.length - 2 >> 1;
    for (;s <= o; ) {
        const e = s + (o - s >> 1);
        const r = t[e << 1];
        if (r === n) {
            return e << 1;
        }
        r < n ? s = e + 1 : o = e - 1;
    }
    return ~(s << 1);
};

const Wi = (t, n, e, s, o = !1) => {
    const r = Vi(t, n, s);
    r >= 0 ? e != null || o ? t[r + 1] = e : t.splice(r, 2) : (e != null || o) && t.splice(r ^ -1, 0, n, e);
};

const Ui = (t, n, e) => {
    const s = Vi(t, n, e);
    return s >= 0 ? t[s + 1] : null;
};

const Xi = (t, n, e) => Vi(t, n, e) >= 0;

function F(t) {
    return t.T === t.R ? t.N : null;
}

function L(t) {
    return t.M || F(t);
}

function D(t, n) {
    const e = function s(t) {
        return t ? t.nextSibling : null;
    }(n);
    const o = F(t);
    return e === o ? null : e;
}

const zi = Object.prototype.hasOwnProperty;

function V(t, n, e, s, o, r) {
    vo(n, e, r);
    un(t, Ii(n.node, e, s, o, (n.flags & 512) !== 0));
}

function W(t, n, e, s) {
    return {
        m: t,
        j: n,
        O: e,
        L: s,
        D: [],
        W: [],
        U: [],
        T: null,
        M: null,
        X: null,
        N: null,
        R: null,
        B: null,
        H: null,
        J: null,
        Y: null,
        G: null,
        K: 0,
        Z: 0,
        tt: !0,
        nt: !1,
        et: {
            rt: new Is({
                L: s,
                st: !0
            }),
            it: new Is({
                L: s,
                st: !1
            })
        }
    };
}

function U(t, n, e, s, o) {
    const r = t ?? W(n, e, s, o);
    (function i(t, n, e, s, o) {
        t.m = n;
        t.j = e;
        t.O = s;
        t.L = o;
        t.et.rt.data.L = o;
        t.et.it.data.L = o;
        t.W.length = 0;
        t.U.length = 0;
    })(r, n, e, s, o);
    return r;
}

const Bi = (t, n, e, s, o, r, i) => X(U(i, t, n, o, r), e, s);

const Hi = (t, n, e, s, o, r, i, c, l = !1, u) => X(U(u, t, n, i, c), e, s, o, r, l);

function X(t, n, e, s = Ho(e), o = null, r = !1) {
    z(t, n, e, s, o, r);
    const i = nt(t);
    if (wr(i)) {
        return i.finally(() => {
            et(t);
        });
    }
    et(t);
}

function z(t, n, e, s = Ho(e), o = null, r = !1) {
    const i = t.nt;
    t.nt = r || i;
    t.T = e;
    t.X = null;
    t.M = s;
    t.N = o;
    t.R = e;
    Y(t, n, !0);
    try {
        if (t.T.flags & 32) {
            return;
        }
        for (;t.D.length; ) {
            for (;t.K < t.Z; ) {
                if (typeof t.G === "string") {
                    gt(t, t.G);
                } else if (typeof t.G === "number") {
                    gt(t, t.G + "");
                } else if (t.G && typeof t.G === "object") {
                    if (Ls(t.G)) {
                        const n = t.G.type;
                        if (typeof n === "string") {
                            it(t);
                            dt(t, t.G, n);
                            const e = t.G.constProps && zi.call(t.G.constProps, cr) || zi.call(t.G.varProps, cr);
                            e ? t.X || rt(t, !1) : J(t, t.G.children, !0);
                        } else if (typeof n === "function") {
                            if (n === ri) {
                                it(t);
                                mt(t, "F", t.G.key);
                                J(t, t.G.children, !0);
                            } else if (n === oi) {
                                it(t);
                                Z(t) || J(t, t.G.children, !0);
                            } else if (n === kt) {
                                K(t);
                                J(t, t.G.children, !0, !1);
                            } else if (n === ci) {
                                st(t);
                            } else if (n === ui) {
                                st(t);
                            } else {
                                it(t);
                                wt(t, n);
                            }
                        }
                    } else if (Array.isArray(t.G)) {
                        J(t, t.G, !1);
                    } else if (xl(t.G)) {
                        mt(t, "S", null);
                        const n = t.G instanceof Ms ? t.G.ot() : t.G;
                        const e = t.M?.[_r]?.get(".")?.backRef;
                        let s = e?.has(n);
                        e && n instanceof Ms && (s = At(e, n));
                        if (!s) {
                            const e = t.X || t.M;
                            J(t, B(t, () => bc(n, e, ".", t.m)), !0);
                        }
                    } else if (wr(t.G)) {
                        mt(t, "A", null);
                        t.W.push(t.G, t.X || t.M);
                    }
                } else {
                    t.G === li || gt(t, "");
                }
                H(t);
            }
            st(t);
            tt(t);
            Q(t);
        }
    } finally {
        t.nt = i;
    }
}

function B(n, e) {
    try {
        return e();
    } catch (s) {
        if (wr(s)) {
            const o = s.then(() => t(e));
            n.W.push(o, n.X || n.M);
            return null;
        }
        throw s;
    }
}

function H(t) {
    if (!t.tt) {
        t.tt = !0;
        return;
    }
    t.K++;
    if (t.K < t.Z) {
        t.G = t.Y[t.K];
    } else if (t.D.length > 0 && t.D[t.D.length - 1] === !1) {
        return Q(t);
    }
    t.X !== null ? t.X = null : t.M = D(t, t.M);
}

function J(t, n, e, s = !0) {
    if (s && (n == null || e && $e(n) && n.length === 0)) {
        rt(t);
        return;
    }
    Y(t, n, e);
    if (e) {
        const n = t.nt || !!t.X || !Ho(t.M);
        t.nt = n;
        t.J = null;
        t.B = null;
        t.H = null;
        t.T = t.X || t.M;
        t.M = Ho(t.T);
        t.X = null;
    }
    t.tt = !1;
}

function Q(t) {
    const n = t.D.pop();
    if (n) {
        t.nt = t.D.pop();
        t.J = t.D.pop();
        t.B = t.D.pop();
        t.H = t.D.pop();
        t.X = t.D.pop();
        t.M = t.D.pop();
        t.T = t.D.pop();
    }
    t.G = t.D.pop();
    t.Z = t.D.pop();
    t.K = t.D.pop();
    t.Y = t.D.pop();
    H(t);
}

function Y(t, n, e) {
    t.D.push(t.Y, t.K, t.Z, t.G);
    e && t.D.push(t.T, t.M, t.X, t.H, t.B, t.J, t.nt);
    t.D.push(e);
    if (Array.isArray(n)) {
        t.K = 0;
        t.Z = n.length;
        t.Y = n;
        t.G = t.Z > 0 ? n[0] : null;
    } else if (n === void 0) {
        t.K = 0;
        t.G = null;
        t.Y = null;
        t.Z = 0;
    } else {
        t.K = 0;
        t.G = n;
        t.Y = null;
        t.Z = 1;
    }
}

function G(t) {
    if (t.X) {
        return L(t);
    }
    return D(t, t.M) || F(t);
}

function K(t) {
    const n = t.G;
    const e = n.key;
    t.M = wo(t.T, e, n => xo(t.m.rootVNode, n));
    t.M = t.M && t.M.flags & 32 ? null : t.M;
    if (t.M == null) {
        t.X = co();
        vo(t.X, Te, e);
        t.X.slotParent = t.T;
        vo(t.T, e, t.X);
    }
}

function Z(t) {
    const n = t.G;
    const e = bl(t.T);
    const s = function o(t, n) {
        const e = t.G;
        const s = e.constProps;
        if (s && typeof s == "object" && zi.call(s, "name")) {
            const e = s.name;
            if (n && e instanceof Ms) {
                return bc(e, n, ":", t.m);
            }
        }
        return ds(e, "name") || "";
    }(t, e);
    const r = ds(n, or) || null;
    const i = e ? wo(e, s, null) : null;
    if (i == null) {
        t.X = co();
        vo(t.X, Te, s);
        vo(t.X, or, r);
        C(t.m, t.X, r);
        e && vo(e, s, t.X);
        Lo(t.j, t.T, t.X, G(t));
        return !1;
    }
    if (i === t.M) {} else {
        const n = i.parent;
        t.X = i;
        vo(t.X, Te, s);
        vo(t.X, or, r);
        C(t.m, t.X, r);
        e && vo(e, s, t.X);
        Fo(t.j, t.X);
        Lo(t.j, t.T, t.X, G(t));
        n && ao(n) && !n.firstChild && Xo(n) === Xe && Wo(t.j, n.parent, n, !0);
    }
    return !0;
}

function tt(t) {
    const n = t.J;
    if (n) {
        for (const e of n.values()) {
            if (e.flags & 32) {
                continue;
            }
            qt(t.m, t.j, e, t.O);
            Wo(t.j, t.T, e, !0);
        }
        n.clear();
        t.J = null;
    }
    t.M = null;
}

function nt(t) {
    for (;t.W.length; ) {
        const n = t.W.shift();
        const e = t.W.shift();
        if (wr(n)) {
            return n.then(n => {
                z(t, n, e);
                return nt(t);
            }).catch(n => {
                t.m.handleError(n, e);
                return nt(t);
            });
        }
        z(t, n, e);
    }
    if (t.U.length) {
        const n = t.U.splice(0);
        return Promise.all(n).then(() => nt(t));
    }
}

function et(t) {
    t.j = null;
    t.O = null;
}

function rt(t, n = !0) {
    const e = t.M && Ho(t.M);
    if (e !== null) {
        let s = e;
        for (;s; ) {
            qt(t.m, t.j, s, t.O);
            s = s.nextSibling;
        }
        Uo(t.j, t.M, e, n);
    }
}

function st(t) {
    const n = F(t);
    if (t.M !== null && t.M !== n) {
        for (;t.M && t.M !== n; ) {
            const n = t.M;
            t.M = D(t, t.M);
            if (t.T === n.parent) {
                qt(t.m, t.j, n, t.O);
                Wo(t.j, t.T, n, !0);
            }
        }
    }
}

function it(t) {
    if (t.M !== null && $o(t.M)) {
        const n = t.M;
        t.M = D(t, t.M);
        Wo(t.j, t.T, n, !0);
    }
}

function ot(t, n, e) {
    if (xl(t)) {
        t.value = n;
        return !0;
    }
    if (typeof t === "function") {
        t(n);
        return !0;
    }
    if (t == null) {
        return !0;
    }
    throw we(15, [ e ]);
}

function lt(n, e, s, o, r) {
    return t(() => bc(o, e, s, n, r));
}

function ut(t, n, e, s, o) {
    const r = t.L;
    const i = s.then(t => x(n, e, P(e, t, r), o));
    t.U.push(i);
}

function ct(t, n) {
    if (n) {
        t.innerHTML = n + "";
        t.setAttribute(We, "html");
    }
}

function ft(t, n) {
    if (n && typeof n !== "string") {
        return !0;
    }
    t.value = function e(t) {
        let n = "";
        const e = t.length;
        let s = 0;
        let o = s;
        for (;s < e; s++) {
            const e = t.charCodeAt(s);
            if (e === 60) {
                n += t.substring(o, s) + "&lt;";
            } else if (e === 62) {
                n += t.substring(o, s) + "&gt;";
            } else if (e === 38) {
                n += t.substring(o, s) + "&amp;";
            } else if (e === 34) {
                n += t.substring(o, s) + "&quot;";
            } else {
                if (e !== 39) {
                    continue;
                }
                n += t.substring(o, s) + "&#39;";
            }
            o = s + 1;
        }
        return o === 0 ? t : n + t.substring(o);
    }(n || "");
    return !0;
}

function at(t, n, s, o) {
    const r = function i(t, n) {
        const s = Vo(t.T, !0);
        const o = e(s, n);
        const r = document;
        const i = o.elementNamespaceFlag === 0 ? r.createElement(n) : r.createElementNS(o.elementNamespace, n);
        t.X = oo(i, n);
        t.X.flags |= o.elementNamespaceFlag;
        return i;
    }(t, s);
    const c = t.X;
    const l = (c.flags & 512) !== 0;
    const {constProps: u} = n;
    if (u) {
        for (const n in u) {
            let e = u[n];
            if (Ar(n)) {
                ht(n, e, r, c, t);
                continue;
            }
            if (n === "ref" && ot(e, r, o)) {
                continue;
            }
            xl(e) && (e = lt(t.m, t.X, n, e, t.et.rt));
            if (wr(e)) {
                ut(t, r, n, e, l);
                continue;
            }
            if (n === cr) {
                ct(r, e);
                continue;
            }
            if (s === "textarea" && n === "value" && ft(r, e)) {
                continue;
            }
            x(r, n, P(n, e, t.L), l);
        }
    }
    const f = n.key;
    f && (t.X.key = f);
    if (t.L) {
        const e = zi.call(n.varProps, "class") || n.constProps && zi.call(n.constProps, "class");
        e || r.setAttribute("class", t.L);
    }
    Mo(t.j, t.T, t.X, L(t));
}

function ht(t, n, e, s, o) {
    const r = t.slice(2);
    if (Array.isArray(n)) {
        const t = n;
        const s = [];
        for (let n = 0; n < t.length; n++) {
            const e = t[n];
            if (Array.isArray(e)) {
                for (let t = 0; t < e.length; t++) {
                    const n = e[t];
                    n && s.push(j.bind(null, n));
                }
            } else {
                e && s.push(j.bind(null, e));
            }
        }
        s.length > 0 && ((e._qDispatch ||= {})[r] = s.length === 1 ? s[0] : s);
    } else {
        n && ((e._qDispatch ||= {})[r] = j.bind(null, n));
    }
    t.charAt(2) !== "e" && bo(o.j, s, t, "");
    (function i(t, n) {
        const e = window;
        e && (e._qwikEv ||= []).push(n);
    })(0, r);
}

function dt(t, n, e) {
    if (t.nt) {
        at(t, n, e, null);
    } else {
        const s = t.M && ao(t.M);
        const o = s && e === Xo(t.M);
        const r = n.key;
        const i = s && t.M.key;
        if (o && r === i) {
            $t(t, e, r);
        } else {
            const s = pt(e, r);
            yt(t, e, r, s, t.T) && at(t, n, e, null);
        }
    }
    const s = n.varProps;
    const o = t.X || t.M;
    s && function r(t, n, e, s) {
        t.nt || _o(t.m, n);
        const o = n.props;
        for (const r in e) {
            const i = e[r];
            if (o && zi.call(o, r)) {
                const e = o[r];
                if (i !== e) {
                    if (i instanceof Ms && e instanceof Ms && Rt(i, e)) {
                        continue;
                    }
                    Ji(t, n, r, i, s);
                }
            } else {
                i != null && Ji(t, n, r, i, s);
            }
        }
        if (o) {
            for (const r in o) {
                zi.call(e, r) || r.charAt(0) === ":" || Ar(r) || Ji(t, n, r, null, s);
            }
        }
    }(t, o, s, null);
}

const Ji = (t, n, e, s, o) => {
    if (Ar(e)) {
        ht(e, s, n.node, n, t);
        return;
    }
    if (e === tr || e === nr) {
        vo(n, e, s);
        n.flags |= 192;
        return;
    }
    const r = s;
    if (e === "ref") {
        const t = n.node;
        if (ot(s, t, o)) {
            return;
        }
    }
    const i = n[_r]?.get(e);
    if (xl(s)) {
        const o = s instanceof Ms ? s.ot() : s;
        if (i?.backRef?.has(o)) {
            return;
        }
        i && mn(t.m, i);
        const r = n;
        s = lt(t.m, r, e, o, t.et.it);
    } else {
        i && mn(t.m, i);
    }
    if (wr(s)) {
        const o = n;
        const i = s.then(n => {
            V(t.j, o, e, n, t.L, r);
        });
        t.U.push(i);
        return;
    }
    V(t.j, n, e, s, t.L, r);
};

function pt(t, n) {
    if (n == null) {
        return null;
    }
    return t ? t + ":" + n : n;
}

function $t(t, n, e) {
    const s = pt(n, e);
    if (s && t.J?.has(s)) {
        t.J.delete(s);
        return !0;
    }
    return !1;
}

function yt(t, n, e, s, o, r) {
    t.X = function i(t, n, e) {
        let s = null;
        if (t.B === null) {
            const o = t.M;
            if (o) {
                const s = ao(o) ? Xo(o) : null;
                const r = _t(o) || St(o, t.m.q);
                if (r === e && s === n) {
                    return o;
                }
            }
            t.B = new Map;
            t.H = [];
            const r = F(t);
            let i = t.M;
            for (;i && i !== r; ) {
                const o = ao(i) ? Xo(i) : null;
                const r = _t(i) || St(i, t.m.q);
                s === null && r == e && o == n ? s = i : r === null ? t.H.push(o, i) : t.B.set(pt(o, r), i);
                i = i.nextSibling;
            }
        } else if (e === null) {
            for (let e = 0; e < t.H.length; e += 2) {
                if (t.H[e] === n) {
                    s = t.H[e + 1];
                    t.H.splice(e, 2);
                    break;
                }
            }
        } else {
            const o = pt(n, e);
            const r = t.B.get(o);
            if (r) {
                s = r;
                t.B.delete(o);
            }
        }
        (function o(t, n) {
            if (!n) {
                if (t.M) {
                    const n = ao(t.M) ? Xo(t.M) : null;
                    const e = _t(t.M) || St(t.M, t.m.q);
                    if (e != null) {
                        const s = pt(n, e);
                        t.J ||= new Map;
                        t.J.set(s, t.M);
                        t.B?.delete(s);
                    }
                }
                return;
            }
            const e = F(t);
            let s = t.M;
            for (;s && s !== n && s !== e; ) {
                const n = ao(s) ? Xo(s) : null;
                const e = _t(s) || St(s, t.m.q);
                if (e != null) {
                    const o = pt(n, e);
                    t.J ||= new Map;
                    t.J.set(o, s);
                    t.B?.delete(o);
                }
                s = s.nextSibling;
            }
        })(t, s);
        return s;
    }(t, n, e);
    if (t.X) {
        s || Lo(t.j, o, t.X, L(t));
        t.M = t.X;
        t.X = null;
        return !1;
    }
    if (s != null) {
        const n = t.J?.get(s) || null;
        if (n) {
            t.J.delete(s);
            if (r && t.M) {
                const n = _t(t.M) || St(t.M, t.m.q);
                if (n != null) {
                    const e = ao(t.M) ? Xo(t.M) : null;
                    const s = pt(e, n);
                    if (s != null) {
                        t.J ||= new Map;
                        t.J.set(s, t.M);
                    }
                }
            }
            n !== t.M && Lo(t.j, o, n, L(t));
            t.M = n;
            t.X = null;
            return !1;
        }
    }
    return !0;
}

function mt(t, n, e) {
    const s = n === "F";
    const o = _t(t.M);
    const r = t.M && yo(t.M);
    const i = r && o === e && (!s || !!e);
    if (i) {
        $t(t, null, o);
        return;
    }
    if (e === null || t.nt) {
        Io(t.j, t.T, t.X = co(), G(t));
        t.X.key = e;
        return;
    }
    if (yt(t, null, e, pt(null, e), t.T, !0)) {
        Io(t.j, t.T, t.X = co(), G(t));
        t.X.key = e;
    }
}

function wt(t, n) {
    const e = n[Zc];
    let s = t.X || t.M;
    const o = t.G;
    if (e) {
        const n = o.props;
        let r = !1;
        const [i] = e;
        const c = i.lt;
        const l = St(s, t.m.q);
        const u = o.key || c;
        const f = _t(s) || l;
        const a = u === f;
        const h = c === l;
        if (a) {
            if (h) {
                $t(t, null, u);
            } else {
                vt(t, s, i, n);
                s = t.X;
                r = !0;
            }
        } else {
            if (yt(t, null, u, u, t.T)) {
                vt(t, s, i, n);
                r = !0;
            }
            s = t.X || t.M;
        }
        if (s) {
            const e = wo(s, Ge, t.m.q);
            if (!r) {
                const c = function l(t, n, e, s) {
                    let o = !1;
                    if (e) {
                        const t = Et(n[es], e[es], e[is], s, !1);
                        o ||= t;
                        const r = Et(n[rs], e[rs], e[is], s, !0);
                        o ||= r;
                        e[ss] = n[ss];
                    } else if (n) {
                        vo(t, Ge, n);
                        e = n;
                    }
                    return o;
                }(s, n, e, t.m);
                if (c && o.key == null) {
                    vt(t, s, i, n);
                    s = t.X;
                    r = !0;
                }
                r ||= c;
            }
            if (r) {
                vo(s, Ee, i);
                s.flags &= -33;
                ln(t.m, s, 4, t.O);
            }
        }
        (function d(t, n, e) {
            const s = Array.isArray(n) ? n : [ n ];
            const o = t => new Os(kt, null, null, [], 0, t);
            const r = [];
            if (e) {
                const t = e.props;
                if (t) {
                    for (const n in t) {
                        if (T(n)) {
                            const t = n;
                            Wi(r, t, o(t), 0);
                        }
                    }
                }
            }
            if (r.length === 0 && n == null) {
                return;
            }
            for (let t = 0; t < s.length; t++) {
                const n = s[t];
                const e = (Ls(n) && ds(n, Te) || "") + "";
                const i = Vi(r, e, 0);
                let c;
                i >= 0 ? c = r[i + 1] : r.splice(~i, 0, e, c = o(e));
                const l = n === !1;
                l || c.children.push(n);
            }
            for (let t = r.length - 2; t >= 0; t -= 2) {
                r.splice(t, 1);
            }
            J(t, r, !0);
        })(t, o.children, s);
    } else {
        const e = o.key;
        const r = _t(s);
        const i = e === r;
        const c = St(s, t.m.q);
        const l = c == null;
        if (s && !l || !s) {
            bt(t);
            s = t.X;
        } else if (i) {
            $t(t, null, e);
        } else {
            yt(t, null, e, e, t.T) && bt(t);
            s = t.X || t.M;
        }
        if (s) {
            let e = s;
            for (;e && (!yo(e) || wo(e, Ee, null) === null); ) {
                e = e.parent || bl(e);
            }
            const r = ii(t.m, s, e || t.m.rootVNode, n, o.props);
            t.W.push(r, s);
        }
    }
}

function vt(t, n, e, s) {
    n && yn(t.m, n);
    Io(t.j, t.T, t.X = co(), G(t));
    const o = t.G;
    vo(t.X, Ee, e);
    vo(t.X, Ge, s);
    t.X.key = o.key;
}

function bt(t) {
    Io(t.j, t.T, t.X = co(), G(t));
    const n = t.G;
    vo(t.X, Ge, n.props);
    n.key && (t.X.key = n.key);
}

function gt(t, n) {
    if (t.M !== null) {
        const e = wl(t.M);
        if (e === 3) {
            if (n !== zo(t.M)) {
                Bo(t.j, t.M, n);
                return;
            }
            return;
        }
    }
    Mo(t.j, t.T, t.X = uo(document.createTextNode(n), n), L(t));
}

function _t(t) {
    if (t == null || $o(t)) {
        return null;
    }
    return t.key;
}

function St(t, n) {
    if (t == null || $o(t)) {
        return null;
    }
    const e = wo(t, Ee, n);
    return e ? e.lt : null;
}

function kt() {}

function Et(t, n, e, s, o = !0) {
    if (xt(t) && xt(n)) {
        return !1;
    }
    e.m = s;
    let r = !1;
    if (t) {
        for (const s in t) {
            if (s === "children" || s === Ce) {
                continue;
            }
            if (!n || t[s] !== n[s]) {
                if (!o) {
                    return !0;
                }
                {
                    n && (n[s] = t[s]);
                    const o = hs(e, s);
                    o || (r = !0);
                }
            }
        }
    }
    if (n) {
        for (const s in n) {
            if (s === "children" || s === Ce) {
                continue;
            }
            if ((!t || !zi.call(t, s)) && o) {
                delete n[s];
                const t = hs(e, s);
                t || (r = !0);
            }
        }
    }
    return r;
}

function xt(t) {
    if (!t) {
        return !0;
    }
    return js(t);
}

function qt(t, n, e, s = null) {
    let o = e;
    const r = s && rn(s) ? d(s) : null;
    if ($o(e)) {
        Pt(o);
        return;
    }
    let i = null;
    for (;;) {
        r && o !== s && rn(o) && u(t, r, o);
        const c = o.flags;
        if (c & 3) {
            yn(t, o);
            Pt(o);
            const r = c & 2 && wo(o, Ee, null) !== null;
            if (r) {
                const e = t.getHostProp(o, Ke);
                if (e) {
                    for (let n = 0; n < e.length; n++) {
                        const r = e[n];
                        if (pe(r)) {
                            const n = kl(r);
                            if (n && r.h & 1) {
                                r.h |= 16;
                                ln(t, o, 64, s);
                                continue;
                            }
                            (r instanceof Kr || Dl(r)) && yn(t, r);
                            (n || r instanceof ns) && Di(r);
                        }
                    }
                }
                const r = o.props;
                if (r) {
                    const e = Object.keys(r);
                    for (let o = 0; o < e.length; o++) {
                        const i = e[o];
                        if (T(i)) {
                            const e = r[i];
                            if (e) {
                                r[i] = null;
                                const o = typeof e === "string" ? xo(t.rootVNode, e) : e;
                                let c = Ho(o);
                                for (;c; ) {
                                    qt(t, n, c, s);
                                    c = c.nextSibling;
                                }
                                Tt(n, o);
                            }
                        }
                    }
                }
            }
            const i = mo(o);
            if (i) {
                if (o === e) {
                    const t = Ho(o);
                    if (t) {
                        an(t, () => {});
                        return;
                    }
                }
            } else {
                const t = Ho(o);
                if (t) {
                    o = t;
                    continue;
                }
            }
        } else {
            c & 4 && Pt(o);
        }
        if (o === e) {
            return;
        }
        const l = o.nextSibling;
        if (l) {
            o = l;
            continue;
        }
        i = o.parent;
        for (;i; ) {
            if (i === e) {
                return;
            }
            const t = i.nextSibling;
            if (t) {
                o = t;
                break;
            }
            i = i.parent;
        }
        if (i == null) {
            return;
        }
    }
}

function Tt(t, n) {
    const e = n.parent;
    if (e) {
        const s = e.flags;
        s & 1 && Xo(e) === Xe && Wo(t, e, n, !0);
    }
}

function Pt(t) {
    t.flags |= 32;
}

function Rt(t, n) {
    if (t === n) {
        return !0;
    }
    return n.ut === t.ut && function e(t, n) {
        if (t === n) {
            return !0;
        }
        if (!t || !n || t.length !== n.length) {
            return !1;
        }
        for (let e = 0; e < t.length; e++) {
            if (t[e] !== n[e]) {
                return !1;
            }
        }
        return !0;
    }(n.ct, t.ct);
}

function At(t, n) {
    if (!(n instanceof Ms)) {
        return !1;
    }
    for (let e = 0; e < t.length; e++) {
        const s = t[e];
        if (s instanceof Ms && Rt(s, n)) {
            return !0;
        }
    }
    return !1;
}

function Nt(t, n, e, s) {
    const o = s(t, n);
    o.key = e;
    return o;
}

function Mt(t, n, e, s, o, r) {
    const i = Array(r - o + 1);
    for (let c = o; c <= r; c++) {
        const r = n[c] ?? (n[c] = e(t[c], c));
        i[c - o] = Nt(t[c], c, r, s);
    }
    return i;
}

function It(t, n, e) {
    let s = n ? n.previousSibling : t.lastChild;
    for (let t = 1; t < e && s; t++) {
        s = s.previousSibling;
    }
    return s;
}

function Ct(t, n, e, s, o, r, i) {
    const c = t;
    const l = o.length;
    const u = Ho(e);
    const f = W(c, n, s, null);
    const a = Array(l);
    if (u === null) {
        if (l > 0) {
            return Hi(c, n, Mt(o, a, r, i, 0, l - 1), e, null, null, s, null, !0, f);
        }
        return;
    }
    if (l === 0) {
        Uo(n, e, u, !0);
        return;
    }
    let h = 0;
    let d = l - 1;
    let p = u;
    for (;p && h <= d && p.key === (a[h] ??= r(o[h], h)); ) {
        p = p.nextSibling;
        h++;
    }
    if (p === null) {
        if (h > d) {
            return;
        }
        return Hi(c, n, Mt(o, a, r, i, h, d), e, null, null, s, null, !0, f);
    }
    if (h > d) {
        Uo(n, e, p, !0);
        return;
    }
    const $ = p.previousSibling;
    let y = e.lastChild;
    for (;y !== $ && d >= h && y.key === (a[d] ??= r(o[d], d)); ) {
        y = y.previousSibling;
        d--;
    }
    const m = y ? y.nextSibling : p;
    if (h > d) {
        let t = p;
        for (;t && t !== m; ) {
            const s = t.nextSibling;
            Wo(n, e, t, !0);
            t = s;
        }
        return;
    }
    if (y === $) {
        const t = m;
        return Hi(c, n, Mt(o, a, r, i, h, d), e, t, t, s, null, !0, f);
    }
    for (let t = h; t <= d; t++) {
        a[t] ??= r(o[t], t);
    }
    const w = d - h + 1;
    const b = new Map;
    for (let t = h; t <= d; t++) {
        b.set(a[t], t - h);
    }
    const v = function g(t, n = null) {
        const e = [];
        let s = t;
        for (;s; ) {
            e.push(s);
            if (s === n) {
                break;
            }
            s = s.nextSibling;
        }
        return e;
    }(p, y);
    const _ = [];
    const S = new Map;
    for (let t = 0; t < v.length; t++) {
        const s = v[t];
        const o = s.key;
        if (b.has(o)) {
            S.set(o, _.length);
            _.push(s);
        } else {
            Wo(n, e, s, !0);
        }
    }
    const k = new Int32Array(w);
    k.fill(-1);
    const E = [];
    const x = [];
    for (let t = 0; t < w; t++) {
        const n = S.get(a[h + t]);
        if (n !== void 0) {
            k[t] = n;
            x.push(t);
            E.push(n);
        }
    }
    const q = new Uint8Array(w);
    const T = function P(t) {
        const n = t.length;
        if (n === 0) {
            return [];
        }
        const e = [];
        const s = Array(n).fill(-1);
        for (let o = 0; o < n; o++) {
            const n = t[o];
            let r = 0;
            let i = e.length;
            for (;r < i; ) {
                const s = r + i >> 1;
                t[e[s]] < n ? r = s + 1 : i = s;
            }
            r > 0 && (s[o] = e[r - 1]);
            r === e.length ? e.push(o) : e[r] = o;
        }
        const o = [];
        let r = e[e.length - 1];
        for (;r !== -1; ) {
            o.push(r);
            r = s[r];
        }
        o.reverse();
        return o;
    }(E);
    for (let t = 0; t < T.length; t++) {
        q[x[T[t]]] = 1;
    }
    let R = d;
    let A = m;
    const M = () => {
        for (;R >= h; ) {
            const t = R - h;
            if (q[t] === 1) {
                A = _[k[t]];
                R--;
                continue;
            }
            const r = k[t];
            if (r !== -1) {
                const t = _[r];
                const s = A === null ? e.lastChild === t : t.nextSibling === A;
                s || Lo(n, e, t, A);
                A = t;
                R--;
                continue;
            }
            let l = R;
            for (;l > h; ) {
                const t = l - 1 - h;
                if (q[t] === 1 || k[t] !== -1) {
                    break;
                }
                l--;
            }
            const u = R - l + 1;
            const d = Hi(c, n, Mt(o, a, null, i, l, R), e, A, A, s, null, !0, f);
            return br(d, () => {
                const t = It(e, A, u);
                A = t;
                R = l - 1;
                return M();
            });
        }
    };
    return M();
}

function jt(t, n, e) {
    t.dirty &= -2;
    const s = n.getHostProp(t, Ke);
    if (!s || s.length === 0) {
        return;
    }
    let o;
    for (let r = 0; r < s.length; r++) {
        const i = s[r];
        if (i instanceof Sl) {
            const s = i;
            if (!(s.h & 4)) {
                continue;
            }
            if (s.h & 1) {
                (e.afterFlushTasks ||= []).push(s);
            } else {
                const r = !!(s.h & 8);
                const i = _l(s, n, t);
                wr(i) && (r ? o = o ? o.then(() => i) : i : (e.extraPromises ||= []).push(i));
            }
        }
    }
    return o;
}

function Ot(t, n) {
    const e = t.props ||= {};
    e[Ur] = n;
}

function Ft(t, n) {
    t.dirty &= -257;
    const e = function s(t) {
        const n = t.props;
        return n?.[Xr] ?? null;
    }(t);
    if (!e) {
        return;
    }
    (function o(t, n) {
        const e = t.props ||= {};
        e[Xr] = n;
    })(t, null);
    const r = t;
    const i = r.parent;
    const c = r.nextSibling;
    const l = Ao(n, document, r, e);
    const u = ao(r) && i || r;
    const f = u === r ? null : c;
    Mo(n, u, l, f);
    t.dirty &= -33;
    t.dirtyChildren = null;
}

function Lt(t, n, e, s) {
    t.dirty &= -3;
    const o = t;
    let r = function i(t) {
        const n = t.props;
        return n?.[Ur];
    }(t);
    if (!r) {
        return;
    }
    Ot(t, null);
    xl(r) && (r = r.value);
    return Bi(n, e, r, o, s, null);
}

function Dt(n, e, s, o) {
    n.dirty &= -5;
    const r = n;
    const i = e.getHostProp(r, Ee);
    if (!i) {
        return;
    }
    const c = e.getHostProp(r, Ge) || null;
    const l = vr(() => ii(e, r, r, i, c), n => {
        const i = e.getHostProp(r, Me);
        return t(() => Bi(e, s, n, r, o, mi(i)));
    }, t => {
        e.handleError(t, r);
    });
    if (wr(l)) {
        return l;
    }
    return;
}

function Vt(t, n, e, s, o, r = null) {
    n.push(Ii(t.node, e, s, r, (t.flags & 512) !== 0));
    o || (t.props && s == null ? delete t.props[e] : (t.props ||= {})[e] = s);
}

function Wt(t, n) {
    t.dirty &= -9;
    if (!(t.flags & 1)) {
        return;
    }
    const e = function s(t) {
        const n = t.props ||= {};
        return n[Wr] ?? null;
    }(t);
    if (!e || e.size === 0) {
        return;
    }
    const o = t;
    for (const [t, s] of e.entries()) {
        let e = s.value;
        xl(e) && (e = e.value);
        const r = s.isConst;
        Vt(o, n, t, e, r, s.scopedStyleIdPrefix);
    }
    (function r(t) {
        const n = t.props ||= {};
        delete n[Wr];
    })(t);
}

function Ut(t, n) {
    t.dirty &= -65;
    const e = n.getHostProp(t, Ke);
    if (!e || e.length === 0) {
        return;
    }
    for (let t = 0; t < e.length; t++) {
        const n = e[t];
        if (n instanceof Sl && n.h & 16) {
            n.h &= -17;
            const t = n;
            Di(t);
        }
    }
}

function Xt(n, e) {
    n.dirty &= -17;
    const s = e.getHostProp(n, zr);
    if (!s) {
        return;
    }
    const o = s.ft;
    const r = ie();
    r.m = e;
    return br(t(() => ee.call(s, r, s.$)), () => {
        if (s.h & 2) {
            s.h &= -3;
            return Rl(e, s, o);
        }
    });
}

function zt(t, n, e, s) {
    t.dirty &= -129;
    const o = t;
    const r = n.getHostProp(o, Ge) || null;
    if (!r) {
        return;
    }
    let i = ps(r, "items");
    xl(i) && (i = mc(i));
    const c = ps(r, "key$");
    const l = ps(r, "item$");
    const u = c.resolved;
    const f = l.resolved;
    if (u !== void 0 && f !== void 0) {
        return Ct(n, e, o, s, i, u, f);
    }
    return br(c.resolve(), t => br(l.resolve(), r => Ct(n, e, o, s, i, t, r)));
}

let Qi = null;

const Yi = (t, n, e) => {
    Qi || (Qi = t.insertBefore);
    Qi.call(t, n, e);
};

function Bt(t) {
    let n = null;
    let e = null;
    let s = null;
    const o = new Set;
    const r = () => {
        if (s) {
            if (s.length === 1) {
                Yi(n, s[0], e);
            } else {
                const t = n.ownerDocument || n;
                const o = t.createDocumentFragment();
                for (let t = 0; t < s.length; t++) {
                    o.appendChild(s[t]);
                }
                Yi(n, o, e);
            }
            s = null;
            n = null;
            e = null;
            o.clear();
        }
    };
    for (let i = 0; i < t.length; i++) {
        const c = t[i];
        if (c instanceof Ti) {
            if (n === c.parent && e === c.beforeTarget) {
                s || (s = []);
                s.push(c.target);
                o.add(c.target);
                continue;
            }
            if (!s) {
                n = c.parent;
                e = c.beforeTarget;
                s = [ c.target ];
                o.add(c.target);
                continue;
            }
            if (n === c.parent) {
                r();
                n = c.parent;
                e = c.beforeTarget;
                s = [ c.target ];
                o.add(c.target);
                continue;
            }
            if (o.has(c.target) || e && c.target === e || n && c.target === n) {
                r();
                n = c.parent;
                e = c.beforeTarget;
                s = [ c.target ];
                o.add(c.target);
                continue;
            }
            Yi(c.parent, c.target, c.beforeTarget);
            continue;
        }
        if (c instanceof Ei) {
            (o.has(c.target) || e && c.target === e || n && c.target === n) && r();
            c.target.remove();
            continue;
        }
        if (c instanceof xi) {
            (o.has(c.target) || e && c.target === e || n && c.target === n) && r();
            const t = c.target;
            t.textContent = "";
            continue;
        }
        if (c instanceof qi) {
            c.target.nodeValue = c.text;
        } else if (c instanceof Pi) {
            const t = c.target;
            const e = c.attrName;
            const s = c.attrValue;
            const o = s != null ? P(e, s, c.scopedStyleIdPrefix) : null;
            const i = o == null || o === !1;
            if (Gi(t, e)) {
                t[e] = Ki(o);
            } else if (e === cr) {
                n === t && r();
                t.innerHTML = o;
                t.setAttribute(We, "html");
            } else {
                i ? t.removeAttribute(e) : e === "value" && e in t ? t.value = o : x(t, e, o, c.isSvg);
            }
        }
    }
    r();
}

const Gi = (t, n) => {
    const e = n == "allowfullscreen" || n == "async" || n == "autofocus" || n == "autoplay" || n == "checked" || n == "controls" || n == "default" || n == "defer" || n == "disabled" || n == "formnovalidate" || n == "inert" || n == "ismap" || n == "itemscope" || n == "loop" || n == "multiple" || n == "muted" || n == "nomodule" || n == "novalidate" || n == "open" || n == "playsinline" || n == "readonly" || n == "required" || n == "reversed" || n == "selected";
    return e && n in t;
};

const Ki = t => {
    if (t === "false") {
        return !1;
    }
    return !!t;
};

const Zi = (t => () => queueMicrotask(t))(Qt);

const no = (t => {
    let n;
    if (typeof MessageChannel !== "undefined") {
        const e = new MessageChannel;
        e.port1.onmessage = () => t();
        n = () => e.port2.postMessage(null);
    } else {
        n = () => setTimeout(t);
    }
    return n;
})(Qt);

let eo = !1;

function Ht() {
    if (!eo) {
        eo = !0;
        Zi();
    }
}

function Jt() {
    if (!eo) {
        eo = !0;
        no();
    }
}

function Qt() {
    eo = !1;
    const t = performance.now();
    const n = t + 15;
    let e = null;
    for (;e = i(); ) {
        if (Yt(e, n)) {
            Jt();
            return;
        }
    }
}

function Yt(t, n) {
    const e = ue;
    const s = d(t);
    const r = s.promise;
    if (r) {
        return;
    }
    const i = s.container;
    if (!t.dirty) {
        Gt(i, t, s, e);
        return;
    }
    const c = s.journal ||= [];
    let u = null;
    for (;u = s.position; ) {
        if (s.promise) {
            return;
        }
        if (!(u.dirty & 511)) {
            __EXPERIMENTAL__.suspense && N(u);
            a(i, s, tn(u, t, i));
            continue;
        }
        if (u.flags & 32) {
            if (u.dirty & 64) {
                Ut(u, i);
            } else if (u.dirty & 32) {
                const n = Zt(i, s, u, t);
                if (n !== null) {
                    u = n;
                    continue;
                }
            }
            u.dirty &= -512;
            a(i, s, tn(u, t, i));
            continue;
        }
        let e;
        try {
            if (u.dirty & 1) {
                e = jt(u, i, s);
            } else if (u.dirty & 2) {
                e = Lt(u, i, c, t);
            } else if (u.dirty & 4) {
                e = Dt(u, i, c, t);
            } else if (u.dirty & 128) {
                e = zt(u, i, c, t);
            } else if (u.dirty & 8) {
                Wt(u, c);
            } else if (u.dirty & 16) {
                e = Xt(u, i);
            } else if (u.dirty & 32) {
                const n = Zt(i, s, u, t);
                if (n !== null) {
                    u = n;
                    continue;
                }
            } else {
                u.dirty & 256 && Ft(u, c);
            }
        } catch (t) {
            i.handleError(t, u);
        }
        if (e && wr(e)) {
            R(s, u);
            const n = e;
            s.promise = n;
            o(t, i);
            const r = u;
            n.catch(t => {
                s.promise === n && i.handleError(t, r);
            }).finally(() => {
                if (s.promise !== n) {
                    return;
                }
                s.promise = null;
                l(t, i);
                Ht();
            });
            return;
        }
        if (performance.now() >= n) {
            return !0;
        }
    }
    Gt(i, t, s, e);
}

function Gt(t, n, e, s) {
    if (!(n.dirty & 511)) {
        c(n, t);
        s || function o(t, n) {
            const e = d(t);
            const s = e.journal;
            if (s && s.length > 0) {
                Bt(s);
                e.journal = null;
            }
            (function o(t, n) {
                const e = n.afterFlushTasks;
                if (!e || e.length === 0) {
                    n.afterFlushTasks = null;
                    return;
                }
                let s;
                for (let n = 0; n < e.length; n++) {
                    const o = e[n];
                    const r = _l(o, t, o.ht);
                    wr(r) && (s = s ? s.then(() => r) : r);
                }
                s && (n.extraPromises ||= []).push(s);
                n.afterFlushTasks = null;
            })(n, e);
        }(n, t);
        (function r(t) {
            if (!__EXPERIMENTAL__.suspense) {
                return;
            }
            const n = t.boundaries;
            if (!n) {
                return;
            }
            t.boundaries = null;
            for (let t = 0; t < n.length; t++) {
                const e = n[t];
                e.pending.value = Math.max(0, e.pending.value - 1);
                e.version.value++;
            }
        })(e);
        if (e.extraPromises) {
            Promise.all(e.extraPromises).then(() => {
                Kt(t);
            });
            return;
        }
        Kt(t);
    }
}

function Kt(t) {
    t.dt();
}

function Zt(t, n, e, s) {
    const o = e.dirtyChildren;
    if (!o || o.length === 0) {
        e.dirty &= -33;
        N(e);
        return null;
    }
    (function r(t, n) {
        let e = 0;
        for (let s = 0; s < t.length; s++) {
            const o = t[s];
            if (o.parent === n) {
                if (e !== s) {
                    const n = t[e];
                    t[e] = o;
                    t[s] = n;
                }
                e++;
            }
        }
    })(o, e);
    e.nextDirtyChildIndex = 0;
    const i = tn(o[0], s, t);
    a(t, n, i);
    return i;
}

function tn(t, n, e) {
    if (t === n) {
        if (n.dirty & 511) {
            return n;
        }
        return null;
    }
    let s = null;
    t.slotParent && t.slotParent.dirty & 32 ? s = t.slotParent : t.parent && t.parent.dirty & 32 && (s = t.parent);
    if (!s) {
        if (n.dirty & 511) {
            return n;
        }
        return null;
    }
    const o = s.dirtyChildren;
    let r = s.nextDirtyChildIndex;
    const i = o.length;
    let c = i;
    for (;c-- > 0; ) {
        const t = o[r];
        if (t.dirty & 511) {
            if (e && nn(e, t)) {
                r++;
                r === i && (r = 0);
                continue;
            }
            s.nextDirtyChildIndex = (r + 1) % i;
            return t;
        }
        r++;
        r === i && (r = 0);
    }
    s.dirty &= -33;
    s.dirtyChildren = null;
    s.nextDirtyChildIndex = 0;
    __EXPERIMENTAL__.suspense && N(s);
    return tn(s, n, e);
}

function nn(t, n) {
    if (!__EXPERIMENTAL__.suspense) {
        return !1;
    }
    if (!n.props || !(or in n.props) || !t.getHostProp(n, or)) {
        return !1;
    }
    rn(n) || en(t, n, 0);
    return !0;
}

function en(t, n, e) {
    const o = {
        afterFlushTasks: null,
        extraPromises: null,
        journal: null,
        container: t,
        position: n,
        priority: e,
        promise: null,
        boundaries: null
    };
    (function r(t, n) {
        Vr.set(t, n);
    })(n, o);
    const i = n;
    i.flags |= 256;
    s(t, i);
    Ht();
    return i;
}

function rn(t) {
    return (t.flags & 256) !== 0;
}

function sn(t, n) {
    if (!(n.flags & 1)) {
        n.dirty & 8 && function e(t, n) {
            n.dirty &= -9;
            const e = n.getProp(Wr);
            if (!e || e.size === 0) {
                return;
            }
            for (const [s, o] of e.entries()) {
                let e = o.value;
                xl(e) && (e = e.value);
                const r = P(s, e, o.scopedStyleIdPrefix);
                t.addBackpatchEntry(n.id, s, r);
            }
        }(t, n);
        n.dirty & 16 && Xt(n, t);
        n.dirty &= -512;
        return;
    }
    let e = null;
    if (n.dirty & 1) {
        const s = function o(t, n) {
            n.dirty &= -2;
            const e = n.getProp(Ke);
            if (!e || e.length === 0) {
                return null;
            }
            let s = null;
            for (let o = 0; o < e.length; o++) {
                const r = e[o];
                if (r instanceof Sl) {
                    const e = r;
                    if (!(e.h & 4)) {
                        continue;
                    }
                    const o = _l(e, t, n);
                    s = s ? s.then(() => o) : o;
                }
            }
            return s;
        }(t, n);
        wr(s) && (e = s);
    }
    if (n.dirty & 128) {
        const s = async function o(t, n) {
            n.dirty &= -129;
            const e = n;
            const s = t.getHostProp(e, Ge) || null;
            if (!s) {
                return;
            }
            let o = ps(s, "items");
            xl(o) && (o = mc(o));
            const r = await ps(s, "key$").resolve();
            const i = await ps(s, "item$").resolve();
            const c = [];
            for (let t = 0; t < o.length; t++) {
                const n = o[t];
                const e = i(n, t);
                const s = r(n, t);
                e.key = s;
                c.push(e);
            }
            await t.renderJSX(c, {
                currentStyleScoped: null,
                parentComponentFrame: t.getComponentFrame(0)
            });
        }(t, n);
        e = e ? e.then(() => s) : s;
    }
    n.dirty &= -508;
    if (e) {
        return e;
    }
}

const ro = [];

function on(t) {
    for (let n = 0; n < ro.length; n++) {
        const e = ro[n];
        const s = ro[n + 1] || t;
        s.dirty |= 32;
        s.dirtyChildren ||= [];
        s.dirtyChildren.includes(e) || s.dirtyChildren.push(e);
    }
}

function ln(t, n, e, s = null) {
    const o = n.dirty;
    n.dirty |= e;
    if (function r() {
        return ue;
    }()) {
        const e = sn(t, n);
        wr(e) && (t.l = t.l ? t.l.then(() => e) : e);
        return;
    }
    const i = e & 511;
    if ((i ? o & 511 : o) || n === s) {
        return;
    }
    const c = n.slotParent || n.parent;
    if (s && i && c && !c.dirty) {
        (function e(t, n, s) {
            ro.push(n);
            let o = A(t, n);
            let r = n.slotParent || n.parent;
            for (;r; ) {
                const e = r.dirty & 511;
                const i = rn(r);
                __EXPERIMENTAL__.suspense && (o ||= A(t, r) || (e ? M(t, r) : null));
                if (r === s || e) {
                    I(n, o);
                    on(r);
                    if (i) {
                        const t = d(r);
                        t.position !== r && (t.position = n);
                    }
                    ro.length = 0;
                    return;
                }
                if (i) {
                    const t = d(r);
                    t.position !== r && (t.position = n);
                }
                ro.push(r);
                r = r.slotParent || r.parent;
            }
            ro.length = 0;
            ((t, ...n) => {
                const e = he(!1, t, ...n);
                debugger;
                throw e;
            })("Cursor root not found in current path!");
        })(t, n, s);
        return;
    }
    if (c && c.dirty & 511) {
        I(n, A(t, n) || M(t, c));
        i && (c.dirty |= 32);
        c.dirtyChildren ||= [];
        c.dirtyChildren.includes(n) || c.dirtyChildren.push(n);
        if (i && n.dirtyChildren) {
            const t = function e(t) {
                for (;t; ) {
                    if (rn(t)) {
                        return t;
                    }
                    t = t.parent || t.slotParent;
                }
                return null;
            }(n);
            if (t) {
                const e = d(t);
                let s = e.position;
                if (s) {
                    for (;s !== t; ) {
                        s = s.slotParent || s.parent;
                        if (s === n) {
                            e.position = n;
                            break;
                        }
                    }
                }
            }
        }
    } else {
        rn(n) ? I(n, A(t, n)) : function l(t, n) {
            ro.push(n);
            let e = __EXPERIMENTAL__.suspense ? A(t, n) : null;
            let s = n.slotParent || n.parent;
            for (;s; ) {
                const o = rn(s);
                __EXPERIMENTAL__.suspense && (e ||= A(t, s) || (o ? M(t, s) : null));
                if (o) {
                    I(n, e);
                    on(s);
                    ro.length = 0;
                    return !0;
                }
                ro.push(s);
                s = s.slotParent || s.parent;
            }
            I(n, e);
            ro.length = 0;
            return !1;
        }(t, n) || en(t, n, 0);
    }
}

function un(t, n) {
    t.push(n);
}

const so = (t, n) => {
    let e;
    for (;t && !(e = Object.getOwnPropertyDescriptor(t, n)?.get); ) {
        t = Object.getPrototypeOf(t);
    }
    return e || function() {
        return this[n];
    };
};

const io = t => {
    let n = null;
    return e => {
        n || (n = so(e, t));
        return n.call(e);
    };
};

const oo = (t, n, e = null) => {
    const s = new Or(e, -4087, null, null, null, null, null, null, t, n);
    t.vNode = s;
    return s;
};

const lo = t => {
    const n = new Or(null, -4095, null, null, null, null, void 0, void 0, t, void 0);
    t.vNode = n;
    return n;
};

const uo = (t, n) => {
    const e = new Fr(-4084, null, null, null, null, t, n);
    return e;
};

const co = () => {
    const t = new jr(null, -4094, null, null, null, null, null, null);
    return t;
};

const fo = t => t instanceof Cr;

const ao = t => (t.flags & 1) === 1;

const ho = t => {
    const n = t.flags;
    return (n & 5) !== 0;
};

const po = t => {
    const n = t.flags;
    return (n & 1) === 1 && t.firstChild !== void 0 && t.lastChild !== void 0;
};

const $o = t => (t.flags & 4) === 4;

const yo = t => (t.flags & 2) === 2;

const mo = t => {
    const n = t.flags;
    return (n & 2) === 2 && wo(t, Te, null) !== null;
};

const Fa = t => t;

const wo = (t, n, e) => {
    if (ao(t) || yo(t)) {
        const s = t.props?.[n] ?? null;
        if (typeof s === "string" && e) {
            const o = e(s);
            t.props[n] = o;
            return o;
        }
        return s;
    }
    return null;
};

const vo = (t, n, e) => {
    if (e == null && t.props) {
        delete t.props[n];
    } else {
        t.props ||= {};
        t.props[n] = e;
    }
};

const bo = (t, n, e, s, o = null) => {
    if (ao(n)) {
        vo(n, e, s);
        un(t, Ii(n.node, e, s, o, (n.flags & 512) !== 0));
    }
};

const go = t => {
    if (t.key) {
        return;
    }
    const n = Ko(t.node, ur);
    n && (t.key = n);
};

const _o = (t, n) => {
    if ((n.flags & 15) === 1) {
        const e = n;
        e.flags ^= 8;
        const s = e.node;
        const o = s.attributes;
        let r = !1;
        for (let n = 0; n < o.length; n++) {
            const i = o[n];
            const c = i.name;
            if (Ar(c)) {
                cn(i, c, t, s);
                continue;
            }
            if (r) {} else if (c !== ur && c) {
                if (c.startsWith(We)) {
                    const t = i.value;
                    t === "html" ? vo(e, "dangerouslySetInnerHTML", s.innerHTML) : t === "text" && "value" in s && vo(e, "value", s.value);
                } else {
                    const t = i.value;
                    vo(e, c, t);
                }
            } else {
                const t = i.value;
                t && (e.key = t);
                r = !0;
            }
        }
        wo(e, tr, null) === null && wo(e, nr, null) === null || (n.flags |= 64);
    }
};

const So = t => {
    if (t.gt === "_run") {
        const n = t.getCaptured()?.[0];
        if (ke(n)) {
            return n;
        }
    }
    return t;
};

function cn(t, n, e, s) {
    const o = t.value;
    const r = n.slice(2);
    const i = o.split("|");
    const c = [];
    for (let t = 0; t < i.length; t++) {
        const n = So(Pn(i[t], e));
        c.push(j.bind(null, n));
    }
    (s._qDispatch ||= {})[r] = c.length === 1 ? c[0] : c;
}

function fn(t, n, e) {
    let s = Ho(n);
    for (;s; ) {
        if ($o(s)) {
            Eo(t, s);
            e(s, n);
        } else {
            ao(s) ? e(s, n) : fn(t, s, e);
        }
        s = s.nextSibling;
    }
}

function an(t, n) {
    let e = t;
    if ($o(t)) {
        n?.(t, null);
        return;
    }
    let s = null;
    for (;;) {
        if (n?.(e, s)) {
            return;
        }
        const o = Ho(e);
        if (o) {
            e = o;
            continue;
        }
        if (e === t) {
            return;
        }
        const r = e.nextSibling;
        if (r) {
            e = r;
            continue;
        }
        s = e.parent;
        for (;s; ) {
            if (s === t) {
                return;
            }
            const n = s.nextSibling;
            if (n) {
                e = n;
                break;
            }
            s = s.parent;
        }
        if (s == null) {
            return;
        }
    }
}

const ko = (t, n, e) => {
    let s = t;
    for (;e && s && yo(s); ) {
        const t = n ? s.firstChild : s.lastChild;
        if (!t) {
            break;
        }
        if (t.flags & 5) {
            return t;
        }
        s = t;
    }
    for (;s; ) {
        let t = n ? s.nextSibling : s.previousSibling;
        if (t && t.flags & 5) {
            return t;
        }
        if (!t) {
            let e = s.parent;
            if (e && !yo(e)) {
                return null;
            }
            for (;e && !(t = n ? e.nextSibling : e.previousSibling); ) {
                e = e.parent;
                if (e && !yo(e)) {
                    return null;
                }
            }
            if (!t) {
                return null;
            }
            if ($o(t) && e && ao(e)) {
                return null;
            }
        }
        for (;t; ) {
            s = t;
            if (s.flags & 5 && pl(s)) {
                return s;
            }
            t = n ? s.firstChild : s.lastChild;
        }
    }
    return null;
};

const Eo = (t, n) => {
    const e = (t => t)(n);
    const s = e.flags;
    if ((s & 8) === 0) {
        const s = Do(n, !0);
        const o = e.node;
        const r = ul(s);
        let i = ko(n, !1, !0);
        const c = ko(n, !0, !0);
        const l = o || (c && ao(c) ? c.node : c?.node) || null;
        let u = l;
        for (;i && $o(i); ) {
            if ((i.flags & 8) === 0) {
                const n = r.createTextNode(i.text);
                un(t, Mi(n, s, u));
                u = n;
                i.node = n;
                i.flags |= 8;
            }
            i = ko(i, !1, !0);
        }
        i = n;
        for (;i && $o(i); ) {
            const n = ko(i, !0, !0);
            const e = !n || !$o(n);
            if ((i.flags & 8) === 0) {
                if (e && o) {
                    un(t, Ni(o, i.text));
                } else {
                    const n = r.createTextNode(i.text);
                    un(t, Mi(n, s, l));
                    i.node = n;
                }
                i.flags |= 8;
            }
            i = n;
        }
    }
};

const xo = (t, n) => {
    let e = t;
    const s = t.node;
    const {qVNodeRefs: o} = s;
    let r = -1;
    let i;
    if (typeof n === "string") {
        r = parseInt(n);
        i = o.get(r);
    } else {
        i = n;
        const t = i.vNode;
        if (t) {
            return t;
        }
    }
    if (fo(i)) {
        e = i;
    } else {
        let t = i;
        const n = [ i ];
        for (;t && t !== s && !t.vNode; ) {
            t = t.parentElement;
            n.push(t);
        }
        t.vNode && (e = t.vNode);
        for (let t = n.length - 2; t >= 0; t--) {
            e = Po(e, n[t]);
        }
        if (r != -1) {
            i.vNode = e;
            o.set(r, e);
        }
    }
    if (typeof n === "string") {
        const t = n.length;
        let s = Ro(n, t);
        let o = 0;
        for (;s < t; ) {
            const t = n.charCodeAt(s);
            o *= 26;
            if (t >= 97) {
                o += t - 97;
            } else {
                o += t - 65;
                e = qo(e, o);
                o = 0;
            }
            s++;
        }
    }
    return e;
};

const qo = (t, n) => {
    let e = Ho(t);
    for (;e.flags >>> 12 !== n; ) {
        e = e.nextSibling;
    }
    return e;
};

const To = [];

const Po = (t, n) => {
    let e = Ho(t);
    for (;e && (!(e instanceof Or) || e.node !== n); ) {
        if (yo(e)) {
            const t = e.nextSibling;
            const n = Ho(e);
            if (n) {
                t && To.push(t);
                e = n;
            } else {
                e = t || (To.length ? To.pop() : null);
            }
        } else {
            const t = e.nextSibling;
            e = t || t || To.pop();
        }
    }
    for (;To.length; ) {
        To.pop();
    }
    return e;
};

const Ro = (t, n) => {
    let e = 0;
    for (;e < n; ) {
        if (!(t.charCodeAt(e) <= 57)) {
            return e;
        }
        e++;
    }
    return n;
};

const Ao = (t, n, e, s) => {
    const o = n.createElement("errored-host");
    s && s instanceof Error && (o.props = {
        error: s
    });
    o.setAttribute("q:key", "_error_");
    const r = oo(o, "errored-host");
    if (ho(e)) {
        Lo(t, r, e, null);
    } else {
        const n = [];
        fn(t, e, t => {
            n.push(t);
        });
        for (let e = 0; e < n.length; e++) {
            Lo(t, r, n[e], null);
        }
    }
    return r;
};

const No = Bt;

const Mo = (t, n, e, s) => {
    const o = ao(n);
    o && Jo(n);
    const r = e.parent;
    if (e === s) {
        if (r) {
            return;
        }
        s = null;
    }
    Oo(t, r, n, e);
    const i = e.node;
    const c = n.flags & 32;
    const l = o ? n.node : Do(n, !1);
    l && !c && un(t, Mi(i, l, Co(t, n, s)?.node ?? null));
    jo(n, e, s);
    c && (e.flags |= 32);
};

const Io = (t, s, o, r) => {
    const i = ao(s);
    i && Jo(s);
    const c = o.parent;
    if (o === r) {
        if (c) {
            return;
        }
        r = null;
    }
    Oo(t, c, s, o);
    const l = s.flags & 32;
    const u = !i && s.flags & 2048 ? s.props?.[xe] : null;
    const f = u ? null : i ? s : Vo(s, !1);
    const a = u || f?.node;
    const h = Co(t, s, r);
    const d = h?.node ?? null;
    const p = mo(o);
    if (p && f && (f.flags & 1536) !== 0) {
        const i = Vo(s, !1);
        const c = Co(t, s, r)?.node ?? null;
        const {elementNamespace: l, elementNamespaceFlag: u} = e(i, o);
        fn(t, o, s => {
            if ($o(s)) {
                un(t, Mi(s.node, a, c));
            } else {
                if ((s.flags & 1536) !== u) {
                    const t = function o(t, s, r, i) {
                        let c = t;
                        let l = null;
                        let u = null;
                        let f = null;
                        for (;c; ) {
                            let o = null;
                            let a = null;
                            if (ao(c)) {
                                o = c.node;
                                const t = Xo(c);
                                const l = c.parent;
                                const h = u == null ? s : l && Vo(l, !0);
                                if (h) {
                                    const t = e(h, Xo(c));
                                    r = t.elementNamespace;
                                    i = t.elementNamespaceFlag;
                                }
                                const d = Ho(c);
                                a = n(o, t, r, !d);
                                o.remove();
                                u == null && (u = a);
                                f && f.appendChild(a);
                                c.node = a;
                                c.flags &= -1537;
                                c.flags |= i;
                                if (d) {
                                    c = d;
                                    f = a;
                                    continue;
                                }
                                if (Yo(o)) {
                                    const t = Kn(o);
                                    if (t) {
                                        const n = Ho(t.rootVNode);
                                        if (n) {
                                            c = n;
                                            f = a;
                                            continue;
                                        }
                                    }
                                }
                            }
                            if (c === t) {
                                return u;
                            }
                            const h = c.nextSibling;
                            if (h) {
                                c = h;
                                continue;
                            }
                            l = c.parent;
                            for (;l; ) {
                                if (l === t) {
                                    return u;
                                }
                                const n = l.nextSibling;
                                if (n) {
                                    c = n;
                                    return u;
                                }
                                l = l.parent;
                            }
                            if (l == null) {
                                return u;
                            }
                        }
                        return u;
                    }(s, i, l, u);
                    t && (s.node = t);
                }
                un(t, Mi(s.node, a, c));
            }
        });
    } else {
        a && !l && fn(t, o, n => {
            un(t, Mi(n.node, a, d));
        });
    }
    jo(s, o, r);
    l && (o.flags |= 32);
};

const Co = (t, n, e) => {
    let s = null;
    e == null ? yo(n) && (s = ko(n, !0, !1)) : s = yo(e) ? ko(e, !0, !0) : e;
    s && $o(s) && Eo(t, s);
    return s;
};

const jo = (t, n, e) => {
    const s = e ? e.previousSibling : t.lastChild;
    e ? e.previousSibling = n : t.lastChild = n;
    s ? s.nextSibling = n : t.firstChild = n;
    n.previousSibling = s;
    n.nextSibling = e;
    n.parent = t;
};

const Oo = (t, n, e, s) => {
    n && (s.previousSibling || s.nextSibling || n !== e) && Wo(t, n, s, !1);
};

const Fo = (t, n) => {
    let e = n;
    for (;e && yo(e); ) {
        e = e.lastChild;
    }
    e && $o(e) && (e.flags & 8) === 0 && Eo(t, e);
};

const Lo = (t, n, e, s) => {
    ho(e) ? Mo(t, n, e, s) : Io(t, n, e, s);
};

const Do = (t, n) => {
    for (;t && !ao(t); ) {
        if (t.flags & 2048) {
            return t.props?.[xe];
        }
        t = t.parent || (n ? t.slotParent : null);
    }
    return t ? t.node : null;
};

const Vo = (t, n) => {
    for (;t && !ao(t); ) {
        t = t.parent || (n ? t.slotParent : null);
    }
    return t;
};

const Wo = (t, n, e, s) => {
    $o(e) && Eo(t, e);
    if (s) {
        const s = wo(n, cr, null) !== null;
        if (s) {
            return;
        }
        ho(e) ? un(t, Ri(e.node)) : fn(t, e, n => {
            un(t, Ri(n.node));
        });
    }
    const o = e.previousSibling;
    const r = e.nextSibling;
    o ? o.nextSibling = r : n.firstChild = r;
    r ? r.previousSibling = o : n.lastChild = o;
    e.previousSibling = null;
    e.nextSibling = null;
};

const Uo = (t, n, e, s = !0) => {
    const o = Do(n, !0);
    if (o && s) {
        if (ho(n)) {
            un(t, Ai(n.node));
        } else {
            const e = Vo(n, !1);
            e && e.firstChild === n && e.lastChild === n ? un(t, Ai(o)) : fn(t, n, n => {
                un(t, Ri(n.node));
            });
        }
    }
    const r = e.previousSibling;
    r ? r.nextSibling = null : n.firstChild = null;
    n.lastChild = r;
};

const Xo = t => {
    const n = Fa(t);
    let e = n.elementName;
    if (e === void 0) {
        const t = n.node;
        const s = ll(t).toLowerCase();
        e = n.elementName = s;
        n.flags |= (t => {
            const n = ol(t);
            switch (n) {
              case Be:
                return 512;

              case He:
                return 1024;

              default:
                return 0;
            }
        })(t);
    }
    return e;
};

const zo = t => {
    let n = t.text;
    n === void 0 && (n = t.text = t.node.nodeValue);
    return n;
};

const Bo = (t, n, e) => {
    Eo(t, n);
    n.text = e;
    un(t, Ni(n.node, e));
};

const Ho = t => {
    if ($o(t)) {
        return null;
    }
    let n = t.firstChild;
    n === void 0 && (n = Jo(t));
    return n;
};

const Jo = t => {
    const n = Fa(t);
    let e = n.firstChild;
    if (e === void 0) {
        const t = n.node;
        e = n.parent && Yo(t) ? n.firstChild = n.lastChild = null : (t => {
            const n = t.node;
            const e = il(n);
            const s = ul(n)?.qVNodeData?.get(n);
            const o = ((t, n, e, s) => {
                go(t);
                if (s) {
                    if (s.charCodeAt(0) === xr && s.charCodeAt(1) === xr) {
                        const n = (t => {
                            const n = t.indexOf("||", 2);
                            const e = t.substring(2, n);
                            const s = t.substring(n + 2);
                            return {
                                elementVNodeData: e,
                                virtualVNodeData: s
                            };
                        })(s);
                        const o = n.elementVNodeData;
                        s = n.virtualVNodeData;
                        const r = cl(t, e, o);
                        if (!s) {
                            return r;
                        }
                    }
                    return function o(t, n, e, s) {
                        let o = 0;
                        let r = null;
                        let i = null;
                        let c = null;
                        const l = n => {
                            n.flags = n.flags & 4095 | o << 12;
                            o++;
                            i && (i.nextSibling = n);
                            n.previousSibling = i;
                            n.parent = t;
                            r || (t.firstChild = r = n);
                            i = n;
                        };
                        let u = 0;
                        let f = null;
                        let a = null;
                        const h = t => {
                            const n = vl(t);
                            return !n || n && $n(t);
                        };
                        let d = null;
                        fl(n, (p, $, y, m, w) => {
                            if ($l(p())) {
                                for (;h(s); ) {
                                    s = el(s);
                                    if (!s) {
                                        throw we(27, [ n, p(), w ]);
                                    }
                                }
                                f = null;
                                c = null;
                                let t = 0;
                                for (;$l(p()); ) {
                                    t *= 10;
                                    t += y() - 48;
                                }
                                for (;t--; ) {
                                    const e = lo(s);
                                    go(e);
                                    l(e);
                                    s = el(s);
                                    for (;vl(s) && $n(s); ) {
                                        s = el(s);
                                        if (!s && t > 0) {
                                            throw we(27, [ n, p(), w ]);
                                        }
                                    }
                                }
                            } else if (p() === 59) {
                                vo(t, Me, $());
                            } else if (p() === 60) {
                                (d ||= []).push(t);
                                vo(t, Ee, $());
                            } else if (p() === 61) {
                                a || (a = Gn(e));
                                const n = $();
                                a.bn(parseInt(n), t);
                            } else if (p() === 62) {
                                vo(t, Ge, $());
                            } else if (p() === 64) {
                                const n = m(w + 1) === xr;
                                let e;
                                if (n) {
                                    y();
                                    e = decodeURIComponent(q($()));
                                    y();
                                } else {
                                    e = $();
                                }
                                t.key = e;
                            } else if (p() === 91) {
                                vo(t, Ke, $());
                            } else if (p() === 94) {
                                vo(t, Ze, $());
                            } else if (p() === 96) {
                                a || (a = Gn(e));
                                dn(t, $(), a);
                            } else if (p() === 63) {
                                a || (a = Gn(e));
                                t.slotParent = xo(a.rootVNode, $());
                            } else if (p() === 93) {
                                vo(t, Ie, $());
                            } else if (p() === 123) {
                                y();
                                l(co());
                                ml.push(t, r, i, c, o);
                                o = 0;
                                t = i;
                                r = i = null;
                            } else if (p() === xr) {
                                const n = q($());
                                const e = q($());
                                vo(t, n, e);
                            } else if (p() === 125) {
                                y();
                                t.lastChild = i;
                                o = ml.pop();
                                c = ml.pop();
                                i = ml.pop();
                                r = ml.pop();
                                t = ml.pop();
                            } else if (p() === 126) {
                                const n = q($());
                                vo(t, Te, n);
                            } else {
                                for (;vl(s) && $n(s); ) {
                                    s = el(s);
                                }
                                const t = s && Zo(s) === 3 ? s : null;
                                if (f === null) {
                                    f = t ? t.nodeValue : null;
                                    u = 0;
                                }
                                let n = 0;
                                for (;yl(p()); ) {
                                    n += y() - 97;
                                    n *= 26;
                                }
                                n += y() - 65;
                                const e = f === null ? "" : f.substring(u, u + n);
                                l(c = ((t, n, e) => {
                                    const s = new Fr(-4092, null, t, null, null, n, e);
                                    return s;
                                })(c, t, e));
                                u += n;
                            }
                        });
                        if (d) {
                            a || (a = Gn(e));
                            for (let t = 0; t < d.length; t++) {
                                a.ensureProjectionResolved(d[t]);
                            }
                            d = null;
                        }
                        t.lastChild = i;
                        return r;
                    }(t, s, n, e);
                }
                return cl(t, e);
            })(t, n, e, s);
            return o;
        })(n);
    }
    return e;
};

let Qo = null;

const Yo = t => {
    Qo || (Qo = t.hasAttribute);
    return Qo.call(t, We);
};

let Go = null;

const Ko = (t, n) => {
    Go || (Go = t.getAttribute);
    return Go.call(t, n);
};

const Zo = io("nodeType");

const tl = t => {
    const n = Zo(t);
    return n === 3 || n === 1;
};

let nl = null;

const el = t => {
    nl || (nl = so(t, "nextSibling"));
    sl || (sl = so(t, "firstChild"));
    for (;t; ) {
        t = nl.call(t);
        if (t !== null) {
            const n = Zo(t);
            if (n === 3 || n === 1) {
                break;
            }
            if (n === 8) {
                const n = t.nodeValue;
                if (n?.startsWith(De)) {
                    return hn(t, Fe, nl, sl);
                }
                if (t.nodeValue?.startsWith(Le)) {
                    return hn(t, [ Fe, Ve ], nl, sl);
                }
                if (n?.startsWith(We)) {
                    for (;t && (t = nl.call(t)) && (Zo(t) !== 8 || !t.nodeValue?.startsWith(Ue)); ) {}
                }
            }
        }
    }
    return t;
};

function hn(t, n, e, s) {
    const o = typeof n === "string";
    const r = n.length;
    for (;t; ) {
        const i = t.nodeValue;
        let c;
        if (o) {
            c = i?.startsWith(n);
        } else {
            for (let t = 0; t < r; t++) {
                if (i?.startsWith(n[t])) {
                    c = !0;
                    break;
                }
            }
        }
        if (c) {
            t = e.call(t) || null;
            return t;
        }
        let l = s.call(t);
        l || (l = e.call(t));
        for (;!l; ) {
            l = rl(t);
            if (!l) {
                break;
            }
            t = l;
            l = e.call(l);
        }
        t = l;
    }
    return null;
}

const rl = io("parentNode");

let sl = null;

const il = t => {
    sl || (sl = so(t, "firstChild"));
    t = t && sl.call(t);
    if (t && Zo(t) === 8 && t.nodeValue?.startsWith(De)) {
        nl || (nl = so(t, "nextSibling"));
        return hn(t, Fe, nl, sl);
    }
    for (;t && !tl(t); ) {
        t = el(t);
    }
    return t;
};

const ol = io("namespaceURI");

const ll = io("nodeName");

const ul = io("ownerDocument");

const cl = (t, n, e) => {
    let s = null;
    const o = () => {
        for (;vl(r) && $n(r); ) {
            r = el(r);
        }
    };
    let r = n;
    o();
    let i = null;
    for (;r; ) {
        const n = Zo(r);
        let e = null;
        if (n === 3) {
            e = uo(r, r.textContent ?? void 0);
        } else if (n === 1) {
            e = lo(r);
            go(e);
        }
        if (e) {
            e.parent = t;
            i && (i.nextSibling = e);
            e.previousSibling = i;
            i = e;
        }
        s || (t.firstChild = s = i);
        r = el(r);
        o();
    }
    t.lastChild = i || null;
    t.firstChild = s;
    if (e) {
        let n = null;
        fl(e, (e, s) => {
            if (e() === 61) {
                n || (n = Gn(t.node));
                const e = s();
                n.bn(parseInt(e), t);
            } else if (e() === 96) {
                n || (n = Gn(t.node));
                dn(t, s(), n);
            } else {
                s();
            }
        });
    }
    return s;
};

function dn(t, n, e) {
    if (t[_r]) {
        const s = t[_r];
        ((t, n) => {
            for (const [e, s] of n) {
                t.set(e, s);
            }
        })(s, e.q(n));
    } else {
        Object.defineProperty(t, _r, {
            get() {
                const s = e.q(n);
                t[_r] = s;
                return s;
            },
            set(n) {
                Object.defineProperty(t, _r, {
                    value: n,
                    writable: !0,
                    enumerable: !0,
                    configurable: !0
                });
            },
            enumerable: !0,
            configurable: !0
        });
    }
}

const fl = (t, n) => {
    let e = 0;
    let s = 0;
    let o = 0;
    const r = n => n < t.length ? t.charCodeAt(n) : 0;
    const i = () => o !== 0 ? o : o = r(e);
    const c = () => {
        s = i();
        o = 0;
        e++;
        return s;
    };
    const l = () => {
        c();
        const n = e;
        for (;i() <= 58 && o !== 0 || o === 92 || o === 95 || o >= 65 && o <= 90 || o >= 97 && o <= 122; ) {
            c();
        }
        return t.substring(n, e);
    };
    for (;i() !== 0; ) {
        n(i, l, c, r, e);
    }
};

const al = (t, n) => {
    const e = n.flags;
    if ((e & 3) !== 0) {
        _o(t, n);
        const e = [];
        const s = n.props;
        if (s) {
            for (const t in s) {
                t.startsWith(ur) || e.push(t);
            }
        }
        return e;
    }
    return [];
};

const hl = (t, n) => {
    let e = dl(t);
    for (;e; ) {
        if (e === n) {
            return !0;
        }
        e = dl(e);
    }
    return !1;
};

const dl = t => t.parent || t.slotParent;

const pl = t => {
    if (t === null || yo(t)) {
        return null;
    }
    return t.node;
};

function pn(t = 20, n = "", e = !1, s = !1, o = !0, r = null) {
    if (this && !r) {
        try {
            r = function t(n) {
                let e = n;
                for (;e; ) {
                    if (ao(e)) {
                        const t = Zn(e.node);
                        if (!t) {
                            return null;
                        }
                        return Kn(t);
                    }
                    e = e.parent;
                }
                return null;
            }(this);
        } catch {}
    }
    let i = this;
    if (t === 0) {
        return "...";
    }
    if (i === null) {
        return "null";
    }
    if (i === void 0) {
        return "undefined";
    }
    const c = [];
    do {
        if ($o(i)) {
            c.push(_n(zo(i)));
        } else if (yo(i)) {
            const e = i.flags >>> 12;
            const s = [ "[" + e + "]" ];
            i.dirty && s.push(" dirty:" + i.dirty);
            if (r) {
                const t = al(r, i);
                for (let n = 0; n < t.length; n++) {
                    const e = t[n];
                    if (e !== kr && e !== "__scopedStyleIdPrefix__") {
                        const t = wo(i, e, null);
                        s.push(" " + e + "=" + _n(t));
                    }
                }
            }
            const l = (o ? "[34m" : "") + (Er[wo(i, kr, null) || "V"] || Er.V) + (o ? "[0m" : "");
            c.push("<" + l + s.join("") + ">");
            const u = Ho(i);
            u && c.push("  " + pn.call(u, t - 1, n + "  ", !0, !0, o));
            c.push("</" + l + ">");
        } else if (ao(i)) {
            const s = Xo(i);
            const l = [];
            rn(i) && l.push(" cursor");
            i.dirty && l.push(" dirty:" + i.dirty);
            i.dirtyChildren && l.push(` dirtyChildren[${i.dirtyChildren.length}]`);
            const u = r ? al(r, i) : [];
            for (let t = 0; t < u.length; t++) {
                const n = u[t];
                const e = wo(i, n, null);
                l.push(" " + n + "=" + _n(e));
            }
            const f = pl(i);
            if (f) {
                const t = ul(f).qVNodeData?.get(f);
                t && l.push(" q:vnodeData=" + _n(t));
            }
            const a = f.attributes;
            for (let t = 0; t < a.length; t++) {
                const n = a[t];
                u.indexOf(n.name) === -1 && l.push(" " + n.name + (n.value ? "=" + _n(n.value) : ""));
            }
            c.push("<" + s + l.join("") + ">");
            if (po(i) || e) {
                const e = Ho(i);
                e && c.push("  " + pn.call(e, t - 1, n + "  ", !0, !0, o));
            } else {
                c.push("  \x3c!-- not materialized --!>");
            }
            c.push("</" + s + ">");
        }
        i = s && i.nextSibling || null;
    } while (i);
    return c.join("\n" + n);
}

const $l = t => 48 <= t && t <= 57;

const yl = t => 97 <= t && t <= 122;

function $n(t) {
    return !t.hasAttribute(ur) || t.nodeName === "STYLE" && (t.hasAttribute(Me) || t.hasAttribute(Re));
}

const ml = [];

const wl = t => {
    const n = t.flags;
    if (n & 1) {
        return 1;
    }
    if (n & 2) {
        return 11;
    }
    if (n & 4) {
        return 3;
    }
    throw we(26, [ n ]);
};

const vl = t => t && typeof t == "object" && Zo(t) === 1;

const bl = t => {
    let n = 1;
    for (;n--; ) {
        for (;t && (!yo(t) || wo(t, Ee, null) === null); ) {
            const e = t.slotParent;
            const s = yo(t) && e;
            s && n++;
            t = s || t.parent;
        }
        n > 0 && (t = t.parent);
    }
    return t;
};

function yn(t, n) {
    fo(n) && ao(n) && Jo(n);
    const e = n[_r];
    if (!e) {
        return;
    }
    for (const [, n] of e) {
        mn(t, n);
    }
    e.clear();
}

function mn(t, n) {
    const e = n.backRef;
    if (!e) {
        return;
    }
    for (const s of e) {
        if (s instanceof ns) {
            vn(s, n);
        } else if (s instanceof Kr) {
            wn(t, s, n);
        } else if (ms(s)) {
            const t = s[is];
            bn(t, n);
        } else if (t.$t.has(s)) {
            const e = t.$t.get(s);
            const o = Cl(e);
            bn(o, n);
        }
    }
    e.clear();
}

function wn(t, n, e) {
    const s = n.ft;
    s && s.has(e) && s.delete(e);
    if (n instanceof Ms && !s?.size) {
        n.k = void 0;
        yn(t, n);
    }
}

function vn(t, n) {
    const e = t.ft;
    e && e.has(n) && e.delete(n);
    const s = t.yt;
    s && s.has(n) && s.delete(n);
    const o = t.wt;
    o && o.has(n) && o.delete(n);
    t.vt();
}

function bn(t, n) {
    const e = t?.ft;
    if (e) {
        for (const [t, s] of e.entries()) {
            if (s.has(n)) {
                s.delete(n);
                s.size === 0 && e.delete(t);
            }
        }
    }
}

const gl = (t, n) => {
    const {val: e, set: s, iCtx: o, i: r} = Ci();
    if (e) {
        return;
    }
    s(1);
    const i = n?.deferUpdates === !1 ? 0 : 8;
    const c = new Sl(6 | i, r, o.k, t, void 0, null);
    s(c);
    const l = o.m;
    const {Dt: u} = o;
    const f = br(u, () => _l(c, l, o.k));
    wr(f) && (o.Dt = f);
};

const _l = (t, n, e) => {
    const s = t.gn;
    if (s) {
        return s;
    }
    t.h &= -5;
    const o = t => n.handleError(t, e);
    let r = null;
    const i = br(((t, n) => {
        const e = t._n;
        if (e) {
            return e;
        }
        const s = t.yn;
        if (!s) {
            return;
        }
        t.yn = null;
        try {
            const e = s();
            if (wr(e)) {
                const s = Promise.resolve(e).then(() => {}, t => {
                    n(t);
                }).finally(() => {
                    t._n === s && (t._n = void 0);
                });
                t._n = s;
                return s;
            }
        } catch (t) {
            n(t);
        }
        return;
    })(t, o), () => {
        const s = ie(n.Ot, e, "qTask");
        s.m = n;
        const i = t.bt.getFn(s, () => yn(n, t));
        const c = Gr(t, n);
        const [l] = ((t, n) => {
            let e = null;
            return [ s => {
                if (typeof s == "function") {
                    if (!e) {
                        e = [];
                        t.yn = () => {
                            t.yn = null;
                            let s = null;
                            for (let t = 0; t < e.length; t++) {
                                const o = e[t];
                                try {
                                    const t = o();
                                    wr(t) && (s ||= []).push(t.catch(n));
                                } catch (t) {
                                    n(t);
                                }
                            }
                            e = null;
                            if (s?.length) {
                                return Promise.all(s).then(() => {});
                            }
                        };
                    }
                    e.push(s);
                }
            }, e ?? [] ];
        })(t, o);
        const u = {
            track: c,
            cleanup: l
        };
        return vr(() => i(u), l, s => {
            if (wr(s)) {
                return s.then(() => {
                    t.gn === r && (t.gn = null);
                    return _l(t, n, e);
                });
            }
            o(s);
        });
    });
    if (wr(i)) {
        r = i.finally(() => {
            t.gn === r && (t.gn = null);
        });
        t.gn = r;
        return r;
    }
    return i;
};

class Sl extends Sr {
    h;
    Sn;
    ht;
    bt;
    jt;
    yn;
    _n;
    gn=null;
    constructor(t, n, e, s, o, r) {
        super();
        this.h = t;
        this.Sn = n;
        this.ht = e;
        this.bt = s;
        this.jt = o;
        this.yn = r;
    }
}

const kl = t => t instanceof Sl;

function gn(t, n) {
    const e = Gn(n);
    typeof this === "string" && Cc(jc(e, this));
    const s = Ic._[0];
    s.h |= 4;
    ln(e, s.ht, 1);
}

const El = t => {
    const n = t.resolved;
    if (!n) {
        throw t.resolve();
    }
};

const xl = t => t instanceof Kr;

const ql = (t, n) => {
    t.add(n);
};

const Tl = (t, n) => {
    (t.backRef ||= new Set).add(n);
};

const Pl = (t, n) => {
    if (n?.serializationCtx) {
        const e = t.consumer;
        const s = t.property;
        let o = null;
        kl(e) ? o = e.bt : e instanceof Zr ? o = e.Xt : s === ":" && (o = n.getHostProp(e, Ee));
        o && n.serializationCtx.Mt.add(o);
    }
};

const Rl = (t, n, e) => {
    const s = ce;
    if (e) {
        const o = e => {
            const o = e.consumer;
            const r = e.property;
            if (kl(o)) {
                o.h |= 4;
                ln(t, o.ht, 1);
            } else if (o instanceof Kr) {
                o.invalidate();
            } else if (r === ":") {
                ln(t, o, 4);
            } else if (r === ".") {
                if (s) {
                    Ot(o, n);
                    ln(t, o, 2);
                }
            } else {
                const i = e.data;
                if (i instanceof Is) {
                    const e = i.data;
                    const c = {
                        isConst: e.st,
                        scopedStyleIdPrefix: e.L,
                        value: n
                    };
                    if (s) {
                        (function l(t, n, e) {
                            const s = t.props ||= {};
                            let o = s[Wr];
                            if (!o) {
                                o = new Map;
                                s[Wr] = o;
                            }
                            o.set(n, e);
                        })(o, r, c);
                    } else {
                        const t = o;
                        let n = t.getProp(Wr);
                        if (!n) {
                            n = new Map;
                            t.setProp(Wr, n);
                        }
                        n.set(r, c);
                    }
                    ln(t, o, 8);
                }
            }
        };
        const r = Array.from(e);
        for (let t = 0; t < r.length; t++) {
            o(r[t]);
        }
    }
};

const Al = t => pe(t) && typeof t[ec] === "function";

const Nl = t => {
    let n = 1;
    switch (t) {
      case "never":
        n |= 8;
        break;

      case "always":
        n |= 16;
        break;
    }
    return n;
};

const Ml = [];

function _n(t) {
    try {
        if (t === null) {
            return "null";
        }
        if (t === void 0) {
            return "undefined";
        }
        if (typeof t === "string") {
            return '"' + t + '"';
        }
        if (typeof t === "number" || typeof t === "boolean") {
            return t + "";
        }
        if (kl(t)) {
            return `Task(${_n(t.bt)})`;
        }
        if (ke(t)) {
            return `Qrl(${t.gt})`;
        }
        if (typeof t === "object" || typeof t === "function") {
            if (Ml.includes(t)) {
                return "*";
            }
            try {
                Ml.push(t);
                if (Array.isArray(t)) {
                    return fo(t) ? "(" + (wo(t, kr, null) || "vnode") + ")" : t.map(_n);
                }
                if (xl(t)) {
                    return t instanceof Ms ? "WrappedSignal" : t instanceof Zr ? "ComputedSignal" : "Signal";
                }
                if (Dl(t)) {
                    return "Store";
                }
                if (Ls(t)) {
                    return Il(t);
                }
                if (fo(t)) {
                    return "(" + (wo(t, kr, null) || "vnode") + ")";
                }
            } finally {
                Ml.pop();
            }
        }
    } catch (t) {
        console.error("ERROR in qwikDebugToString", t);
        return "*error*";
    }
    return t;
}

const Il = t => {
    if (Ls(t)) {
        if (typeof t.type === "function") {
            const n = t.type[Zc];
            if (n) {
                const [t] = n;
                return "Component(" + t.gt + ")";
            }
            return "Function(" + t.type.name + ")";
        }
        let n = "<" + t.type;
        if (t.props) {
            const e = Object.entries(t.props);
            for (let t = 0; t < e.length; t++) {
                const [s, o] = e[t];
                n += " " + s + "=" + _n(o);
            }
            const s = t.children;
            if (s != null) {
                n += ">";
                if (Array.isArray(s)) {
                    for (let t = 0; t < s.length; t++) {
                        const e = s[t];
                        n += Il(e);
                    }
                } else {
                    n += Il(s);
                }
                n += "</" + t.type + ">";
            } else {
                n += "/>";
            }
        }
        return n;
    }
    return t + "";
};

const Cl = t => t[Qr];

const jl = t => t?.[Jr] || null;

const Ol = (t, n) => {
    const e = Cl(t);
    e && e.force(n);
};

const Fl = (t, n) => {
    const e = Cl(t);
    if (e) {
        return (e.ft?.get(n)?.size ?? 0) > 0;
    }
    return !1;
};

const Ll = t => jl(t) || t;

const Dl = t => Jr in t;

function Sn(t, n, e) {
    return new Proxy(n, new Wl(e, t || null));
}

const Vl = (t, n, e) => {
    if (de(t) && e) {
        let s = e.$t.get(t);
        if (!s) {
            s = Sn(e, t, n);
            e.$t.set(t, s);
        }
        return s;
    }
    return t;
};

class Wl {
    h;
    m;
    ft=void 0;
    constructor(t, n) {
        this.h = t;
        this.m = n;
    }
    toString() {
        return "[Store]";
    }
    force(t) {
        const n = jl(this);
        Rl(this.m, this, xn(n, t, this.ft));
    }
    get(t, n) {
        if (typeof n === "symbol") {
            if (n === Jr) {
                return t;
            }
            if (n === Qr) {
                return this;
            }
            return t[n];
        }
        const e = dc();
        const s = t[n];
        if (e) {
            if (this.m === null) {
                if (!e.m) {
                    return s;
                }
                this.m = e.m;
            }
            const o = e.Lt;
            o && kn(t, Array.isArray(t) ? Yr : n, this, o);
        }
        if (n === "toString" && s === Object.prototype.toString) {
            return this.toString;
        }
        const o = this.h;
        if (o & 1 && pe(s) && !Object.isFrozen(s) && !Dl(s) && !Object.isFrozen(t)) {
            return Vl(s, this.h, this.m);
        }
        return s;
    }
    set(t, n, e) {
        if (typeof n === "symbol") {
            t[n] = e;
            return !0;
        }
        const s = this.h & 1 ? Ll(e) : e;
        if (n in t) {
            const e = t[n];
            s !== e && En(n, s, t, this);
        } else {
            En(n, s, t, this);
        }
        return !0;
    }
    deleteProperty(t, n) {
        if (typeof n != "string" || !delete t[n]) {
            return !1;
        }
        Array.isArray(t) || Rl(this.m, this, xn(t, n, this.ft));
        return !0;
    }
    has(t, n) {
        if (n === Jr) {
            return !0;
        }
        if (typeof n === "string") {
            const e = dc();
            if (e) {
                const s = e.Lt;
                s && kn(t, Array.isArray(t) ? Yr : n, this, s);
            }
        }
        return Object.prototype.hasOwnProperty.call(t, n);
    }
    ownKeys(t) {
        const n = dc();
        const e = n?.Lt;
        e && kn(t, Yr, this, e);
        return Reflect.ownKeys(t);
    }
    getOwnPropertyDescriptor(t, n) {
        const e = Reflect.getOwnPropertyDescriptor(t, n);
        if (Array.isArray(t) || typeof n === "symbol") {
            return e;
        }
        if (e && !e.configurable) {
            return e;
        }
        return {
            enumerable: !0,
            configurable: !0
        };
    }
}

function kn(t, n, e, s) {
    const o = e.ft ||= new Map;
    let r = o.get(n);
    if (!r) {
        r = new Set;
        o.set(n, r);
    }
    ql(r, s);
    Tl(s, t);
    ue && Pl(s, e.m);
}

function En(t, n, e, s) {
    e[t] = n;
    const o = xn(e, t, s.ft);
    o && Rl(s.m, s, o);
}

function xn(t, n, e) {
    let s;
    if (e) {
        if (Array.isArray(t)) {
            for (const t of e.values()) {
                s ||= new Set;
                for (const n of t) {
                    s.add(n);
                }
            }
        } else {
            s = e.get(n);
        }
    }
    const o = e?.get(Yr);
    if (o) {
        s ||= new Set;
        for (const t of o) {
            s.add(t);
        }
    }
    return s;
}

const Ul = ",";

const Xl = Symbol();

const zl = [ void 0, null, !0, !1, "", us, cs, Br, Yr, ls, oi, ri, NaN, Infinity, -Infinity, Number.MAX_SAFE_INTEGER, Number.MAX_SAFE_INTEGER - 1, Number.MIN_SAFE_INTEGER ];

const Bl = [ "undefined", "null", "true", "false", "''", "EMPTY_ARRAY", "EMPTY_OBJ", "NEEDS_COMPUTATION", "STORE_ALL_PROPS", "_UNINITIALIZED", "Slot", "Fragment", "NaN", "Infinity", "-Infinity", "MAX_SAFE_INTEGER", "MAX_SAFE_INTEGER-1", "MIN_SAFE_INTEGER" ];

const Hl = [ "Plain", "RootRef", "ForwardRef", "Constant", "Array", "Object", "URL", "Date", "Regex", "QRL", "VNode", "RefVNode", "BigInt", "URLSearchParams", "ForwardRefs", "TemporalDuration", "TemporalInstant", "TemporalPlainDate", "TemporalPlainDateTime", "TemporalPlainMonthDay", "TemporalPlainTime", "TemporalPlainYearMonth", "TemporalZonedDateTime", "Error", "Promise", "Set", "Map", "Uint8Array", "Task", "Component", "Signal", "WrappedSignal", "ComputedSignal", "AsyncSignal", "SerializerSignal", "Store", "FormData", "JSXNode", "PropsProxy", "SubscriptionData", "EffectSubscription" ];

function qn(t, n, e) {
    let s = n.gt;
    let o = n._t;
    const r = $r();
    if (r) {
        const t = r.chunkForSymbol(s, o);
        if (t) {
            o = t[1];
            s = t[0];
        }
    }
    const i = (t => ke(t) && t.gt == Se)(n);
    if (i) {
        const e = n.resolved;
        o = "";
        s = t.St(null, 0, e) + "";
    } else {
        o || (o = t.kt(n.lt));
        if (!o) {
            throw we(14, [ n.gt ]);
        }
        o.startsWith("./") && (o = o.slice(2));
    }
    const c = n.getCaptured();
    let l = null;
    c && c.length > 0 && (l = c.map(n => "" + t.Et(n)).join(" "));
    if (e) {
        return [ o, s, l ];
    }
    let u = `${o}#${s}`;
    l && (u += "#" + l);
    return u;
}

function Tn(t, n, e, s) {
    return Dc(t, n, null, null, e, s);
}

function Pn(t, n) {
    const [e, s, o] = t.split("#");
    return Tn(e, s, o || null, n);
}

class Jl {
    kn;
    En=0;
    qt=[];
    xn=0;
    qn=new Set;
    Tn=new Map;
    Pn;
    Rn=new Map;
    Ct;
    An=typeof Temporal !== "undefined";
    constructor(t) {
        this.kn = t;
        this.Ct = t.Ct;
    }
    async serialize() {
        await this.outputRoots();
    }
    outputArray(t, n, e) {
        this.Ct.write("[");
        let s = !1;
        let o;
        if (n) {
            o = t.length;
        } else {
            o = t.length - 1;
            for (;o >= 0 && t[o] === void 0; ) {
                o--;
            }
            o++;
        }
        for (let n = 0; n < o; n++) {
            s ? this.Ct.write(Ul) : s = !0;
            e(t[n], n);
        }
        this.Ct.write("]");
    }
    stringNeedsJsonEscape$(t) {
        for (let n = 0; n < t.length; n++) {
            const e = t.charCodeAt(n);
            if (e < 32 || e === 34 || e === 92) {
                return !0;
            }
        }
        return !1;
    }
    maybeNumericObjectKey$(t) {
        if (t.length === 0 || t.length >= 8) {
            return t;
        }
        let n = 0;
        if (t.charCodeAt(0) === 45) {
            if (t.length === 1) {
                return t;
            }
            n = 1;
        }
        const e = t.charCodeAt(n);
        if (e < 49 || e > 57) {
            return t;
        }
        for (n++; n < t.length; n++) {
            const e = t.charCodeAt(n);
            if (e < 48 || e > 57) {
                return t;
            }
        }
        return +t;
    }
    output(t, n, e) {
        if (typeof n === "number") {
            this.Ct.write(t + Ul + n);
        } else if (typeof n === "string") {
            const e = this.stringNeedsJsonEscape$(n) ? JSON.stringify(n) : '"' + n + '"';
            this.Ct.write(t + Ul);
            let s = -1;
            let o = 0;
            for (;(s = e.indexOf("</", o)) !== -1; ) {
                this.Ct.write(e.slice(o, s));
                this.Ct.write("<\\/");
                o = s + 2;
            }
            this.Ct.write(o === 0 ? e : e.slice(o));
        } else {
            this.Ct.write(t + Ul);
            this.outputArray(n, !!e, (t, n) => {
                this.writeValue(t, n);
            });
        }
    }
    getSeenRefOrOutput(t, n, e) {
        let s = this.kn.getSeenRef(t);
        const o = !e && this.Tn.get(t);
        if (!s) {
            if (e) {
                return !0;
            }
            if (typeof o !== "number") {
                return this.kn.Nn(t, this.Pn, n);
            }
            s = this.kn.Et(t, !0);
        }
        if (s.Pn) {
            if (this.Pn) {
                this.kn.Mn(s);
            } else {
                this.kn.Mn(s, n);
                t = this.kn.In[n];
            }
        }
        if (typeof o === "number") {
            this.qt[o] = s.Sn;
            this.Tn.delete(t);
        }
        const r = t instanceof nu ? t.Cn : s.Sn;
        if (!this.Pn && r === n) {
            return s;
        }
        this.output(1, r);
    }
    writeValue(t, n) {
        if (Zu(t)) {
            this.output(3, 0);
        } else {
            switch (typeof t) {
              case "undefined":
                this.output(3, 0);
                break;

              case "boolean":
                this.output(3, t ? 2 : 3);
                break;

              case "number":
                Number.isNaN(t) ? this.output(3, 12) : Number.isFinite(t) ? t === Number.MAX_SAFE_INTEGER ? this.output(3, 15) : t === Number.MAX_SAFE_INTEGER - 1 ? this.output(3, 16) : t === Number.MIN_SAFE_INTEGER ? this.output(3, 17) : this.output(0, t) : this.output(3, t < 0 ? 14 : 13);
                break;

              case "string":
                t.length === 0 ? this.output(3, 4) : (t.length < 4 || this.getSeenRefOrOutput(t, n)) && this.output(0, t);
                break;

              case "bigint":
                (t < 1e4 && t > -1e3 || this.getSeenRefOrOutput(t, n)) && this.output(12, "" + t);
                break;

              case "symbol":
                t === Br ? this.output(3, 7) : t === Yr ? this.output(3, 8) : t === ls ? this.output(3, 9) : t === Xl && this.output(3, 0);
                break;

              case "function":
                if (t === oi) {
                    this.output(3, 10);
                } else if (t === ri) {
                    this.output(3, 11);
                } else if (ke(t)) {
                    if (this.getSeenRefOrOutput(t, n)) {
                        const [n, e, s] = qn(this.kn, t, !0);
                        let o;
                        if (n !== "") {
                            o = `${this.kn.Et(n)}#${this.kn.Et(e)}${s ? "#" + s : ""}`;
                            const r = this.Rn.get(o);
                            if (r) {
                                const t = this.kn.Et(r);
                                this.output(1, t);
                                return;
                            }
                            this.Rn.set(o, t);
                        } else {
                            o = +e;
                        }
                        this.output(9, o);
                    }
                } else {
                    if (!tf(t)) {
                        throw we(34, [ "" + t ]);
                    }
                    {
                        const [n] = t[Zc];
                        this.kn.jn.add(n.gt);
                        this.output(29, [ n ]);
                    }
                }
                break;

              case "object":
                if (t === us) {
                    this.output(3, 5);
                } else if (t === cs) {
                    this.output(3, 6);
                } else if (t === null) {
                    this.output(3, 1);
                } else if (t instanceof nu) {
                    this.output(1, t.Cn);
                } else {
                    const e = this.getSeenRefOrOutput(t, n);
                    if (e) {
                        const n = this.Pn;
                        this.Pn = e;
                        this.writeObjectValue(t);
                        this.Pn = n;
                    }
                }
                break;

              default:
                throw we(20, [ typeof t ]);
            }
        }
    }
    writeObjectValue(t) {
        if (ms(t)) {
            const n = t[ss];
            this.output(38, [ Zl(n), n.varProps, n.constProps, t[is].ft ]);
        } else if (t instanceof Is) {
            this.output(39, [ t.data.L, t.data.st ]);
        } else if (t instanceof Hr) {
            this.output(40, [ t.consumer, t.property, t.data ]);
        } else if (Dl(t)) {
            const n = Cl(t);
            const e = jl(t);
            const s = n.h;
            const o = n.ft;
            const r = [];
            for (const t in e) {
                const n = e[t];
                const s = this.kn.$t.get(n);
                s && r.push(s);
            }
            const i = [ e, s, o, ...r ];
            for (;i[i.length - 1] === void 0; ) {
                i.pop();
            }
            this.output(35, i);
        } else if (Al(t)) {
            const n = t[ec](t);
            if (wr(n)) {
                const t = this.resolvePromise(n, (t, n) => new Ql(34, t, n, void 0, void 0));
                this.output(2, t);
            } else {
                const t = this.Pn.Sn;
                this.Pn = this.Pn.Pn;
                this.writeValue(n, t);
            }
        } else if (function n(t) {
            const n = Object.getPrototypeOf(t);
            return n == null || n === Object.prototype || n === Array.prototype;
        }(t)) {
            if (Array.isArray(t)) {
                this.output(4, t);
            } else {
                const n = [];
                for (const e in t) {
                    if (Object.prototype.hasOwnProperty.call(t, e)) {
                        const s = t[e];
                        Zu(s) || n.push(this.maybeNumericObjectKey$(e), s);
                    }
                }
                this.output(5, n.length ? n : 0);
            }
        } else if (this.kn.On(t)) {
            t.Fn.vnodeData[0] |= 16;
            this.output(11, t.Fn.id);
        } else if (t instanceof Kr) {
            if (t instanceof vs) {
                const n = function e(t, n) {
                    if (n === Br) {
                        return n;
                    }
                    return br(t.Xt.resolved || t.Xt.resolve(), t => {
                        let e;
                        typeof t === "function" && (t = t());
                        t.serialize ? e = t.serialize(n) : typeof n === "object" && ec in n && (e = n[ec](n));
                        e === void 0 && (e = Br);
                        return e;
                    });
                }(t, t.Wt);
                if (wr(n)) {
                    const e = this.resolvePromise(n, (n, e) => new Ql(34, n, e, t.ft, t.Xt));
                    this.output(2, e);
                } else {
                    this.output(34, [ t.Xt, t.ft, n ]);
                }
                return;
            }
            if (t instanceof Ms) {
                this.output(31, [ ...Rn(this.kn, t), t.h, t.k, ...t.ft || [] ]);
            } else if (t instanceof Zr) {
                let n = t.Wt;
                const e = t.h & 16;
                const s = t.h & 8;
                const o = t.h & 1;
                const r = Zu(t.Wt);
                const i = t instanceof ns;
                const c = i && t.Tt !== 0 ? t.Tt : void 0;
                const l = i && t.en !== 1 ? t.en : void 0;
                const u = i && t.sn !== 0 ? t.sn : void 0;
                const f = i && t.h & -25 || void 0;
                o || r ? n = Br : e ? n = t.Wt : s && (n = Br);
                const a = [ t.Xt, t.ft ];
                if (i) {
                    a.push(t.yt, t.wt, t.tn);
                    a.push(f || void 0);
                }
                n === Br && c === void 0 && l === void 0 && u === void 0 || a.push(n === void 0 ? Xl : n);
                if (i) {
                    a.push(c);
                    a.push(l);
                    a.push(u);
                }
                this.output(i ? 33 : 32, a);
            } else {
                const n = t.Wt;
                const e = [ n === void 0 ? Xl : n ];
                t.ft && e.push(...t.ft);
                this.output(30, e);
            }
        } else if (t instanceof URL) {
            this.output(6, t.href);
        } else if (t instanceof Date) {
            this.output(7, Number.isNaN(t.valueOf()) ? "" : t.valueOf());
        } else if (this.An && t instanceof Temporal.Duration) {
            this.output(15, t.toJSON());
        } else if (this.An && t instanceof Temporal.Instant) {
            this.output(16, t.toJSON());
        } else if (this.An && t instanceof Temporal.PlainDate) {
            this.output(17, t.toJSON());
        } else if (this.An && t instanceof Temporal.PlainDateTime) {
            this.output(18, t.toJSON());
        } else if (this.An && t instanceof Temporal.PlainMonthDay) {
            this.output(19, t.toJSON());
        } else if (this.An && t instanceof Temporal.PlainTime) {
            this.output(20, t.toJSON());
        } else if (this.An && t instanceof Temporal.PlainYearMonth) {
            this.output(21, t.toJSON());
        } else if (this.An && t instanceof Temporal.ZonedDateTime) {
            this.output(22, t.toJSON());
        } else if (t instanceof RegExp) {
            this.output(8, "" + t);
        } else if (t instanceof Error) {
            const n = [ t.message ];
            n.push(...Object.entries(t).flat());
            this.output(23, n);
        } else if (this.kn.Ln(t)) {
            const n = this.kn.Et(t);
            this.kn.Dn(t, "q:id", n + "");
            this.output(10, t.id);
            const e = t.vnodeData;
            if (e) {
                Yl(e, t => this.kn.Et(t));
                e[0] |= 16;
            }
            if (t.children) {
                const n = t.children.length;
                for (let e = 0; e < n; e++) {
                    const n = t.children[e];
                    const s = n.vnodeData;
                    s && (s[0] |= 16);
                }
            }
        } else if (typeof FormData !== "undefined" && t instanceof FormData) {
            const n = [];
            for (const [e, s] of t.entries()) {
                typeof s === "string" && n.push(e, s);
            }
            this.output(36, n);
        } else if (t instanceof URLSearchParams) {
            this.output(13, "" + t);
        } else if (t instanceof Set) {
            this.output(25, [ ...t.values() ]);
        } else if (t instanceof Map) {
            const n = [];
            for (const [e, s] of t.entries()) {
                n.push(e, s);
            }
            this.output(26, n);
        } else if (Ls(t)) {
            const n = [ t.type, t.key, t.varProps, t.constProps, t.children, t.toSort || void 0 ];
            for (;n[n.length - 1] === void 0; ) {
                n.pop();
            }
            this.output(37, n);
        } else if (t instanceof Sl) {
            const n = [ t.bt, t.h, t.Sn, t.ht, t.jt ];
            for (;n[n.length - 1] === void 0; ) {
                n.pop();
            }
            this.output(28, n);
        } else if (wr(t)) {
            const n = this.resolvePromise(t, (t, n) => new Ql(24, t, n));
            this.output(2, n);
        } else if (t instanceof Ql) {
            if (t.Vn === 34) {
                if (t.bt) {
                    this.output(34, [ t.bt, t.ft, t.Wn ]);
                } else {
                    if (!t.Un) {
                        console.error(t.Wn);
                        throw we(33);
                    }
                    {
                        const n = this.Pn.Sn;
                        this.Pn = this.Pn.Pn;
                        this.writeValue(t.Wn, n);
                    }
                }
            } else {
                this.output(24, [ t.Un, t.Wn ]);
            }
        } else if (t instanceof Uint8Array) {
            let n = "";
            const e = t.length;
            for (let s = 0; s < e; s++) {
                n += String.fromCharCode(t[s]);
            }
            const s = btoa(n).replace(/=+$/, "");
            this.output(27, s);
        } else if (t instanceof Kl) {
            const n = t.Xn;
            if (this.getSeenRefOrOutput(n, this.Pn.Sn, !0)) {
                let t = this.Tn.get(n);
                if (t === void 0) {
                    t = this.xn++;
                    this.Tn.set(n, t);
                    this.qt[t] = -1;
                }
                this.output(2, t);
            }
        } else {
            if (!fo(t)) {
                throw we(20, [ typeof t ]);
            }
            this.output(3, 0);
        }
    }
    resolvePromise(t, n) {
        const e = this.xn++;
        t.then(s => {
            this.qn.delete(t);
            this.qt[e] = this.kn.Et(n(!0, s));
        }).catch(s => {
            this.qn.delete(t);
            this.qt[e] = this.kn.Et(n(!1, s));
        });
        this.qn.add(t);
        return e;
    }
    async outputRoots() {
        this.Ct.write("[");
        const {In: t} = this.kn;
        for (;this.En < t.length || this.qn.size; ) {
            this.En !== 0 && this.Ct.write(Ul);
            let n = !1;
            for (;this.En < t.length; this.En++) {
                n ? this.Ct.write(Ul) : n = !0;
                this.writeValue(t[this.En], this.En);
            }
            if (this.qn.size) {
                try {
                    await Promise.race(this.qn);
                } catch {}
            }
        }
        if (this.qt.length) {
            let t = this.qt.length - 1;
            for (;t >= 0 && this.qt[t] === -1; ) {
                t--;
            }
            if (t >= 0) {
                this.Ct.write(Ul);
                this.Ct.write(14 + Ul);
                const n = t === this.qt.length - 1 ? this.qt : this.qt.slice(0, t + 1);
                this.outputArray(n, !0, t => {
                    this.Ct.write(t + "");
                });
            }
        }
        this.Ct.write("]");
    }
}

class Ql {
    Vn;
    Un;
    Wn;
    ft;
    bt;
    constructor(t, n, e, s, o) {
        this.Vn = t;
        this.Un = n;
        this.Wn = e;
        this.ft = s;
        this.bt = o;
    }
}

const Yl = (t, n) => {
    const e = t.length;
    for (let s = 0; s < e; s++) {
        const e = t[s];
        if (Gl(e)) {
            for (const t in e) {
                const s = e[t];
                if (s == null || typeof s === "string" || t === Ge && js(s)) {
                    continue;
                }
                n(s);
            }
        }
    }
};

const Gl = t => typeof t === "object" && t !== null && !js(t);

function Rn(t, n) {
    n.xt && n.xt[0] === "{" && (n.xt = `(${n.xt})`);
    const e = t.St(n.xt, n.ct.length, n.ut);
    return [ e, n.ct ];
}

class Kl {
    Xn;
    constructor(t) {
        this.Xn = t;
    }
}

const Zl = t => new Kl(t);

let tu = () => !1;

class nu {
    Cn;
    constructor(t) {
        this.Cn = t;
    }
}

class eu {
    NodeConstructor;
    DomRefConstructor;
    kt;
    Dn;
    $t;
    Ct;
    zn=new Map;
    Bn=new Map;
    Hn=[];
    In=[];
    Pt=new Set;
    Mt=new Set;
    Nt=new Set;
    jn=new Set;
    Jn;
    constructor(t, n, e, s, o, r) {
        this.NodeConstructor = t;
        this.DomRefConstructor = n;
        this.kt = e;
        this.Dn = s;
        this.$t = o;
        this.Ct = r;
        this.Jn = new Jl(this);
    }
    async It() {
        return await this.Jn.serialize();
    }
    getSeenRef(t) {
        return this.zn.get(t);
    }
    Nn(t, n, e) {
        const s = {
            Sn: e,
            Pn: n
        };
        this.zn.set(t, s);
        return s;
    }
    Qn(t) {
        const n = [];
        for (;t.Pn; ) {
            n.unshift(t.Sn);
            t = t.Pn;
        }
        n.unshift(t.Sn);
        return n.join(" ");
    }
    Mn(t, n) {
        const e = this.Qn(t);
        n === void 0 && (n = this.In.length);
        this.In[n] = new nu(e);
        t.Pn = null;
        t.Sn = n;
    }
    Et(t, n = !1) {
        let e = this.zn.get(t);
        let s;
        if (e) {
            e.Pn && this.Mn(e);
            s = e.Sn;
        } else {
            s = this.In.length;
            e = {
                Sn: s
            };
            this.zn.set(t, e);
            this.In.push(t);
        }
        return n ? e : s;
    }
    Ln(t) {
        return !!this.NodeConstructor && t instanceof this.NodeConstructor;
    }
    On(t) {
        return !!this.DomRefConstructor && t instanceof this.DomRefConstructor;
    }
    Yn(t) {
        const n = this.zn.get(t);
        return n && (n.Pn ? void 0 : n.Sn);
    }
    St(t, n, e) {
        const s = t == null;
        s && (t = e.serialized || "" + e);
        let o = this.Bn.get(t);
        if (o === void 0) {
            o = this.Hn.length;
            this.Bn.set(t, o);
            if (s) {
                this.Hn.push(t);
            } else {
                let e = "(";
                for (let t = 0; t < n; t++) {
                    e += (t == 0 ? "p" : ",p") + t;
                }
                this.Hn.push(e += ")=>" + t);
            }
        }
        return o;
    }
}

const ru = (t, n, e, s, o, r) => {
    if (!r) {
        const t = [];
        r = {
            write: n => {
                t.push(n);
            },
            toString: () => t.join("")
        };
    }
    tu = n ? t => t instanceof n : () => !1;
    return new eu(t, n, e, s, o, r);
};

const su = (t, n) => t[n];

const iu = (t, n = new WeakSet) => {
    const e = typeof Temporal !== "undefined";
    if (t == null || typeof t === "string" || typeof t === "number" || typeof t === "boolean" || typeof t === "bigint") {
        return !0;
    }
    if (typeof t === "object") {
        if (n.has(t)) {
            return !0;
        }
        n.add(t);
        const s = Object.getPrototypeOf(t);
        Dl(t) && (t = jl(t));
        if (s == Object.prototype) {
            for (const e in t) {
                if (!iu(mc(su, t, e), n)) {
                    return !1;
                }
            }
            return !0;
        }
        if (s == Array.prototype) {
            for (let e = 0; e < t.length; e++) {
                if (!(e in t)) {
                    return !1;
                }
                if (!iu(t[e], n)) {
                    return !1;
                }
            }
            return !0;
        }
        if (kl(t)) {
            return !0;
        }
        if (ms(t)) {
            return !0;
        }
        if (wr(t)) {
            return !0;
        }
        if (Ls(t)) {
            return !0;
        }
        if (Al(t)) {
            return !0;
        }
        if (t instanceof Error) {
            return !0;
        }
        if (t instanceof URL) {
            return !0;
        }
        if (t instanceof Date) {
            return !0;
        }
        if (e && t instanceof Temporal.Duration) {
            return !0;
        }
        if (e && t instanceof Temporal.Instant) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainDate) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainDateTime) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainMonthDay) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainTime) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainYearMonth) {
            return !0;
        }
        if (e && t instanceof Temporal.ZonedDateTime) {
            return !0;
        }
        if (t instanceof RegExp) {
            return !0;
        }
        if (t instanceof URLSearchParams) {
            return !0;
        }
        if (t instanceof FormData) {
            return !0;
        }
        if (t instanceof Set) {
            return !0;
        }
        if (t instanceof Map) {
            return !0;
        }
        if (t instanceof Uint8Array) {
            return !0;
        }
        if (t instanceof Is) {
            return !0;
        }
        if (tu?.(t)) {
            return !0;
        }
    } else if (typeof t === "function") {
        if (ke(t) || tf(t) || t === oi || t === ri) {
            return !0;
        }
    } else if (t === ls || t === Br || t === Yr) {
        return !0;
    }
    return !1;
};

const ou = (t, n) => {
    let e = fo(t) ? pn.call(t, 1, "", !0).replaceAll(/\n.*/gm, "") : typeof t === "function" ? t + "" : (t => {
        const n = new WeakSet;
        return JSON.stringify(t, (t, e) => {
            if (pe(e)) {
                if (n.has(e)) {
                    return `[Circular ${e.constructor.name}]`;
                }
                n.add(e);
            }
            return e;
        }, 2);
    })(t);
    e.length > 500 && (e = e.slice(0, 500) + '"...');
    e = e.replace(/\n/g, "\n" + n);
    return e.includes("\n") ? e = `\n${n}${e}` : e;
};

let lu = !1;

const uu = (t, n = !1, e = "", s = 20) => {
    const o = n ? "[31m" : "";
    const r = n ? "[0m" : "";
    const i = e === "";
    const c = [];
    for (let i = 0; i < t.length; i++) {
        if (s && i > 2 * s) {
            c.push("...");
            break;
        }
        const l = t[i];
        let u = t[++i];
        if (l === 0) {
            const t = typeof u !== "number" && typeof u !== "string";
            t && (lu = !0);
            const n = `{${pe(u) ? u.constructor.name : typeof u}}`;
            c.push(`${o}${n}${r} ${ou(u, e + "  ")}`);
        } else {
            if (l === 3) {
                u = fu(u);
            } else if (typeof u === "string") {
                u = JSON.stringify(u);
                u.length > 120 && (u = u.slice(0, 120) + '"...');
            } else {
                l === 14 ? u = `[\n${e}  ${u.join(`\n${e}  `)}\n${e}]` : Array.isArray(u) && (u = u.length ? `[\n${uu(u, n, e + "  ")}\n${e}]` : "[]");
            }
            c.push(`${o}${cu(l)}${r} ${u}`);
        }
    }
    const l = c.map((t, n) => `${e}${i ? n + " " : ""}${t}`).join("\n");
    if (i) {
        const n = lu ? "" : `(${JSON.stringify(t).length} chars)`;
        lu = !1;
        return `\n${l}\n${n}`;
    }
    return l;
};

const cu = t => Hl[t] || `Unknown(${t})`;

const fu = t => Bl[t] || `Unknown(${t})`;

function An(t, n) {
    const e = (t, n) => t === 1 && typeof n === "string";
    const s = t => t === 14;
    const o = n => {
        const e = t[n + 1].split(" ");
        let s = t;
        let o = 1;
        let r = 0;
        let i = 0;
        let c = null;
        for (let n = 0; n < e.length; n++) {
            c = s;
            r = parseInt(e[n], 10) * 2;
            i = r + 1;
            o = s[r];
            s = s[i];
            if (o === 1) {
                const n = s;
                const e = n * 2;
                o = t[e];
                s = t[e + 1];
            }
        }
        if (c) {
            c[r] = 1;
            c[i] = n / 2;
        }
        t[n] = o;
        t[n + 1] = s;
    };
    for (let r = 0; r < t.length; r += 2) {
        e(t[r], t[r + 1]) ? o(r) : s(t[r]) && (n.qt = t[r + 1]);
    }
}

const au = _e("resolvers", () => new WeakMap);

const hu = _e("pendingStoreTargets", () => new Map);

const du = (t, n, e) => {
    switch (n) {
      case 0:
        return e;

      case 1:
        return t.q(e);

      case 2:
        if (!t.qt) {
            return ls;
        }
        const s = t.qt[e];
        return s === -1 || s === void 0 ? ls : t.q(s);

      case 14:
        return e;

      case 3:
        return zl[e];

      case 4:
        return Array(e.length / 2);

      case 5:
        return {};

      case 9:
        {
            let n;
            if (typeof e === "string") {
                const [s, o, r] = e.split("#");
                const i = t.q(s);
                const c = t.q(o);
                n = Tn(i, c, r || null, t);
            } else {
                n = Tn("", e + "", null, t);
            }
            return n;
        }

      case 28:
        return new Sl(-1, -1, null, null, null, null);

      case 6:
        return new URL(e);

      case 7:
        return new Date(e);

      case 15:
        return Temporal.Duration.from(e);

      case 16:
        return Temporal.Instant.from(e);

      case 17:
        return Temporal.PlainDate.from(e);

      case 18:
        return Temporal.PlainDateTime.from(e);

      case 19:
        return Temporal.PlainMonthDay.from(e);

      case 20:
        return Temporal.PlainTime.from(e);

      case 21:
        return Temporal.PlainYearMonth.from(e);

      case 22:
        return Temporal.ZonedDateTime.from(e);

      case 8:
        const o = e.lastIndexOf("/");
        return RegExp(e.slice(1, o), e.slice(o + 1));

      case 23:
        return Error();

      case 29:
        return Kc(null);

      case 30:
        return new Kr(t, 0);

      case 31:
        return new Ms(t, null, null, null);

      case 32:
        return new Zr(t, null);

      case 33:
        return new ns(t, null, void 0, {});

      case 34:
        return new vs(t, null);

      case 35:
        {
            const n = e;
            const s = n[0];
            const o = n[1];
            const r = du(t, s, o);
            const i = Vl(r, 0, t);
            Xu(s) && hu.set(r, {
                t: s,
                v: o
            });
            n[0] = 0;
            n[1] = r;
            return i;
        }

      case 13:
        return new URLSearchParams(e);

      case 36:
        return new FormData;

      case 37:
        return new Os(null, null, null, null, 0, null);

      case 12:
        return BigInt(e);

      case 25:
        return new Set;

      case 26:
        return new Map;

      case 24:
        let r;
        let i;
        const c = new Promise((t, n) => {
            r = t;
            i = n;
        });
        au.set(c, [ r, i ]);
        c.catch(() => {});
        return c;

      case 27:
        const l = e.length;
        const u = l >>> 2;
        const f = l & 3;
        const a = u * 3 + (f ? f - 1 : 0);
        return new Uint8Array(a);

      case 38:
        return $(null);

      case 10:
        return Nn(t, e);

      case 11:
        const h = Nn(t, e);
        if (fo(h)) {
            Jo(h);
            return pl(h);
        }
        throw we(17, [ typeof h ]);

      case 39:
        return new Is({});

      case 40:
        return new Hr(null, null, null, null);

      default:
        throw we(18, [ n ]);
    }
};

function Nn(t, n) {
    return n ? t.rootVNode ? xo(t.rootVNode, n) : void 0 : t.element?.ownerDocument;
}

const pu = (t, n, e) => {
    let s = null;
    let o = null;
    if (me(t)) {
        o = t;
    } else {
        if (!ye(t)) {
            throw we(7, [ t ]);
        }
        s = t;
    }
    return Dc(s, n, null, o, e);
};

const $u = (t, n, e) => Dc(null, n, t, null, e);

const yu = (t, n) => Dc(null, t, null, null, n);

const mu = (t, n, e) => {
    const s = yu(t, e);
    return s;
};

const wu = (t, n, e, s) => Dc(t, e, null, n, s);

const vu = (t, n, e, s, o) => {
    const r = wu(t, n, e, o);
    r.Gn(s);
    return r;
};

const bu = (t, n, e, s) => {
    const o = pu(t, n, s);
    return o;
};

const gu = (t, n, e, s) => {
    const o = $u(t, n, s);
    return o;
};

const La = ue ? _e("regSymbols", () => new Map) : void 0;

const _u = (t, n) => {
    La.set(n, t);
    return t;
};

const Su = () => {
    const t = globalThis.process;
    return t?.getBuiltinModule?.("node:async_hooks")?.AsyncLocalStorage;
};

function Mn(t) {
    return t === null || typeof t === "string" || typeof t === "number" || typeof t === "boolean";
}

const ku = (t, n, e) => new Ms(null, t, n, e || null);

class Eu {
    Kn;
    $t;
    Ot;
    q;
    Vt;
    Zn=0;
    te=null;
    ne=null;
    l=null;
    u=null;
    o=0;
    constructor(t, n) {
        this.Vt = t;
        this.Ot = n;
        this.Kn = ve;
        this.$t = new WeakMap;
        this.q = () => {
            throw Error("Not implemented");
        };
    }
    trackSignalValue(t, n, e, s) {
        return bc(t, n, e, this, s);
    }
    serializationCtxFactory(t, n, e, s) {
        return ru(t, n, e, this.setHostProp.bind(this), this.$t, s);
    }
    dt() {
        if (this.o === 0) {
            this.u?.();
            this.l = null;
        }
    }
}

class xu {}

function In(t, n, e) {
    return () => {
        t.currentStyleScoped = n;
        t.parentComponentFrame = e;
    };
}

async function Cn(n, e, s) {
    const o = [ e ];
    const r = t => o.push(t);
    await (async () => {
        for (;o.length; ) {
            try {
                const e = o.pop();
                if (e === xu) {
                    const n = o.pop();
                    await t(() => o.push(n()));
                    continue;
                }
                if (typeof e === "function") {
                    e === Promise ? o.push(await o.pop()) : await e.apply(n);
                    continue;
                }
                jn(n, r, e, s);
            } finally {
                const t = n.streamHandler.waitForPendingFlush();
                wr(t) && await t;
            }
        }
    })();
}

function jn(t, n, e, s) {
    if (e == null) {
        t.textNode("");
    } else if (typeof e === "boolean") {
        t.textNode("");
    } else if (typeof e === "number") {
        t.textNode(e + "");
    } else if (typeof e === "string") {
        t.textNode(e);
    } else if (typeof e === "object") {
        if (Array.isArray(e)) {
            for (let t = e.length - 1; t >= 0; t--) {
                n(e[t]);
            }
        } else if (xl(e)) {
            (function s(t, n) {
                const e = n instanceof Ms ? n.ot() : n;
                if (e instanceof ns) {
                    const n = e.Tt;
                    if (n && !(e.h & 256)) {
                        t.Et(e);
                        t.Pt.add(e);
                    }
                }
            })(t.serializationCtx, e);
            t.openFragment(cs);
            const o = t.getOrCreateLastNode();
            const r = e instanceof Ms ? e.ot() : e;
            n(t.closeFragment);
            n(() => bc(r, o, ".", t));
            n(xu);
        } else if (wr(e)) {
            t.openFragment(cs);
            n(t.closeFragment);
            n(e);
            n(Promise);
            n(() => t.streamHandler.flush());
        } else if (function o(t) {
            return !!t[Symbol.asyncIterator];
        }(e)) {
            n(async () => {
                for await (const n of e) {
                    await Cn(t, n, {
                        currentStyleScoped: s.currentStyleScoped,
                        parentComponentFrame: s.parentComponentFrame
                    });
                    await t.streamHandler.flush();
                }
            });
        } else {
            const o = e;
            const r = o.type;
            if (typeof r === "string") {
                (function e(t, n) {
                    const e = ds(t, "class") != null;
                    if (!e && n) {
                        t.constProps || (t.constProps = {});
                        t.constProps.class = "";
                    }
                })(o, s.currentStyleScoped);
                let i = null;
                const c = t.openElement(r, o.key, o.varProps, o.constProps, s.currentStyleScoped, i, !!(o.flags & 4));
                c && t.htmlNode(c);
                n(t.closeElement);
                if (r === "head") {
                    t.emitQwikLoaderAtTopIfNeeded();
                    t.emitPreloaderPre();
                    n(t.additionalHeadNodes);
                } else if (r === "body") {
                    n(t.additionalBodyNodes);
                } else if (!t.isHtml && !t._didAddQwikLoader && !t.Rt) {
                    t.emitQwikLoaderAtTopIfNeeded();
                    t.emitPreloaderPre();
                    t._didAddQwikLoader = !0;
                }
                const l = o.children;
                l != null && n(l);
            } else if (me(r)) {
                if (r === ri) {
                    const e = o.key != null ? {
                        [Ye]: o.key
                    } : {};
                    t.openFragment(e);
                    n(t.closeFragment);
                    const s = o.children;
                    s != null && n(s);
                } else if (r === oi) {
                    const e = s.parentComponentFrame;
                    if (e) {
                        const r = e.componentNode.id || "";
                        const i = {};
                        const c = ds(o, or);
                        c && (i[or] = c);
                        i["q:sparent"] = r;
                        t.openProjection(i);
                        const l = e.componentNode;
                        const u = t.getOrCreateLastNode();
                        const f = function a(t, n, e) {
                            const s = n.constProps;
                            if (s && typeof s == "object" && "name" in s) {
                                const n = s.name;
                                if (n instanceof Ms) {
                                    return bc(n, t, ":", e);
                                }
                            }
                            return ds(n, "name") || "";
                        }(l, o, t);
                        i[Te] = f;
                        n(In(s, s.currentStyleScoped, s.parentComponentFrame));
                        n(t.closeProjection);
                        const h = o.children || null;
                        const d = e.consumeChildrenForSlot(u, f) || h;
                        h && d !== h && t.addUnclaimedProjection(e, "", h);
                        n(d);
                        n(In(s, e.projectionScopedStyle, e.projectionComponentFrame));
                    } else {
                        let n = cs;
                        t.openFragment(n);
                        t.closeFragment();
                    }
                } else if (r === ci) {
                    t.commentNode(ds(o, "data") || "");
                } else if (r === ai) {
                    t.streamHandler.flush();
                    const e = o.children;
                    let r;
                    r = me(e) ? e({
                        async write(n) {
                            await Cn(t, n, {
                                currentStyleScoped: s.currentStyleScoped,
                                parentComponentFrame: s.parentComponentFrame
                            });
                            await t.streamHandler.flush();
                        }
                    }) : e;
                    n(r);
                    wr(r) && n(Promise);
                } else if (r === ui) {
                    t.htmlNode(ds(o, "data"));
                } else if (r === fi) {
                    t.streamHandler.streamBlockStart();
                    n(() => t.streamHandler.streamBlockEnd());
                    n(o.children);
                } else if (tf(r)) {
                    const e = {};
                    t.openComponent(e);
                    const i = t.getOrCreateLastNode();
                    const c = t.getParentComponentFrame();
                    c.distributeChildrenIntoSlots(o.children, s.currentStyleScoped, s.parentComponentFrame);
                    const l = ((t, n, e) => {
                        const s = t.getOrCreateLastNode();
                        const [o] = e[Zc];
                        const r = n.props;
                        r && r.children && delete r.children;
                        s.setProp(Ee, o);
                        s.setProp(Ge, r);
                        n.key !== null && s.setProp(Ye, n.key);
                        return ii(t, s, s, o, r);
                    })(t, o, r);
                    n(In(s, s.currentStyleScoped, s.parentComponentFrame));
                    n(t.closeComponent);
                    if (wr(l)) {
                        n(async () => {
                            const t = await l;
                            const e = mi(i.getProp(Me));
                            n(t);
                            n(In(s, e, c));
                        });
                    } else {
                        n(l);
                        const t = mi(i.getProp(Me));
                        n(In(s, t, c));
                    }
                } else {
                    const e = {
                        [Ye]: o.key
                    };
                    t.openFragment(e);
                    n(t.closeFragment);
                    const s = t.getParentComponentFrame();
                    const i = ((t, n, e, s) => {
                        const o = t.getOrCreateLastNode();
                        return ii(t, o, n, e, s.props);
                    })(t, s && s.componentNode, r, o);
                    n(i);
                    wr(i) && n(Promise);
                }
            }
        }
    }
}

const qu = () => {
    const t = Ic._;
    return t;
};

const Tu = async t => {
    const [n, e] = Ic._;
    const s = await n(t);
    s && typeof s === "object" ? e.r ? Object.assign(e.r, s) : e.r = Sn(n.m, s, 1) : e.r = s;
    return {
        r: e.r
    };
};

const Pu = (t, n) => {
    const {val: e, set: s, iCtx: o} = Ci();
    if (e) {
        return e;
    }
    const r = Dc(null, "_rsc", Tu, null, [ t, {} ], o.m);
    const i = gs(r, {
        timeout: n?.timeout,
        container: o.m,
        concurrency: 0
    });
    i.$();
    const c = {
        __brand: "resource",
        signal: i,
        get value() {
            return i.promise().then(() => i.error ? Promise.reject(i.error) : i.value.r);
        },
        get loading() {
            return i.loading;
        }
    };
    s(c);
    return c;
};

const Ru = ({value: t, onResolved: n, onPending: e, onRejected: s}) => {
    if (wr(t)) {
        return t.then(n, s);
    }
    const o = Au(t);
    const r = o ? t.signal : t;
    if (e && r.loading) {
        return e();
    }
    if (s && r.error) {
        return s(r.error);
    }
    const i = o ? r.value?.r : r.value;
    return wr(i) ? i.then(n, s) : n(i);
};

const Au = t => t && t.__brand === "resource";

function On(t, n, e, s) {
    let o = null;
    const r = e;
    const i = t => {
        o = (o == null ? "" : o + "|") + t;
    };
    const c = n => {
        n.gt.startsWith("_") || !n.At?.length && !s || (n = Dc(null, "_run", O, null, [ n ]));
        return qn(t, n);
    };
    if (Array.isArray(r)) {
        for (let e = 0; e < r.length; e++) {
            const o = r[e];
            if (ke(o)) {
                i(c(o));
                Fn(t, n, o);
            } else if (o != null) {
                const e = On(t, n, o, s);
                e && i(e);
            }
        }
    } else if (ke(r)) {
        o = c(r);
        Fn(t, n, r);
    }
    return o;
}

function Fn(t, n, e) {
    const s = Ir(n);
    if (s) {
        const [n, o] = s;
        const r = ((t, n) => t + ":" + n)(n, o);
        t.Nt.add(r);
        t.Mt.add(e);
    }
}

const Nu = (t, n, e) => {
    Cu(e?.passive ? "q-ep:" : "q-e:", t, n, e);
};

const Mu = (t, n, e) => {
    Cu(e?.passive ? "q-dp:" : "q-d:", t, n, e);
};

const Iu = (t, n, e) => {
    Cu(e?.passive ? "q-wp:" : "q-w:", t, n, e);
};

const Cu = (t, n, e, s) => {
    const {isAdded: o, addEvent: r} = ju();
    if (o) {
        return;
    }
    if (e) {
        if (Array.isArray(n)) {
            for (let o = 0; o < n.length; o++) {
                const i = n[o];
                r(t + Mr(i), e, s);
            }
        } else {
            r(t + Mr(n), e, s);
        }
    }
};

const ju = () => {
    const t = $c();
    const n = t.k;
    const e = n;
    let s = t.m.getHostProp(e, rr);
    if (s === null) {
        s = {};
        t.m.setHostProp(e, rr, s);
    }
    let o = t.m.getHostProp(e, sr);
    o === null && (o = 0);
    t.m.setHostProp(e, sr, o + 1);
    let r = t.m.getHostProp(e, ir);
    if (r === null) {
        r = [];
        t.m.setHostProp(e, ir, r);
    }
    for (;r.length <= o; ) {
        r.push(!1);
    }
    return {
        isAdded: r[o],
        addEvent: (t, n, e) => {
            r[o] = !0;
            let i = s[t];
            i || (s[t] = i = {
                qrls: [],
                capture: !1,
                preventdefault: !1,
                stoppropagation: !1
            });
            i.qrls.push(n);
            e?.capture && (i.capture = !0);
            e?.preventdefault && (i.preventdefault = !0);
            e?.stoppropagation && (i.stoppropagation = !0);
        }
    };
};

const Ou = function(t, n) {
    if (!t.detail.files.some(t => n.getAttribute("data-qwik-inspector")?.startsWith(t))) {
        return;
    }
    if (typeof this === "string") {
        const t = Gn(n);
        Cc(jc(t, this));
    }
    const e = Ic._[0];
    const s = Gn(n);
    ln(s, e, 4);
    const o = n.ownerDocument;
    o.__hmrDone = o.__hmrT;
};

let Fu;

function Ln() {
    const t = dc();
    if (!t) {
        return;
    }
    Fu ||= $u(Ou, "_hmr");
    const n = t.k;
    const e = Fu.w([ n ]);
    Mu("qHmr", e);
}

function Dn(t, n, e, s, o) {
    const r = co();
    vo(r, Te, o);
    r.parent = n;
    vo(n, o, r);
    vo(r, Ee, e);
    vo(r, Ge, s);
    r.dirty = 4;
    en(t, r, 1);
    return r;
}

function Vn(t, n) {
    vo(t, xe, n);
    t.flags |= 2048;
}

function Wn(t, n, e) {
    vo(n, Ge, e);
    ln(t, n, 4);
}

function Un(t, n, e, s) {
    vo(n, s, null);
    const o = [];
    qt(t, o, e);
    No(o);
    if (e.flags & 2048) {
        const t = wo(e, xe, null);
        t && t.replaceChildren();
        vo(e, xe, null);
        e.flags &= -2049;
    }
}

const Lu = _e("loadingHolder", () => ({
    p: Promise.resolve()
}));

const Du = new Set([ "constructor", "prototype", "toString", "valueOf", "toJSON", "then" ]);

const Vu = (t, n) => {
    if (typeof t === "number") {
        return !0;
    }
    return typeof t === "string" && t !== "__proto__" && (typeof n !== "function" || !Du.has(t));
};

const Wu = (t, n, e, s) => {
    if (e === 0) {
        return;
    }
    e !== 4 && Array.isArray(s) && (s = Uu(t, s));
    switch (e) {
      case 4:
        Uu(t, s, n);
        break;

      case 5:
        if (s === 0) {
            break;
        }
        for (let t = 0; t < s.length; t += 2) {
            const e = s[t];
            const o = s[t + 1];
            if (!Vu(e, o)) {
                continue;
            }
            n[e] = o;
        }
        break;

      case 28:
        const o = n;
        const r = s;
        o.bt = r[0];
        o.h = r[1];
        o.Sn = r[2];
        o.ht = r[3];
        o.jt = r[4];
        break;

      case 29:
        n[Zc][0] = s[0];
        break;

      case 35:
        {
            const e = Ll(n);
            const o = hu.get(e);
            if (o) {
                hu.delete(e);
                Wu(t, e, o.t, o.v);
            }
            const [, r, i] = s;
            const c = Cl(n);
            c.h = r;
            c.ft = i;
            Bn(c.ft, e);
            break;
        }

      case 30:
        {
            const t = n;
            const e = s;
            t.Wt = e[0];
            t.ft = new Set(e.slice(1));
            zn(t.ft, t);
            break;
        }

      case 31:
        {
            const e = n;
            const o = s;
            e.ut = t.getSyncFn(o[0]);
            e.ct = o[1];
            e.Wt = Br;
            e.h = o[2];
            e.h |= 1;
            e.k = o[3];
            e.ft = new Set(o.slice(4));
            (function r(t) {
                if (t.k !== null && fo(t.k)) {
                    const n = t.k;
                    const e = t.ft;
                    let s = !1;
                    if (e) {
                        for (const o of e) {
                            const e = o.property;
                            if (ye(e)) {
                                const o = wo(n, e, null);
                                if (o !== null) {
                                    t.Wt = o;
                                    s = !0;
                                    break;
                                }
                            }
                        }
                    }
                    if (!s) {
                        const e = Ho(n);
                        e && n.firstChild === n.lastChild && $o(e) && (t.Wt = zo(e));
                    }
                }
            })(e);
            zn(e.ft, e);
            break;
        }

      case 33:
        {
            const t = n;
            const e = s;
            t.Xt = e[0];
            e[1] && (t.ft = new Set(e[1]));
            e[2] && (t.yt = new Set(e[2]));
            e[3] && (t.wt = new Set(e[3]));
            e[4] && (t.tn = e[4]);
            t.h = e[5] ?? 0;
            t.h & 64 && (t.Zt = !0);
            const o = e.length > 6;
            o && (t.Wt = e[6]);
            t.Wt === Br && (t.h |= 1);
            const r = e[7] ?? 0;
            t.expires = Math.abs(r);
            r < 0 && (t.h |= 256);
            if (e[8] !== void 0 && e[8] !== 1) {
                t.en = e[8] ?? 1;
                t.rn = [];
            }
            t.sn = e[9] ?? 0;
            zn(t.ft, t);
            zn(t.yt, t);
            zn(t.wt, t);
            break;
        }

      case 34:
      case 32:
        {
            const o = n;
            const r = s;
            o.Xt = r[0];
            const i = o.Xt.resolve(t).catch(() => {});
            Lu.p = Lu.p.finally(() => i);
            r[1] && (o.ft = new Set(r[1]));
            const c = r.length > 2;
            c && (o.Wt = r[2]);
            e !== 34 && o.Wt !== Br && (o.h &= -2);
            zn(o.ft, o);
            break;
        }

      case 23:
        {
            const t = s;
            n.message = t[0];
            for (let e = 1; e < t.length; e += 2) {
                n[t[e]] = t[e + 1];
            }
            break;
        }

      case 36:
        {
            const t = n;
            const e = s;
            for (let n = 0; n < e.length; n++) {
                t.append(e[n++], e[n]);
            }
            break;
        }

      case 37:
        {
            const t = n;
            const [e, o, r, i, c, l] = s;
            t.type = e;
            t.key = o;
            t.varProps = r;
            t.constProps = i || null;
            t.children = c;
            t.toSort = !!l;
            break;
        }

      case 25:
        {
            const t = n;
            const e = s;
            for (let n = 0; n < e.length; n++) {
                t.add(e[n]);
            }
            break;
        }

      case 26:
        {
            const t = n;
            const e = s;
            for (let n = 0; n < e.length; n++) {
                t.set(e[n++], e[n]);
            }
            break;
        }

      case 24:
        {
            const t = n;
            const [e, o] = s;
            const [r, i] = au.get(t);
            e ? r(o) : i(o);
            break;
        }

      case 27:
        const i = n;
        const c = atob(s);
        let l = 0;
        for (let t = 0; t < c.length; t++) {
            const n = c[t];
            i[l++] = n.charCodeAt(0);
        }
        break;

      case 38:
        const u = n;
        const f = s;
        let a = f[0];
        if (a === ls) {
            a = new Os(ri, f[1], f[2], null, 0, null);
            a._proxy = u;
        }
        u[ss] = a;
        const h = u[is];
        h.ft = f[3];
        Bn(h.ft, u);
        break;

      case 39:
        {
            const t = n;
            t.data.L = s[0];
            t.data.st = s[1];
            break;
        }

      case 40:
        {
            const t = n;
            const e = s;
            t.consumer = e[0];
            t.property = e[1];
            t.data = e[2];
            (function o(t) {
                const n = ue;
                const e = t.consumer;
                if (n && !e) {
                    return;
                }
                e[_r] ||= new Map;
                e[_r].set(t.property, t);
            })(t);
            break;
        }

      default:
        throw we(16, [ e ]);
    }
};

const Uu = (t, n, e = Array(n.length / 2)) => {
    for (let s = 0; s < n.length; s += 2) {
        e[s / 2] = Xn(t, n[s], n[s + 1]);
    }
    return e;
};

function Xn(t, n, e) {
    if (n === 0) {
        return e;
    }
    const s = du(t, n, e);
    Xu(n) && Wu(t, s, n, e);
    return s;
}

function zn(t, n) {
    if (t) {
        for (const e of t) {
            e.backRef ||= new Set;
            e.backRef.add(n);
        }
    }
}

function Bn(t, n) {
    if (t) {
        for (const [, e] of t) {
            zn(e, n);
        }
    }
}

const Xu = t => t >= 23 || t === 4 || t === 5;

const zu = _e("deserializedProxyMap", () => new WeakMap);

const Bu = Symbol();

const Hu = (t, n) => {
    if (!Array.isArray(n) || fo(n) || (t => pe(t) && Bu in t)(n)) {
        return n;
    }
    let e = zu.get(n);
    if (!e) {
        const s = Array(n.length / 2).fill(void 0);
        e = new Proxy(s, new Ju(t, n));
        zu.set(n, e);
    }
    return e;
};

class Ju {
    m;
    ee;
    re;
    constructor(t, n) {
        this.m = t;
        this.ee = n;
        this.re = this.ee.length / 2;
    }
    get(t, n, e) {
        if (n === Bu) {
            return t;
        }
        const s = typeof n === "number" ? n : typeof n === "string" ? parseInt(n, 10) : NaN;
        if (Number.isNaN(s) || s < 0 || s >= this.re) {
            return Reflect.get(t, n, e);
        }
        const o = s * 2;
        const r = this.ee[o];
        const i = this.ee[o + 1];
        if (r === 0) {
            return i;
        }
        const c = this.m;
        const l = du(c, r, i);
        Reflect.set(t, n, l);
        this.ee[o] = 0;
        this.ee[o + 1] = l;
        Xu(r) && Wu(c, l, r, i);
        return l;
    }
    has(t, n) {
        if (n === Bu) {
            return !0;
        }
        return Object.prototype.hasOwnProperty.call(t, n);
    }
    set(t, n, e, s) {
        if (n === Bu) {
            return !1;
        }
        const o = Reflect.set(t, n, e, s);
        const r = typeof n === "number" ? n : parseInt(n, 10);
        if (Number.isNaN(r) || r < 0 || r >= this.ee.length / 2) {
            return o;
        }
        const i = r * 2;
        this.ee[i] = 0;
        this.ee[i + 1] = e;
        return !0;
    }
}

async function Hn(t) {
    const n = ru(null, null, () => "", () => {}, new WeakMap);
    n.Et(t);
    await n.It();
    return "" + n.Ct;
}

function Jn(t) {
    if (t == null) {
        throw Error("No state data to deserialize");
    }
    const n = JSON.parse(t);
    if (!Array.isArray(n) || n.length < 2 || typeof n[0] !== "number") {
        throw Error("Invalid state data");
    }
    const e = Yn(n);
    return Xn(e, n[0], n[1]);
}

function Qn(t, n) {
    if (typeof t === "string") {
        t = parseInt(t, 10);
        return n[t];
    }
    return n[t];
}

function Yn(t) {
    let n;
    const e = {
        q: t => Qn(t, n),
        getSyncFn: () => () => {},
        $t: new WeakMap,
        element: null,
        qt: null
    };
    An(t, e);
    n = Hu(e, t);
    e.jt = n;
    return e;
}

const Qu = (t, n) => {
    const e = new WeakSet;
    return mc(Yu, t, e, "_", n);
};

const Yu = (t, n, e, s) => {
    const o = Ll(t);
    if (o == null) {
        return t;
    }
    if (Ku(o)) {
        if (typeof o === "object") {
            if (n.has(o)) {
                return t;
            }
            n.add(o);
        }
        if (xl(o)) {
            return t;
        }
        if (iu(o)) {
            return t;
        }
        if (o.__brand || o.__brand__) {
            return t;
        }
        const r = typeof o;
        switch (r) {
          case "object":
            if (wr(o)) {
                return t;
            }
            if ((t => t && typeof t.nodeType === "number")(o)) {
                return t;
            }
            if ($e(o)) {
                let s = 0;
                for (let t = 0; t < o.length; t++) {
                    if (!(t in o)) {
                        throw we(3, [ o ]);
                    }
                    const r = o[t];
                    if (t !== s) {
                        throw we(3, [ o ]);
                    }
                    Yu(r, n, e + "[" + t + "]");
                    s = t + 1;
                }
                return t;
            }
            if (o instanceof Cr) {
                return t;
            }
            if (de(o)) {
                for (const [t, s] of Object.entries(o)) {
                    Yu(s, n, e + "." + t);
                }
                return t;
            }
            break;
        }
        let i;
        i = s || "Value cannot be serialized";
        e !== "_" && (i += ` in ${e},`);
        if (r === "object") {
            i += ` because it's an instance of "${t?.constructor.name}". You might need to use 'noSerialize()' or use an object literal instead. Check out https://qwik.dev/docs/advanced/dollar/`;
        } else if (r === "function") {
            const n = t.name;
            i += ` because it's a function named "${n}". You might need to convert it to a QRL using $(fn):\n\nconst ${n} = $(${t + ""});\n\nPlease check out https://qwik.dev/docs/advanced/qrl/ for more information.`;
        }
        throw we(3, [ i ]);
    }
    return t;
};

const Gu = /*#__PURE__*/ new WeakSet;

const Ku = t => {
    if (pe(t) || me(t)) {
        return !Gu.has(t) && !(nc in t);
    }
    return !0;
};

const Zu = t => !!t && (pe(t) || typeof t === "function") && (Gu.has(t) || nc in t);

const tc = t => {
    (pe(t) && t !== null || typeof t === "function") && Gu.add(t);
    return t;
};

const nc = Symbol();

const ec = Symbol();

const rc = t => /*#__PURE__*/ Object.freeze({
    id: Mr(t)
});

const sc = (t, n) => {
    const {val: e, set: s, iCtx: o} = Ci();
    if (e !== void 0) {
        return;
    }
    o.m.setContext(o.k, t, n);
    s(1);
};

const ic = (t, n) => {
    const {val: e, set: s, iCtx: o} = Ci();
    if (e !== void 0) {
        return e;
    }
    const r = o.m.resolveContext(o.k, t);
    if (typeof n === "function") {
        return s(ee(void 0, n, r));
    }
    if (r !== void 0) {
        return s(r);
    }
    if (n !== void 0) {
        return s(n);
    }
    throw we(8, [ t.id ]);
};

const oc = t => {
    const n = pc();
    const e = n.k;
    if (!e) {
        return;
    }
    return n.m?.resolveContext(e, t);
};

const lc = /*#__PURE__*/ rc("qk-error");

const uc = t => 33 <= t && t <= 46;

const cc = (t, n, e) => {
    let s = 0;
    for (;n < e; ) {
        const e = t.charCodeAt(n);
        if (e === 92) {
            n += 2;
        } else {
            if (s === 0 && uc(e)) {
                break;
            }
            e === 123 ? s++ : e === 125 && s--;
            n++;
        }
    }
    return n;
};

function Gn(t) {
    const n = Zn(t);
    if (!n) {
        throw we(24);
    }
    return Kn(n);
}

function Kn(t) {
    const n = t;
    return n.qContainer ||= new fc(n);
}

function Zn(t) {
    return t.closest("[q\\:container]:not([q\\:container=html]):not([q\\:container=text])");
}

class fc extends Eu {
    element;
    qContainer;
    qManifestHash;
    rootVNode;
    document;
    $t=new WeakMap;
    se;
    te;
    qt=null;
    vNodeLocate=t => xo(this.rootVNode, t);
    ie;
    oe;
    le=null;
    constructor(t) {
        super({}, t.getAttribute("q:locale"));
        this.qContainer = t.getAttribute(We);
        if (!this.qContainer) {
            throw we(25);
        }
        this.document = t.ownerDocument;
        this.element = t;
        this.ne = t.getAttribute(Oe);
        this.te = t.getAttribute("q:instance");
        this.qManifestHash = t.getAttribute("q:manifest-hash");
        this.rootVNode = lo(this.element);
        this.ie = [];
        this.oe = [];
        const n = this.element.ownerDocument;
        n.qVNodeData || function e(t) {
            const n = "q:container";
            const e = "/" + n;
            const s = "q:ignore";
            const o = "/" + s;
            const r = "q:container-island";
            const i = "/" + r;
            const c = t;
            const l = c.qVNodeData || (c.qVNodeData = new WeakMap);
            const u = t.body;
            const f = u.getAttribute;
            const a = u.hasAttribute;
            const h = ((t, n) => {
                let e;
                for (;t && !(e = Object.getOwnPropertyDescriptor(t, n)?.get); ) {
                    t = Object.getPrototypeOf(t);
                }
                return e || function() {
                    return this[n];
                };
            })(u, "nodeType");
            const d = t => {
                const n = t.querySelectorAll('script[type="qwik/vnode"]');
                for (let t = 0; t < n.length; t++) {
                    const e = n[t];
                    const s = e.closest("[q\\:container]");
                    s.qVnodeData = e.textContent;
                    s.qVNodeRefs = new Map;
                }
                const e = t.querySelectorAll("[q\\:shadowroot]");
                for (let t = 0; t < e.length; t++) {
                    const n = e[t];
                    const s = n.shadowRoot;
                    s && d(s);
                }
            };
            d(t);
            const p = t => {
                const c = h.call(t);
                if (c === 1) {
                    const e = f.call(t, n);
                    if (e === null) {
                        if (a.call(t, "q:shadowroot")) {
                            return 6;
                        }
                        const n = a.call(t, ":");
                        return n ? 2 : 0;
                    }
                    return 3;
                }
                if (c === 8) {
                    const c = t.nodeValue || "";
                    if (c.startsWith(r)) {
                        return 65;
                    }
                    if (c.startsWith(s)) {
                        return 16;
                    }
                    if (c.startsWith(n)) {
                        return 9;
                    }
                    if (c.startsWith(i)) {
                        return 64;
                    }
                    if (c.startsWith(o)) {
                        return 32;
                    }
                    if (c.startsWith(e)) {
                        return 8;
                    }
                }
                return 0;
            };
            const $ = t => {
                for (;t && (t = t.nextSibling) && p(t) === 0; ) {}
                return t;
            };
            const y = (n, e, s, o, r, i) => {
                const c = r.length;
                let u = 0;
                let f = -1;
                let a = 0;
                let h = 0;
                let d = 0;
                let m = -1;
                let w = null;
                const b = () => {
                    let t = 0;
                    for (;uc(d = r.charCodeAt(a)); ) {
                        t += 1 << d - 33;
                        a++;
                        if (a >= c) {
                            break;
                        }
                    }
                    return t;
                };
                do {
                    if (s === o) {
                        return;
                    }
                    w = null;
                    const v = s == e ? 2 : p(s);
                    if (v === 3) {
                        const t = s;
                        let e = s;
                        for (;e && !(w = $(e)); ) {
                            e = e.parentNode;
                        }
                        y(n, t, s, w, t.qVnodeData || "", t.qVNodeRefs);
                    } else if (v === 16) {
                        let t = s;
                        do {
                            t = n.nextNode();
                            if (!t) {
                                throw Error(`Island inside \x3c!--${s?.nodeValue}--\x3e not found!`);
                            }
                        } while (p(t) !== 65);
                        w = null;
                    } else if (v === 64) {
                        w = s;
                        let t;
                        do {
                            w = n.nextNode();
                            if (!w) {
                                throw Error("Ignore block not closed!");
                            }
                            t = p(w);
                        } while (t !== 32 && t !== 65);
                        w = null;
                    } else if (v === 9) {
                        w = s;
                        do {
                            w = $(w);
                            if (!w) {
                                throw Error(`\x3c!--${s?.nodeValue}--\x3e not closed!`);
                            }
                        } while (p(w) !== 8);
                        y(n, s, s, w, "", null);
                    } else if (v === 6) {
                        w = $(s);
                        const n = s;
                        const e = n?.shadowRoot;
                        e && y(t.createTreeWalker(e, 129), null, e, null, "", null);
                    }
                    if ((v & 2) === 2) {
                        if (f < u) {
                            f === -1 && (f = 0);
                            a = h;
                            if (a < c) {
                                f += b();
                                const t = d === 126;
                                if (t) {
                                    m = f;
                                    a++;
                                    d = a < c ? r.charCodeAt(h) : 33;
                                }
                                h = cc(r, a, c);
                            } else {
                                f = Number.MAX_SAFE_INTEGER;
                            }
                        }
                        if (u === f) {
                            m === u && i.set(u, s);
                            const t = r.substring(a, h);
                            l.set(s, t);
                        }
                        u++;
                    }
                } while (s = w || n.nextNode());
            };
            const m = t.createTreeWalker(t, 129);
            y(m, null, m.firstChild(), null, "", null);
        }(n);
        this.se = je(n, this.te) || us;
        this.ue();
        t.setAttribute(We, "resumed");
        t.qContainer = this;
        t.qDestroy = () => this.yn();
        const s = t.querySelectorAll('script[type="qwik/state"]');
        if (s.length !== 0) {
            const t = s[s.length - 1];
            this.ie = JSON.parse(t.textContent);
            An(this.ie, this);
            this.oe = Hu(this, this.ie);
        }
        this.ce();
        t.isConnected && t.dispatchEvent(new CustomEvent("qresume", {
            bubbles: !0
        }));
    }
    yn() {
        this.vNodeLocate = () => null;
        this.ie.length = 0;
        this.oe.length = 0;
        this.q = () => {};
        const t = this.element;
        t.qContainer = void 0;
        t.qVnodeData = void 0;
        t.qVNodeRefs = void 0;
        t.removeAttribute(We);
        t.ownerDocument.qVNodeData = void 0;
    }
    ce() {
        const t = this.element.ownerDocument;
        const n = t.head;
        const e = t.body.querySelectorAll(Ne);
        const s = e.length;
        if (s) {
            const o = t.createDocumentFragment();
            for (let t = 0; t < s; t++) {
                o.appendChild(e[t]);
            }
            n.appendChild(o);
        }
    }
    bn(t, n) {
        this.oe[t] = n;
    }
    parseQRL(t) {
        const n = Pn(t, this);
        return n;
    }
    handleError(t, n) {
        const e = n && this.resolveContext(n, lc);
        if (!e) {
            throw t;
        }
        e.error = t;
    }
    setContext(t, n, e) {
        let s = this.getHostProp(t, Ie);
        s == null && this.setHostProp(t, Ie, s = []);
        Wi(s, n.id, e, 0, !0);
    }
    resolveContext(t, n) {
        for (;t; ) {
            const e = this.getHostProp(t, Ie);
            if (e != null && Xi(e, n.id, 0)) {
                return Ui(e, n.id, 0);
            }
            t = this.getParentHost(t);
        }
        return;
    }
    getParentHost(t) {
        let n = t.parent;
        for (;n; ) {
            if (yo(n)) {
                if (wo(n, Ee, null) !== null) {
                    return n;
                }
                n = n.parent || n.slotParent;
            } else {
                n = n.parent;
            }
        }
        return null;
    }
    setHostProp(t, n, e) {
        const s = t;
        vo(s, n, e);
    }
    getHostProp(t, n) {
        const e = t;
        let s = null;
        switch (n) {
          case Ke:
          case Ge:
          case Ee:
          case Ie:
          case Ce:
          case or:
            s = this.q;
            break;

          case Ze:
          case sr:
            s = parseInt;
            break;
        }
        return wo(e, n, s);
    }
    ensureProjectionResolved(t) {
        if ((t.flags & 16) === 0) {
            t.flags |= 16;
            const n = t.props;
            if (n) {
                const t = Object.keys(n);
                for (let e = 0; e < t.length; e++) {
                    const s = t[e];
                    if (T(s)) {
                        const t = n[s];
                        if (typeof t == "string") {
                            const e = this.vNodeLocate(t);
                            n[s] = e;
                        }
                    }
                }
            }
        }
    }
    q=t => Qn(t, this.oe);
    getSyncFn(t) {
        const n = this.se[t];
        return n;
    }
    fe(t, n, e, s) {
        if (s) {
            const t = this.getHostProp(e, Me);
            const s = new Set(function o(t) {
                return t?.split(" ") ?? null;
            }(t));
            s.add(n);
            this.setHostProp(e, Me, function r(t) {
                return Array.from(t).join(" ");
            }(s));
        }
        if (this.le == null) {
            this.le = new Set;
            const t = this.document.querySelectorAll(Ae);
            for (let n = 0; n < t.length; n++) {
                const e = t[n];
                this.le.add(e.getAttribute(Re));
            }
        }
        if (!this.le.has(n)) {
            this.le.add(n);
            const e = this.document.createElement("style");
            e.setAttribute(Re, n);
            e.textContent = t;
            this.document.head.appendChild(e);
        }
    }
    ue() {
        const t = {};
        const n = this.element.attributes;
        if (n) {
            for (let e = 0; e < n.length; e++) {
                const s = n[e];
                if (s.name === ur) {
                    continue;
                }
                t[s.name] = s.value;
            }
        }
        this.Vt = {
            containerAttributes: t
        };
    }
}

const ac = _e("localeStore", () => ({
    locale: void 0,
    asyncStore: void 0
}));

if (ue) {
    const t = Su();
    t && (ac.asyncStore || (ac.asyncStore = new t));
}

function te(t) {
    if (ac.asyncStore) {
        const t = ac.asyncStore.getStore();
        if (t) {
            return t;
        }
    }
    if (ac.locale === void 0) {
        const n = dc();
        if (n && n.Ot) {
            return n.Ot;
        }
        if (t !== void 0) {
            return t;
        }
        throw Error("Reading `locale` outside of context.");
    }
    return ac.locale;
}

function ne(t, n) {
    if (ac.asyncStore) {
        return ac.asyncStore.run(t, n);
    }
    const e = ac.locale;
    try {
        ac.locale = t;
        return n();
    } finally {
        ac.locale = e;
    }
}

let hc;

const dc = () => hc;

const pc = () => {
    const t = dc();
    if (!t) {
        throw we(9);
    }
    return t;
};

const $c = () => {
    const t = dc();
    if (!t || t.Ft !== Je) {
        throw we(10);
    }
    return t;
};

function ee(t, n, ...e) {
    return re.call(this, t, n, e);
}

function re(t, n, e) {
    const s = hc;
    try {
        hc = t;
        return n.apply(this, e);
    } finally {
        hc = s;
    }
}

const yc = (t, n) => {
    const e = Gn(n);
    const s = xo(e.rootVNode, n);
    const o = e.Ot;
    o && function r(t) {
        if (ac.asyncStore) {
            ac.asyncStore.enterWith(t);
            return;
        }
        ac.locale = t;
    }(o);
    const i = ie(o, s, t);
    i.m = e;
    return i;
};

function se(t, n, e) {
    const s = {
        k: n,
        Ft: Je,
        Lt: void 0,
        Ot: t,
        m: e,
        Dt: void 0
    };
    return s;
}

function ie(t, n, e) {
    const s = t || (e && pe(e) && "locale" in e ? e.locale : void 0);
    const o = {
        k: n,
        Ft: e,
        Lt: void 0,
        Ot: s,
        m: void 0
    };
    return o;
}

const mc = (t, ...n) => {
    if (typeof t === "function") {
        if (!hc) {
            return t(...n);
        }
        {
            const e = hc.Lt;
            try {
                hc.Lt = void 0;
                return t(...n);
            } finally {
                hc.Lt = e;
            }
        }
    }
    if (xl(t)) {
        return t.untrackedValue;
    }
    return Ll(t);
};

const wc = /*#__PURE__*/ se(void 0, void 0, void 0);

const vc = (t, n, e, s, o) => {
    const r = wc.Lt;
    const i = wc.m;
    try {
        wc.Lt = p(n, e, o);
        wc.m = s;
        return re(wc, t);
    } finally {
        wc.Lt = r;
        wc.m = i;
    }
};

const bc = (t, n, e, s, o) => {
    t instanceof Ms && t.k !== n && n && (t.k = n);
    return vc(() => t.value, n, e, s, o);
};

const gc = () => dc()?.k;

const _c = () => {
    const t = dc();
    if (t) {
        return t.Ft;
    }
};

const Sc = () => {
    const t = dc();
    if (t) {
        return t.m;
    }
};

const kc = t => t;

const Ec = t => t.l || Promise.resolve();

let xc = (t, n, e, s, o) => new qc(t, n, e, s, o);

class qc {
    _t;
    gt;
    ae;
    he;
    m;
    constructor(t, n, e, s, o) {
        this._t = t;
        this.gt = n;
        this.ae = e;
        this.he = s;
        s && this.de(s);
        !o || s || typeof t !== "string" || e || (this.m = o);
        ce && t && le(t, .8);
    }
    get lt() {
        return Ca(this.gt);
    }
    de(t) {
        this.he = t;
        wr(t) && t.then(t => this.he = t, t => {
            console.error(`qrl ${this.gt} failed to load`, t);
            this.he = null;
        });
    }
    pe() {
        if (this.he != null) {
            return this.he;
        }
        if (this._t === "") {
            const t = this.m.te;
            const n = this.m.element?.ownerDocument || document;
            const e = je(n, t);
            return this.he = e[+this.gt];
        }
        ce && this._t && le(this._t, 1);
        const t = this.gt;
        const n = this.ae ? this.ae().then(n => n[t]) : $r().importSymbol(this.m?.element, this._t, t);
        this.de(n);
        return this.he;
    }
}

ce && import.meta.hot && (t => {
    if (!ce || !import.meta.hot) {
        return;
    }
    const n = new Map;
    (() => {
        xc = (e, s, o, r, i) => {
            let c = n.get(s);
            if (!c) {
                c = new t(e, s, o, r, i);
                e !== "" && n.set(s, c);
            }
            return c;
        };
    })();
    const e = (t, n) => {
        const [e, s] = t.split("?", 2);
        if (!s) {
            return `${e}?t=${n}`;
        }
        const o = s.split("&").filter(t => !t.startsWith("t="));
        o.push("t=" + n);
        return `${e}?${o.join("&")}`;
    };
    document.addEventListener("qHmr", t => {
        const s = t.detail.files;
        const o = t.detail.t || document.__hmrT || Date.now();
        let r = !1;
        for (const t of n.values()) {
            const n = t.dev?.file || t._t;
            if (!n || !s.some(t => n.startsWith(t))) {
                continue;
            }
            const i = t._t;
            if (i) {
                t._t = e(i, o);
                r = !0;
            }
            const c = t.ae?.toString();
            if (c) {
                const n = c.replace(/import\((['"])(.+?)\1\)/, (t, n, s) => {
                    const r = e(s, o);
                    return `import(${n}${r}${n})`;
                });
                if (n !== c) {
                    try {
                        t.ae = Function(`return (${n})`)();
                        r = !0;
                    } catch (n) {
                        console.error("Failed to update symbolFn for " + t.gt, n);
                    }
                } else {
                    console.warn(`Couldn't find import() in symbolFn for ${t.gt}, cannot update it for HMR`, c);
                }
            }
            if (r) {
                t.he = void 0;
                document.__hmrDone = document.__hmrT;
                if (t.qrls) {
                    for (const n of t.qrls) {
                        const e = n.deref();
                        e ? e.resolved && (e.resolved = void 0) : t.qrls.delete(n);
                    }
                }
            }
        }
    });
})(qc);

const Tc = Symbol();

const Pc = t => t?.[Tc] ?? t;

class Rc {
    $e;
    resolved=void 0;
    At;
    m;
    constructor(t, n, e) {
        this.$e = t;
        if (n) {
            this.At = n;
            typeof n === "string" && (this.m = e);
        }
        t.he == null || typeof this.At === "string" || wr(t.he) || (this.resolved = Fc(this, t.he));
    }
}

const Ac = function(t, ...n) {
    const e = Pc(this);
    if (e.resolved) {
        return e.resolved.apply(t, n);
    }
    const s = dc();
    return Nc.call(e, s?.m).then(() => re.call(t, s, e.resolved, n));
};

const Nc = async function(t) {
    const n = Pc(this);
    return br(Lc(n, t), () => n.resolved);
};

const Mc = Object.create(Function.prototype, {
    resolved: {
        get() {
            return this[Tc].resolved;
        },
        set(t) {
            this[Tc].resolved = t;
        }
    },
    At: {
        get() {
            return this[Tc].At;
        },
        set(t) {
            this[Tc].At = t;
        }
    },
    m: {
        get() {
            return this[Tc].m;
        },
        set(t) {
            this[Tc].m = t;
        }
    },
    $e: {
        get() {
            return this[Tc].$e;
        }
    },
    _t: {
        get() {
            return this[Tc].$e._t;
        }
    },
    gt: {
        get() {
            return this[Tc].$e.gt;
        }
    },
    lt: {
        get() {
            return this[Tc].$e.lt;
        }
    },
    dev: {
        get() {
            return this[Tc].$e.dev;
        }
    },
    ye: {
        value: Ac
    },
    w: {
        value: function(t) {
            const n = Pc(this);
            const e = new Rc(n.$e, t, n.At ? n.m : void 0);
            return Vc(e);
        }
    },
    s: {
        value: function(t) {
            const n = Pc(this);
            n.$e.de(t);
            n.resolved = Fc(n, t);
        }
    },
    resolve: {
        value: Nc
    },
    getSymbol: {
        value: function() {
            return Pc(this).$e.gt;
        }
    },
    getHash: {
        value: function() {
            return Pc(this).$e.lt;
        }
    },
    getCaptured: {
        value: function() {
            const t = Pc(this);
            Oc(t);
            return t.At;
        }
    },
    getFn: {
        value: function(t, n) {
            const e = Pc(this);
            const s = (...o) => {
                if (!e.resolved) {
                    return Nc.call(e).then(() => s(...o));
                }
                if (n && n() === !1) {
                    return;
                }
                return re(t, e.resolved, o);
            };
            return s;
        }
    }
});

const Ic = _e("qrlCaptures", () => ({
    _: null
}));

const Cc = t => {
    Ic._ = t;
};

const jc = (t, n) => {
    const e = [];
    const s = n.split(" ");
    for (let n = 0; n < s.length; n++) {
        const o = s[n];
        e.push(t.q(o));
    }
    return e;
};

const Oc = t => {
    let n = t.At;
    const e = t.m;
    if (typeof n === "string") {
        if (!e) {
            throw we(13);
        }
        const s = Lu.p;
        n = t.At = jc(e, n);
        Cc(n);
        if (Lu.p !== s) {
            return Lu.p;
        }
    } else {
        Cc(n ?? null);
    }
};

const Fc = (t, n) => {
    if (typeof n !== "function" || !t.At) {
        return n;
    }
    return function e(...s) {
        Oc(t);
        return n.apply(this, s);
    };
};

const Lc = (t, n) => {
    const e = t.$e;
    const s = typeof t.At === "string";
    s && !t.m && (t.m = n || dc()?.m);
    if (t.resolved) {
        return;
    }
    const o = zc();
    const r = dc();
    const i = e.pe();
    const c = br(i, n => {
        t.resolved = Fc(t, n);
    });
    if (c) {
        const t = e.gt;
        Uc(t, r?.k instanceof Or ? r?.k.node : void 0, o);
    }
    const l = s && t.m && Oc(t);
    if (l) {
        return l.then(() => c);
    }
    return c;
};

const Dc = (t, n, e, s, o, r) => {
    const i = xc(t, n, s, e, r);
    const c = new Rc(i, o, r);
    return Vc(c);
};

const Vc = t => {
    const n = async function(...t) {
        return Ac.call(n, this, ...t);
    };
    n[Tc] = t;
    Object.setPrototypeOf(n, Mc);
    return n;
};

const Wc = /*#__PURE__*/ new Set;

const Uc = (t, n, e) => {
    if (!Wc.has(t)) {
        Wc.add(t);
        Xc("qsymbol", {
            symbol: t,
            element: n,
            reqTime: e
        });
    }
};

const Xc = (t, n) => {
    Oa() || typeof document !== "object" || document.dispatchEvent(new CustomEvent(t, {
        bubbles: !1,
        detail: n
    }));
};

const zc = () => {
    if (Oa()) {
        return 0;
    }
    if (typeof performance === "object") {
        return performance.now();
    }
    return 0;
};

let Bc = 0;

const Hc = t => Dc(null, "s" + Bc++, t, null, null);

const Jc = Hc;

const Qc = t => t;

const Yc = t => Dc("", Se, t, null, null);

const Gc = (t, n) => {
    n === void 0 && (n = "" + t);
    t.serialized = n;
    return Dc("", Se, t, null, null);
};

const Kc = t => {
    function n(n, e, s = 0) {
        const o = t.lt.slice(0, 4);
        const r = o + ":" + (e || "");
        const i = () => {};
        i[Zc] = [ t ];
        return Qs(i, n, null, n.children, s, r);
    }
    n[Zc] = [ t ];
    return n;
};

const Zc = Symbol();

const tf = t => typeof t == "function" && t[Zc] !== void 0;

const nf = t => Kc(Jc(t));

const ef = ws(Qc);

const rf = () => {
    const t = globalThis.__QWIK_MANIFEST__;
    if (!globalThis.__QWIK_MANIFEST__) {
        throw Error("Client manifest is not available. It should have been automatically injected during the build process. Make sure that @qwik.dev/core is internal to the build.");
    }
    return t;
};

const sf = async (t, n, e = {}) => {
    if ((t => t.nodeType === 9)(t)) {
        let n = t.firstChild;
        for (;n && !yr(n); ) {
            n = n.nextSibling;
        }
        t = n;
    }
    t.setAttribute(We, "resumed");
    const s = Gn(t);
    s.Vt = e.serverData || {};
    const o = s.rootVNode;
    vo(o, Ur, n);
    ln(s, o, 2);
    await s.l;
    return {
        cleanup: () => {
            qt(s, [], s.rootVNode);
        }
    };
};

const of = (t, n) => {
    const {val: e, set: s, iCtx: o} = Ci();
    if (e != null) {
        return e;
    }
    const r = me(t) ? ee(void 0, t) : t;
    if (n?.reactive === !1) {
        s(r);
        return r;
    }
    {
        const t = o.m;
        const e = n?.deep ?? !0;
        const i = e ? 1 : 0;
        const c = Vl(r, i, t);
        s(c);
        return c;
    }
};

const lf = () => {
    const {val: t, set: n, iCtx: e} = Ci();
    if (t != null) {
        return t;
    }
    const s = e.m.ne || "";
    const o = s ? vi(s).substring(0, 3) : "";
    const r = e.m.getHostProp(e.k, Ee);
    const i = r?.getHash().substring(0, 3) || "";
    const c = (t => (t => t.toString(36))(t.Zn++))(e.m) || "";
    let l = `${o}${i}${c}`;
    let u = l.charCodeAt(0);
    if (u >= 48 && u <= 57) {
        u += 17;
        l = String.fromCharCode(u) + l.substring(1);
    }
    return n(l);
};

function oe(t, n) {
    const e = dc();
    return e?.m?.Vt[t] ?? n;
}

const uf = /*#__PURE__*/ new Map;

const cf = (t, n) => {
    let e = uf.get(n);
    e || uf.set(n, e = ff(t, n));
    return e;
};

const ff = (t, n) => {
    const e = t.length;
    const s = [];
    const o = [];
    let r = 0;
    let i = r;
    let c = $f;
    let l = 0;
    for (;r < e; ) {
        const n = r;
        let e = t.charCodeAt(r++);
        if (e === Wf) {
            r++;
            e = Lf;
        }
        const s = Yf[c];
        for (let d = 0; d < s.length; d++) {
            const p = s[d];
            const [$, y, m] = p;
            if (($ === l || $ === kf || $ === Ef && af(l) || $ === qf && pf(l)) && (y === e || y === kf || y === Ef && af(e) || y === xf && !af(e) && e !== Cf || y === qf && pf(e)) && (p.length == 3 || a(p))) {
                p.length > 3 && (e = t.charCodeAt(r - 1));
                if (m === _f || m == Sf) {
                    if (m === Sf) {
                        if (c !== yf || h()) {
                            if (!hf(e)) {
                                const t = y == xf ? 1 : y == Mf ? 2 : 0;
                                f(r - t);
                            }
                        } else {
                            hf(e) ? u(r - 2) : f(r - 2);
                            i++;
                        }
                    }
                    if (y === xf) {
                        r--;
                        e = l;
                    }
                    do {
                        c = o.pop() || $f;
                        if (c === mf) {
                            u(r - 1);
                            i++;
                        }
                    } while (df(c));
                } else {
                    o.push(c);
                    if (c === mf && m === $f) {
                        u(r - 8);
                        i = r;
                    } else {
                        m === wf && f(n);
                    }
                    c = m;
                }
                break;
            }
        }
        l = e;
    }
    u(r);
    return s.join("");
    function u(n) {
        s.push(t.substring(i, n));
        i = n;
    }
    function f(t) {
        if (c === mf || h()) {
            return;
        }
        u(t);
        s.push(".", qe, n);
    }
    function a(n) {
        let e = 0;
        if (t.charCodeAt(r) === If) {
            for (let n = 1; n < 10; n++) {
                if (t.charCodeAt(r + n) === If) {
                    e = n + 1;
                    break;
                }
            }
        }
        t: for (let s = 3; s < n.length; s++) {
            const o = n[s];
            for (let n = 0; n < o.length; n++) {
                if ((t.charCodeAt(r + n + e) | Xf) !== o.charCodeAt(n)) {
                    continue t;
                }
            }
            r += o.length + e;
            return !0;
        }
        return !1;
    }
    function h() {
        return o.indexOf(mf) !== -1 || o.indexOf(vf) !== -1;
    }
};

const af = t => t >= jf && t <= Of || t >= Lf && t <= Df || t >= zf && t <= Bf || t >= 128 || t === Uf || t === If;

const hf = t => t === Ff || t === Cf || t === Vf || t === Nf || af(t);

const df = t => t === bf || t === vf || t === gf || t === mf;

const pf = t => t === Af || t === Tf || t === Pf || t === Rf;

const $f = 0;

const yf = 2;

const mf = 5;

const wf = 6;

const vf = 10;

const bf = 11;

const gf = 12;

const _f = 17;

const Sf = 18;

const kf = 0;

const Ef = 1;

const xf = 2;

const qf = 3;

const Tf = 9;

const Pf = 10;

const Rf = 13;

const Af = 32;

const Nf = 35;

const Mf = 41;

const If = 45;

const Cf = 46;

const jf = 48;

const Of = 57;

const Ff = 58;

const Lf = 65;

const Df = 90;

const Vf = 91;

const Wf = 92;

const Uf = 95;

const Xf = 32;

const zf = 97;

const Bf = 122;

const Hf = 123;

const Jf = 125;

const Qf = /*@__PURE__*/ (() => [ [ kf, 39, 14 ], [ kf, 34, 15 ], [ kf, 47, 16, "*" ] ])();

const Yf = /*@__PURE__*/ (() => [ [ [ kf, 42, yf ], [ kf, Vf, 7 ], [ kf, Ff, wf, ":", "before", "after", "first-letter", "first-line" ], [ kf, Ff, mf, "global" ], [ kf, Ff, 3, "has", "host-context", "not", "where", "is", "matches", "any" ], [ kf, Ff, 4 ], [ kf, Ef, 1 ], [ kf, Cf, 1 ], [ kf, Nf, 1 ], [ kf, 64, vf, "keyframe" ], [ kf, 64, bf, "media", "supports", "container" ], [ kf, 64, gf ], [ kf, Hf, 13 ], [ 47, 42, 16 ], [ kf, 59, _f ], [ kf, Jf, _f ], [ kf, Mf, _f ], ...Qf ], [ [ kf, xf, Sf ] ], [ [ kf, xf, Sf ] ], [ [ kf, 40, $f ], [ kf, xf, Sf ] ], [ [ kf, 40, 8 ], [ kf, xf, Sf ] ], [ [ kf, 40, $f ], [ kf, xf, _f ] ], [ [ kf, xf, _f ] ], [ [ kf, 93, Sf ], [ kf, 39, 14 ], [ kf, 34, 15 ] ], [ [ kf, Mf, _f ], ...Qf ], [ [ kf, Jf, _f ], ...Qf ], [ [ kf, Jf, _f ], [ qf, Ef, 1 ], [ kf, Ff, mf, "global" ], [ kf, Hf, 13 ], ...Qf ], [ [ kf, Hf, $f ], [ kf, 59, _f ], ...Qf ], [ [ kf, 59, _f ], [ kf, Hf, 9 ], ...Qf ], [ [ kf, Jf, _f ], [ kf, Hf, 13 ], [ kf, 40, 8 ], ...Qf ], [ [ kf, 39, _f ] ], [ [ kf, 34, _f ] ], [ [ 42, 47, _f ] ] ])();

const Gf = t => ({
    styleId: na(t, t => t, !1)
});

const Kf = /*#__PURE__*/ ws(Gf);

const Zf = t => ({
    scopeId: qe + na(t, cf, !0)
});

const ta = /*#__PURE__*/ ws(Zf);

const na = (t, n, e) => {
    let {val: s, set: o, iCtx: r, i} = Ci();
    if (s) {
        return s;
    }
    const c = ((t, n) => `${vi(t.lt)}-${n}`)(t, i);
    const l = r.k;
    o(c);
    if (!t.resolved) {
        throw t.resolve().then(t => r.m.fe(n(t, c), c, l, e));
    }
    r.m.fe(n(t.resolved, c), c, l, e);
    return c;
};

const ea = (t, n) => {
    t.resolve();
    return bs(t, n);
};

const ra = (t, n) => Fi(ea, t, n);

const sa = ws(ra);

const ia = t => {
    t.resolve();
    return _s(t);
};

const oa = t => Fi(ia, t);

const la = ws(oa);

const ua = (t, n) => {
    const {val: e, set: s, i: o, iCtx: r} = Ci();
    const i = n?.strategy ?? "intersection-observer";
    if (e) {
        if (!(e.h & 32) && !Oa()) {
            e.h |= 32;
            ca(e, i);
        }
        return;
    }
    let c;
    if (Oa()) {
        c = 1;
    } else {
        c = 5;
        t.resolve();
        ln(r.m, r.k, 1);
    }
    const l = new Sl(c, o, r.k, t, void 0, null);
    s(l);
    ca(l, i);
};

const ca = (t, n) => {
    n === "intersection-observer" ? Nu("qvisible", fa(t)) : n === "document-ready" ? Mu("qinit", fa(t)) : n === "document-idle" && Mu("qidle", fa(t));
};

const fa = t => Dc(null, "_task", gn, null, [ t ]);

const aa = ws(Pu);

const ha = /*#__PURE__*/ ws(gl);

const da = /*#__PURE__*/ ws(ua);

const pa = (t, n) => {
    t.resolve();
    return gs(t, n);
};

const $a = (t, n) => Fi(pa, t, n);

const ya = ws($a);

const ma = () => {
    const t = of({
        error: void 0
    });
    sc(lc, t);
    return t;
};

const wa = async ({track: t}) => {
    const n = Ic._[0];
    t(() => n.items);
    const e = dc();
    const s = e.k;
    const o = e.m;
    ln(o, s, 128);
    const r = ue;
    r && await o.l;
};

const va = t => {
    if (!__EXPERIMENTAL__.each) {
        throw Error('Each is experimental and must be enabled with `experimental: ["each"]` in the `qwikVite` plugin.');
    }
    gl(/*#__PURE__*/ $u(wa, "_eaT", [ t ]));
    return li;
};

const ba = /*#__PURE__*/ Kc(
/*#__PURE__*/ $u(va, "_eaC"));

const ga = /*#__PURE__*/ rc("qk-reveal");

const _a = t => ({
    order: t.order ?? "parallel",
    collapsed: t.collapsed === !0,
    items: [],
    version: Ss(0)
});

const Sa = () => {
    const t = Ic._[0];
    if (t === null) {
        return !0;
    }
    const n = t.reveal;
    const e = t.item;
    const s = n.items;
    if (n.version.value < 0) {
        return !1;
    }
    switch (n.order) {
      case "together":
        for (let t = 0; t < s.length; t++) {
            if (s[t].boundary.pending.untrackedValue > 0) {
                return !1;
            }
        }
        return !0;

      case "sequential":
        for (let t = 0; t < s.length; t++) {
            const n = s[t];
            if (n === e) {
                return !0;
            }
            if (n.boundary.pending.untrackedValue > 0) {
                return !1;
            }
        }
        return !0;

      case "reverse":
        for (let t = s.length - 1; t >= 0; t--) {
            const n = s[t];
            if (n === e) {
                return !0;
            }
            if (n.boundary.pending.untrackedValue > 0) {
                return !1;
            }
        }
        return !0;

      default:
        return !0;
    }
};

const ka = ({cleanup: t}) => {
    const n = Ic._[0];
    t(() => {
        if (!ce) {
            return;
        }
        const t = n.reveal.items;
        const e = t.indexOf(n.item);
        if (e !== -1) {
            t.splice(e, 1);
            n.reveal.version.value++;
        }
    });
};

const Ea = t => {
    if (!__EXPERIMENTAL__.suspense) {
        throw Error('Reveal is experimental and must be enabled with `experimental: ["suspense"]` in the `qwikVite` plugin.');
    }
    const n = Fi(_a, t);
    sc(ga, n);
    /*#__PURE__*/
    return Js(oi, null, null, null, 0, "u7_0");
};

const xa = /*#__PURE__*/ Kc(
/*#__PURE__*/ $u(Ea, "_reC"));

const qa = (t, n, e, s) => ({
    display: n.value !== "fallback" || t.fallback == null || t.fallback === !1 || e !== null && !e.value && s.reveal.collapsed ? "none" : "contents"
});

const Ta = (t, n, e) => ({
    display: e !== null && !e.value || n.value !== "content" && !t.showStale ? "none" : "contents"
});

const Pa = ({track: t, cleanup: n}) => {
    const e = Ic._[0], s = Ic._[1], o = Ic._[2], r = Ic._[3];
    const i = t(e.pending);
    const c = ce;
    r !== null && c && r.reveal.version.value++;
    if (!c || i === 0) {
        o.value = "content";
        return;
    }
    const l = setTimeout(() => {
        e.pending.value > 0 && (o.value = "fallback");
    }, s.delay ?? 0);
    n(() => clearTimeout(l));
};

const Ra = t => {
    if (!__EXPERIMENTAL__.suspense) {
        throw Error('Suspense is experimental and must be enabled with `experimental: ["suspense"]` in the `qwikVite` plugin.');
    }
    const n = Oi("content");
    const e = (() => {
        if (!__EXPERIMENTAL__.suspense) {
            throw Error('useCursorBoundary is experimental and must be enabled with `experimental: ["suspense"]` in the `qwikVite` plugin.');
        }
        return Fi(Li);
    })();
    const s = (t => {
        const n = ic(ga, null);
        const e = Fi(() => {
            if (n === null) {
                return null;
            }
            const e = {
                boundary: t
            };
            n.items.push(e);
            return {
                reveal: n,
                item: e
            };
        });
        e !== null && gl(/*#__PURE__*/ $u(ka, "_reT", [ e ]), {
            deferUpdates: !1
        });
        return e;
    })(e);
    const o = ra(
    /*#__PURE__*/ $u(Sa, "_reR", [ s ]));
    gl(
    /*#__PURE__*/ $u(Pa, "_suT", [ e, t, n, s ]));
    /*#__PURE__*/
    return Js(ri, null, null, [ 
    /*#__PURE__*/ Js("div", {
        style: ku(qa, [ t, n, o, s ], '{display:p1.value==="fallback"&&p0.fallback!=null&&p0.fallback!==false&&(p2===null||p2.value||!p3.reveal.collapsed)?"contents":"none"}')
    }, null, Rs(t, "fallback"), 1, null), 
    /*#__PURE__*/ Js("div", null, {
        style: ku(Ta, [ t, n, o ], '{display:(p2===null||p2.value)&&(p1.value==="content"||p0.showStale)?"contents":"none"}')
    }, 
    /*#__PURE__*/ Js(oi, {
        [or]: e
    }, null, null, 3, "u6_0"), 1, null) ], 1, "u6_1");
};

const Aa = /*#__PURE__*/ Kc(
/*#__PURE__*/ $u(Ra, "_suC"));

const Na = t => {
    const n = import.meta.env?.BASE_URL || "/";
    const e = {
        path: "qwik-prefetch-service-worker.js",
        ...t
    };
    e.path = t?.path?.startsWith?.("/") ? t.path : n + e.path;
    let s = Ma.replace('"_URL_"', JSON.stringify(e.path.split("/").pop()));
    s = s.replaceAll(/\s\s+/gm, "");
    const o = {
        dangerouslySetInnerHTML: "(" + s + ")(navigator.serviceWorker);",
        nonce: e.nonce
    };
    return Js("script", null, o, null, 0, "prefetch-service-worker");
};

const Ma = /*#__PURE__*/ "" + (t => {
    "getRegistrations" in t && t.getRegistrations().then(t => {
        for (let n = 0; n < t.length; n++) {
            const e = t[n];
            e.active && e.active.scriptURL.endsWith("_URL_") && e.unregister().catch(console.error);
        }
    });
    "caches" in window && caches.keys().then(t => {
        const n = t.find(t => t.startsWith("QwikBundles"));
        n && caches.delete(n).catch(console.error);
    }).catch(console.error);
});

const Ia = () => null;

export { Hc as $, ba as Each, ri as Fragment, nc as NoSerializeSymbol, Ia as PrefetchGraph, Na as PrefetchServiceWorker, si as RenderOnce, Ru as Resource, xa as Reveal, ci as SSRComment, ui as SSRRaw, ai as SSRStream, fi as SSRStreamBlock, ec as SerializerSymbol, li as SkipRender, oi as Slot, Aa as Suspense, es as _CONST_PROPS, fc as _DomContainer, _r as _EFFECT_BACK_REF, us as _EMPTY_ARRAY, cs as _EMPTY_OBJ, os as _IMMUTABLE, Eu as _SharedContainer, Is as _SubscriptionData, ls as _UNINITIALIZED, rs as _VAR_PROPS, Dn as _addProjection, Ic as _capturesObj, m as _chk, Yn as _createDeserializeContainer, Dc as _createQRL, Jn as _deserialize, uu as _dumpState, va as _eaC, wa as _eaT, sn as _executeSsrChores, ku as _fnSignal, Su as _getAsyncLocalStorage, ys as _getConstProps, Sc as _getContextContainer, _c as _getContextEvent, gc as _getContextHostElement, Gn as _getDomContainer, Zn as _getQContainerElement, $s as _getVarProps, Fl as _hasStoreEffects, Ou as _hmr, Ls as _isJSXNode, Dl as _isStore, Mn as _isStringifiable, kl as _isTask, kc as _jsxBranch, Ys as _jsxC, Ks as _jsxQ, Gs as _jsxS, Js as _jsxSorted, Qs as _jsxSplit, Vi as _mapApp_findIndx, Ui as _mapArray_get, Wi as _mapArray_set, yu as _noopQrl, mu as _noopQrlDEV, An as _preprocessState, Gc as _qrlSync, qn as _qrlToString, wu as _qrlWithChunk, vu as _qrlWithChunkDEV, Ea as _reC, Sa as _reR, ka as _reT, _u as _regSymbol, Un as _removeProjection, w as _res, oc as _resolveContextWithoutSequentialScope, $i as _restProps, Tu as _rsc, O as _run, Hn as _serialize, On as _setEvent, Vn as _setProjectionTarget, Ra as _suC, Pa as _suT, gn as _task, Wn as _updateProjectionProps, Ln as _useHmr, y as _val, Qu as _verifySerializable, _o as _vnode_ensureElementInflated, al as _vnode_getAttrKeys, Xo as _vnode_getElementName, Ho as _vnode_getFirstChild, wo as _vnode_getProp, Po as _vnode_getVNodeForChildNode, Lo as _vnode_insertBefore, ao as _vnode_isElementVNode, po as _vnode_isMaterialized, $o as _vnode_isTextVNode, yo as _vnode_isVirtualVNode, co as _vnode_newVirtual, Wo as _vnode_remove, vo as _vnode_setProp, pn as _vnode_toString, Ec as _waitUntilRendered, Cn as _walkJSX, Rs as _wrapProp, Ns as _wrapSignal, nf as component$, Kc as componentQrl, Es as createAsync$, gs as createAsyncQrl, ks as createComputed$, bs as createComputedQrl, rc as createContextId, v as createElement, xs as createSerializer$, _s as createSerializerQrl, Ss as createSignal, ef as event$, Qc as eventQrl, Ol as forceStoreEffects, rf as getClientManifest, Gn as getDomContainer, te as getLocale, $r as getPlatform, v as h, ws as implicit$FirstArg, $u as inlinedQrl, gu as inlinedQrlDEV, fe as isDev, xl as isSignal, ti as jsx, ni as jsxDEV, ei as jsxs, tc as noSerialize, pu as qrl, bu as qrlDEV, sf as render, pr as setPlatform, Yc as sync$, mc as untrack, Ll as unwrapStore, ya as useAsync$, $a as useAsyncQrl, sa as useComputed$, ra as useComputedQrl, Fi as useConstant, ic as useContext, sc as useContextProvider, ma as useErrorBoundary, lf as useId, qu as useLexicalScope, Nu as useOn, Mu as useOnDocument, Iu as useOnWindow, aa as useResource$, Pu as useResourceQrl, la as useSerializer$, oa as useSerializerQrl, oe as useServerData, Oi as useSignal, of as useStore, Kf as useStyles$, Gf as useStylesQrl, ta as useStylesScoped$, Zf as useStylesScopedQrl, ha as useTask$, gl as useTaskQrl, da as useVisibleTask$, ua as useVisibleTaskQrl, ve as version, ne as withLocale };
